{
  "material.outdated.title": "Ce document a été mis à jour",
  "material.outdated.description": "Veuillez copier vos réponses non envoyées, puis actualiser cette page dans votre navigateur pour continuer.",
  "material.autosave.saved": "Enregistré",
  "material.autosave.description": "Les modifications sont enregistrées automatiquement.",
  "material.autosave.saving": "Enregistrement …",
  "material.autosave.failed": "Non enregistré",
  "ai.assistant.sharing.title": "Partager le matériel",
  "ai.assistant.sharing.recipients": "Partager avec",
  "ai.assistant.sharing.hide.title": "Masquer le matériel",
  "ai.assistant.sharing.hide.recipients": "Masquer pour",
  "ai.assistant.sharing.hide.confirm": "Masquer",
  "ai.assistant.sharing.hide.confirmed": "Masqué",
  "ai.assistant.sharing.all_students": "Tous les élèves de ce cours",
  "ai.assistant.sharing.pending": "La visibilité de ces supports ne change qu’après ta confirmation.",
  "ai.assistant.sharing.confirmed": "Partagé",
  "ai.assistant.sharing.discarded": "Modification annulée",
  "ai.assistant.sharing.error": "La visibilité n’a pas pu être mise à jour. Réessaie.",
  "ai.assistant.composer.attachment_size_limit": "La taille de chaque fichier ne doit pas dépasser {{size}} Mio. Choisis un fichier plus petit.",
  "course_students.access_cards.login_instruction": "Ouvre {{url}} et saisis ton code.",
  "course_students.access_cards.course_scope_hint": "Ces codes donnent aux élèves accès à tous les supports partagés dans le cours « {{courseName}} ».",
  "ai.assistant.student_note.loading": "Chargement de la documentation …",
  "ai.assistant.student_note.discarded": "Ce brouillon a été supprimé ou n’est plus disponible.",
  "ai.assistant.student_note.student": "Élève",
  "ai.assistant.student_note.edit": "Modifier la documentation ou l’élève",
  "ai.assistant.student_note.discard": "Supprimer le brouillon",
  "ai.assistant.student_note.open_student": "Ouvrir la fiche de l’élève",
  "ai.assistant.student_note.error": "La documentation n’a pas pu être chargée ou mise à jour. Réessaie.",
  "ai.assistant.student_note.retry": "Réessayer",
  "ai.assistant.student_privacy.protected": "Protégé",
  "ai.assistant.student_privacy.hint": "Le nom est automatiquement remplacé par un pseudonyme aléatoire",
  "upgrade.plan.school_dpa_only": "AVV signé",
  "chatbot.context.add_file": "Fichier",
  "chatbot.context.add_link": "Lien",
  "auth.signup_v2.continue_with_provider": "Continuer avec {{provider}}",
  "auth.signup_v2.marketing_title": "La plateforme pédagogique\nqui réfléchit avec vous.",
  "auth.signup_v2.marketing_description": "Planification, supports, devoirs et documentation au même endroit – reliés par une assistance IA qui travaille à vos côtés et concrétise vos idées.",
  "auth.signup_v2.start_free": "Commencer gratuitement",
  "integration.google.description": "Connecte-toi à Teachino avec ton compte Google.",
  "integration.authenticate_google.description": "Connecte-toi à Teachino avec ton compte Google.",
  "onboarding.iam_banner.title": "Activez votre licence Teachino gratuite avec IAM",
  "onboarding.iam_banner.description": "WebUntis est déjà connecté. Connectez-vous avec votre compte IAM (CGIE) pour terminer la configuration et activer votre licence gratuite.",
  "onboarding.iam_banner.connect": "Se connecter avec IAM",
  "onboarding.webuntis_banner.title": "Connectez votre emploi du temps pour importer vos cours depuis WebUntis",
  "onboarding.webuntis_banner.step_open": "Ouvrez WebUntis dans un nouvel onglet, connectez-vous et sélectionnez « Teachino » dans le menu principal. Si cette option n’apparaît pas, demandez à votre administration de l’activer.",
  "onboarding.webuntis_banner.step_connect": "Confirmez la connexion à votre compte Teachino.",
  "onboarding.webuntis_banner.step_ready": "Vos cours, votre emploi du temps et vos élèves WebUntis apparaîtront ensuite ici.",
  "onboarding.webuntis_banner.tutorial": "Consulter le guide complet",
  "onboarding.webuntis_banner.dismiss": "Masquer",
  "integration.authenticate_eduplaces.description": "Connecte-toi à Teachino avec Eduplaces et importe les groupes et les élèves partagés dans tes cours.",
  "integration.eduplaces.description": "Connecte Teachino à Eduplaces pour utiliser l'authentification unique et importer des cours et des élèves.",
  "generic_prompt": "Indication",
  "timetable.course_first_banner.feedback": "Nous attendons vos retours : bonjour@teachino.io",
  "integration.authenticate_europathek.description": "La connexion de Teachino avec l'EUROPATHEK permet l'inscription automatique sur Teachino.",
  "integration.europathek.description": "Pour les enseignants : Connectez Teachino avec l'EUROPATHEK.",
  "feature_course.onboarding.progress.aria_label": "Progression de l'intégration",
  "feature_course.onboarding.step_label.country": "Pays",
  "feature_course.onboarding.step_label.school_type": "Type d'école",
  "feature_course.onboarding.step_label.subject": "Sujet",
  "feature_course.onboarding.step_label.class_level": "Classe",
  "feature_course.onboarding.step_label.summary": "Résumé",
  "feature_course.onboarding.step_label.unknown": "Inconnu",
  "feature_course.onboarding.country.title": "Bienvenue sur Teachino",
  "feature_course.onboarding.country.description": "Commençons par quelques questions pour adapter Teachino à votre quotidien scolaire.",
  "feature_course.onboarding.country.other_option": "Autre pays",
  "feature_course.onboarding.country.other_input_label": "Pays",
  "feature_course.onboarding.country.other_placeholder": "Entrez votre pays",
  "feature_course.onboarding.state.title": "Région",
  "feature_course.onboarding.state.other_option": "Autre région",
  "feature_course.onboarding.state.other_input_label": "Région",
  "feature_course.onboarding.state.other_placeholder": "Entrez votre région",
  "feature_course.onboarding.school_type.title": "Quel type d'école ?",
  "feature_course.onboarding.school_type.description": "L'IA adapte les résultats à votre école",
  "feature_course.onboarding.school_type.other_option": "Autre type d'école",
  "feature_course.onboarding.school_type.other_input_label": "Type d'école",
  "feature_course.onboarding.school_type.other_placeholder": "Entrez le type d'école",
  "feature_course.onboarding.subject.title": "Avec quel sujet voulez-vous commencer ?",
  "feature_course.onboarding.subject.description": "Vous pouvez ajouter d'autres sujets plus tard.",
  "feature_course.onboarding.subject_group.languages": "Langues",
  "feature_course.onboarding.subject_group.natural_sciences": "Sciences naturelles",
  "feature_course.onboarding.subject_group.social_studies": "Études sociales",
  "feature_course.onboarding.subject_group.vocational": "Professionnel",
  "feature_course.onboarding.subject_group.mandatory": "Obligatoire",
  "feature_course.onboarding.subject_group.other": "Autres sujets",
  "feature_course.onboarding.subject.other_option": "Autre sujet",
  "feature_course.onboarding.subject.other_placeholder": "Entrez un sujet",
  "feature_course.onboarding.subject.other_label": "Saisir le sujet",
  "feature_course.onboarding.class_level.title": "Dans quelle classe enseignez-vous {{subject}} ?",
  "feature_course.onboarding.class_level.description": "Vous pouvez ajouter d'autres classes plus tard.",
  "feature_course.onboarding.class_level.other_option": "Autre classe",
  "feature_course.onboarding.class_level.other_input_label": "Classe",
  "feature_course.onboarding.class_level.other_placeholder": "Entrez la classe",
  "feature_course.onboarding.summary.title": "Presque terminé!",
  "feature_course.onboarding.summary.description": "Vérifiez et ajustez votre course",
  "feature_course.onboarding.summary.more_courses_hint": "Vous pourrez créer d’autres cours à tout moment par la suite.",
  "feature_course.onboarding.summary.course_name_label": "Nom de la course",
  "feature_course.onboarding.summary.class_name_label": "Classe",
  "feature_course.onboarding.summary.class_name_label_example": "Classe (p. ex. {{example}})",
  "feature_course.onboarding.summary.subject_name_label": "Matière",
  "feature_course.onboarding.summary.course_name_preview": "Le nom de votre cours",
  "feature_course.onboarding.summary.color_label": "Couleur",
  "feature_course.onboarding.fallback.step": "Étape {{step}} : {{label}}",
  "feature_course.onboarding.fallback.not_implemented": "Cette étape n’est pas encore implémentée.",
  "feature_course.onboarding.fallback.content_area": "Zone de contenu",
  "feature_course.onboarding.debug.title": "Informations de débogage",
  "feature_course.onboarding.debug.no_selections": "Aucune sélection pour le moment.",
  "feature_course.onboarding.debug.toggle": "Afficher le débogage",
  "feature_course.onboarding.action.create_course": "Créer une course",
  "feature_course.onboarding.integration.action.import_courses": "Importer les cours",
  "feature_course.onboarding.integration.connecting.title": "Importation de vos cours …",
  "feature_course.onboarding.integration.connecting.progress": "{{done}} cours sur {{total}} traités",
  "feature_course.onboarding.integration.partial_error": "Certains cours n'ont pas pu être connectés automatiquement. Vous pouvez les connecter à tout moment depuis la page des cours.",
  "feature_course.onboarding.common.other": "Autres",
  "feature_course.onboarding.common.type_own_value": "Entrez votre propre valeur",
  "editor.image_selector.libraries.search": "Rechercher dans le manuel",
  "material.block_menu.listening": "Texte à écouter",
  "material.tab_share_preview": "Aperçu & Distribution",
  "material.share.visibility_hint": "Les écoliers voient le matériel seulement après l'avoir débloqué avec l'œil.",
  "material.editor.multiple_choice.validation.min_answers": "Veuillez fournir au moins deux réponses.",
  "material.editor.multiple_choice.validation.correct_answer": "Veuillez marquer au moins une réponse correcte.",
  "material.editor.multiple_choice.feedback.correct": "Super ! Tout est correct.",
  "material.editor.multiple_choice.feedback.partially": "Partiellement correct. Vérifiez les sélections et réessayez.",
  "material.editor.multiple_choice.feedback.incorrect": "Pas encore correct. Vérifiez les sélections et réessayez.",
  "material.editor.multiple_choice.state.correct_selected": "Correctement sélectionné",
  "material.editor.multiple_choice.state.incorrect_selected": "Sélectionné incorrectement",
  "material.editor.multiple_choice.state.missed_correct": "Bonne réponse non sélectionnée",
  "material.editor.listening.badge": "Texte à écouter",
  "material.editor.listening.placeholder": "Saisissez le texte à lire",
  "material.editor.listening.edit_open": "Modifier le texte",
  "material.editor.listening.edit_close": "Fermer l'édition du texte",
  "material.editor.listening.generating": "Création de l'audio...",
  "material.editor.listening.empty_state": "Saisissez un texte pour créer l'audio.",
  "material.editor.listening.audio_unavailable": "Audio non disponible",
  "material.editor.listening.listen": "Écouter",
  "material.editor.listening.stop": "Arrêter",
  "material.editor.listening.generation_failed": "Impossible de créer l'audio.",
  "material.editor.listening.retry": "Réessayer",
  "material.editor.gap_text.placeholder": "Saisissez votre texte ici",
  "material.editor.gap_text.hint": "Sélectionnez du texte pour créer un trou, ou cliquez sur un mot surligné et choisissez « Supprimer le trou »",
  "material.editor.gap_text.validation.min_gaps": "Marquez au moins un mot comme trou",
  "material.editor.gap_text.word_bank_for_students": "Banque de mots pour les élèves",
  "material.editor.gap_text.word_bank_off": "Non",
  "material.editor.gap_text.word_bank_on": "Oui",
  "material.editor.gap_text.word_bank": "Banque de mots",
  "material.editor.gap_text.word_bank_drop_return": "Déposez ici pour remettre le mot",
  "material.editor.gap_text.word_bank_all_used": "Tous les mots utilisés",
  "material.editor.gap_text.actions": "Actions du texte à trous",
  "material.editor.gap_text.mark_as_gap": "Marquer comme trou",
  "material.editor.gap_text.remove_gap": "Supprimer le trou",
  "material.editor.gap_text.evaluation.correct": "Correct",
  "material.editor.gap_text.evaluation.capitalization": "Vérifier les majuscules et minuscules",
  "material.editor.gap_text.evaluation.incorrect": "Incorrect",
  "generic_link_copied_to_clipboard": "Lien copié dans le presse-papiers",
  "generic_loading": "Chargement...",
  "auth_verify_resend_success": "Un nouvel e-mail vous a été envoyé.",
  "library.recent_materials.empty_state.title": "Aucun matériel créé pour l'instant.",
  "library.recent_materials.empty_state.description": "Dès que vous créez votre premier matériel, il apparaîtra ici. Les matériaux peuvent inclure des tâches interactives avec rétroaction IA, images, liens, fichiers et bien plus encore.",
  "library.recent_materials.empty_state.cta": "Créer du matériel",
  "item_detail.file_replace": "Remplacer le fichier",
  "onboarding.skip": "Passer",
  "editor.tools.video.caption.label": "Description vidéo",
  "editor.tools.video.caption.placeholder": "Décrire la vidéo",
  "material.block_menu.text": "Texte",
  "material.block_menu.open_question": "Question ouverte",
  "material.block_menu.questions_reproduction": "Générer des questions de reproduction",
  "material.block_menu.questions_reorganisation": "Générer des questions de réorganisation",
  "material.block_menu.questions_reflection": "Générer des questions de réflexion",
  "material.block_menu.multiple_choice": "Question à choix multiples",
  "material.block_menu.matching": "Exercice d'association",
  "material.editor.matching.badge": "Exercice d'association",
  "material.editor.matching.instruction_placeholder": "Saisis ici la consigne, par ex. « Trouve les bonnes traductions ».",
  "material.editor.matching.no_instruction": "Aucune consigne",
  "material.editor.matching.left_placeholder": "Terme (à gauche)",
  "material.editor.matching.right_placeholder": "Terme correspondant (à droite)",
  "material.editor.matching.add_pair": "Ajouter une paire",
  "material.editor.matching.reorder": "Déplacer",
  "material.editor.matching.connect_hint": "Relie les termes qui vont ensemble : trace une ligne de gauche à droite ou touche un terme puis l'autre.",
  "material.editor.matching.print_hint": "Associe chaque carte de gauche à la carte correspondante de droite. Trace une ligne entre les deux cartes.",
  "material.editor.matching.submit": "Soumettre",
  "material.editor.matching.redo": "Modifier les associations",
  "material.editor.matching.reset": "Réinitialiser",
  "material.editor.matching.validation.min_pairs": "Ajoute au moins deux paires complètes.",
  "material.editor.matching.feedback.correct": "Bravo ! Toutes les paires sont correctes.",
  "material.editor.matching.feedback.partially": "Partiellement correct. Vérifie tes associations et réessaie.",
  "material.editor.matching.feedback.incorrect": "Pas encore correct. Vérifie tes associations et réessaie.",
  "material.editor.matching.state.correct": "Bien associé",
  "material.editor.matching.state.incorrect": "Mal associé",
  "material.editor.matching.state.missing": "Non associé",
  "material.editor.matching.correct_answer": "Bonne réponse",
  "material.editor.matching.shuffle_hint": "Remarque : pour les élèves, la colonne de droite est mélangée automatiquement.",
  "material.editor.matching.read_hint": "Maintiens un terme appuyé pour lire le texte complet.",
  "material.editor.matching.peek_label": "Texte complet",
  "material.block_menu.gap_text": "Texte à trous",
  "material.block_menu.gap_text_generate": "Générer un texte à trous",
  "material.block_menu.flashcards": "Cartes éducatives",
  "material.block_menu.flashcards_add": "Ajouter des cartes éducatives",
  "material.block_menu.flashcards_generate": "Générer des cartes éducatives",
  "material.tab_share": "Distribuer",
  "material.ai_suggestions.custom_prompt": "Entrer une invite",
  "material.ai_edit.title": "Réviser le matériel avec IA",
  "material.ai_edit.paywall.description": "Souscris une licence maintenant pour réviser du matériel pédagogique avec l'IA.",
  "material.ai_create.title": "Créer du matériel avec IA",
  "material.ai_edit.placeholder": "Tapez comment l'IA doit réviser le matériel",
  "material.ai_edit.suggestions_title": "Suggestions",
  "material.ai.edit.suggestion_1_label": "Simplifier",
  "material.ai_edit.suggestion_1": "Simplifie tout le matériel",
  "material.ai.edit.suggestion_2_label": "Changer de focus",
  "material.ai_edit.suggestion_2": "Changez le focus du matériel sur :",
  "material.ai.edit.suggestion_3_label": "Traduire",
  "material.ai_edit.suggestion_3": "Traduire le matériel en :",
  "material.ai_edit.suggestion_3_question": "Dans quelle langue souhaitez-vous traduire le matériel ?",
  "material.ai_edit.suggestion_3_other": "Autre langue",
  "material.ai_edit.suggestion_3_placeholder": "Saisissez une langue…",
  "material.ai.edit.suggestion_4_label": "Tâches interactives",
  "material.ai_edit.suggestion_4": "Ajoutez des tâches interactives appropriées au matériel.",
  "material.ai.edit.suggestion_5_label": "Approfondir",
  "material.ai_edit.suggestion_5": "Approfondissez le contenu du matériel.",
  "material.ai.edit.suggestion_6_label": "Raccourcir",
  "material.ai_edit.suggestion_6": "Raccourcissez le matériel à l'essentiel.",
  "material.ai.edit.suggestion_7_label": "Ajouter des exercices",
  "material.ai_edit.suggestion_7": "Ajoutez d'autres exercices avec les opérateurs suivants :",
  "material.ai.edit.suggestion_8_label": "Exercices supplémentaires",
  "material.ai_edit.suggestion_8": "Ajoutez des défis supplémentaires pour les élèves qui terminent tôt.",
  "material.ai.edit.suggestion_9_label": "Améliorer la structure",
  "material.ai_edit.suggestion_9": "Organisez le matériel de manière plus lisible en utilisant des titres clairs, des sections et des paragraphes significatifs.",
  "material.ai.edit.suggestion_10_label": "Résumer",
  "material.ai_edit.suggestion_10": "Créez un bref résumé des points clés à la fin.",
  "material.ai.edit.suggestion_11_label": "Régénérer",
  "material.ai_edit.suggestion_11": "Créez tout le matériel à nouveau.",
  "material.ai.create.suggestion_1_label": "Fiche de travail",
  "material.ai.create.suggestion_1": "Créez une fiche de travail sur le thème : ",
  "material.ai.create.suggestion_1_question": "Sur quel thème doit porter la fiche de travail ?",
  "material.ai.create.suggestion_1_no_topic": "Créez une fiche de travail.",
  "material.ai.create.suggestion_2_label": "Déroulement du cours",
  "material.ai.create.suggestion_2": "Créez le déroulement d'un cours sur le thème : ",
  "material.ai.create.suggestion_2_question": "Sur quel thème doit porter le déroulement du cours ?",
  "material.ai.create.suggestion_2_no_topic": "Créez le déroulement d'un cours.",
  "material.ai.create.suggestion_3_label": "Exercice interactif",
  "material.ai.create.suggestion_3": "Créez un exercice interactif sur le thème : ",
  "material.ai.create.suggestion_3_question": "Sur quel thème doit porter l'exercice interactif ?",
  "material.ai.create.suggestion_3_no_topic": "Créez un exercice interactif.",
  "material.ai.create.suggestion_4_label": "Introduction du cours",
  "material.ai.create.suggestion_4": "Créez une introduction motivante et centrée sur les élèves sur le thème : ",
  "material.ai.create.suggestion_4_question": "Sur quel thème doit porter l'introduction du cours ?",
  "material.ai.create.suggestion_4_no_topic": "Créez une introduction motivante et centrée sur les élèves.",
  "material.ai.create.suggestion_5_label": "Idées pour le prochain cours",
  "material.ai.create.suggestion_5": "Développez des idées pour le prochain cours.",
  "material.ai_create.suggestion_6": "Formulez les objectifs d'apprentissage sur le thème : ",
  "material.ai_state.generated": "Matériel généré",
  "material.ai_state.reworking": "L’IA retravaille le matériel…",
  "material.ai_state.undo": "Annuler",
  "material.ai_state.save_as_new": "Enregistrer comme nouveau matériel",
  "material.ai_state.accept": "sauvegarder",
  "material.ai_save_as_new.description": "Le résultat sera enregistré comme un nouveau matériel. Par exemple, différentes versions d'un matériel peuvent être créées.",
  "material.ai_save_as_new.name_label": "Nom du nouveau matériel",
  "material.ai_save_as_new.name_placeholder": "Nom du nouveau matériel",
  "material.ai_save_as_new.copy_suffix": " (Copie)",
  "material.ai_save_as_new.success_title": "Nouveau matériel enregistré",
  "material.ai_save_as_new.success_message": "Le nouveau matériel a été créé et ouvert.",
  "material.pdf_export": "Enregistrer / imprimer le PDF",
  "material.pdf_export_beautiful": "PDF soigné",
  "material.docx_export": "Word (.docx)",
  "material.docx_export_with_notes": "Word (.docx) avec notes",
  "material.search_placeholder": "Rechercher du matériel",
  "material.generate": "Générer du matériel",
  "material.editor.text.generate_questions": "Générer des questions sur le texte",
  "material.editor.text.simplify": "Simplifier le texte",
  "material.editor.text.label": "Bloc de texte",
  "material.editor.text.placeholder": "Tapez le texte",
  "material.editor.callout.label": "Phrase mémorable",
  "material.editor.callout.placeholder": "Écrire ici",
  "material.save_conflict.title": "Une version plus recente du materiel est disponible",
  "material.save_conflict.close": "Fermer",
  "material.save_conflict.reload": "Recharger le materiel",
  "material.save_conflict.body_updated": "Ce matériel a été mis à jour après l'ouverture de cet éditeur.",
  "material.save_conflict.body_reload_warning": "Le rechargement chargera la dernière version du matériel. Les modifications non enregistrées dans cette version obsolète seront perdues.",
  "material.editor.details.summary_label": "Titre de la liste déroulante",
  "material.editor.details.summary_placeholder": "Titre",
  "material.editor.details.content_label": "Contenu de la liste déroulante",
  "material.editor.details.placeholder": "Écrire ici",
  "material.editor.block.ai_suggestion": "Suggestion IA",
  "material.editor.block.reject": "Rejeter",
  "material.editor.block.accept": "Accepter",
  "material.editor.block.teacher_only": "Visible uniquement pour les enseignants",
  "material.editor.block.adjust_results": "Ajuster les résultats",
  "material.editor.block.prompt_placeholder": "Entrer une invite",
  "material.editor.block_number.image": "B{{number}}",
  "material.editor.assignment_open_question.placeholder": "Tapez la question ici",
  "material.editor.assignment_open_question.hint_loading": "Astuce est en chargement",
  "material.editor.assignment_open_question.badge": "Tâche avec rétroaction IA",
  "material.editor.assignment_open_question.guidance_hint": "Saisissez ici des critères de feedback ou une réponse modèle.",
  "material.editor.assignment_open_question.guidance_hint_short": "Saisissez ici des critères de feedback",
  "material.editor.assignment_open_question.guidance_collapsed_empty": "Pas encore définis",
  "material.editor.assignment_open_question.guidance_input_placeholder": "Saisissez ici des critères de feedback",
  "material.editor.assignment_open_question.preview_cta": "Tester la rétroaction IA",
  "material.editor.assignment_open_question.preview_title": "Essayez la question de la perspective de vos élèves",
  "material.editor.assignment_open_question.language_assessment.label": "Critères pour le feedback linguistique de l’IA",
  "material.editor.assignment_open_question.language_assessment.description": "Activez ou désactivez les options souhaitées.",
  "material.editor.assignment_open_question.language_assessment.chip.grammar_spelling": "Grammaire et orthographe",
  "material.editor.assignment_open_question.language_assessment.chip.allow_all_languages": "Autoriser toutes les langues",
  "material.editor.assignment_open_question.language_assessment.feedback_label": "Langue",
  "material.editor.assignment_open_question.help.cta": "Lire l'instruction complète",
  "material.editor.assignment_open_question.help.title": "Guide : Utiliser l'IA en classe",
  "material.editor.assignment_open_question.help.link": "Guide : Utiliser l'IA en classe",
  "material.editor.multiple_choice.badge": "Question à choix multiples",
  "material.editor.multiple_choice.choice_type": "Type de choix",
  "material.editor.multiple_choice.single_choice": "Choix unique",
  "material.editor.multiple_choice.multiple_choice": "Choix multiple",
  "material.editor.multiple_choice.option_placeholder": "Réponse {{index}}",
  "material.editor.multiple_choice.allow_multiple": "Permettre plusieurs choix",
  "material.editor.multiple_choice.add_option": "Ajouter une réponse",
  "material.editor.multiple_choice.randomized_order_hint": "L'ordre des réponses est aléatoire pour les élèves.",
  "material.editor.multiple_choice.no_question": "L'enseignant n'a pas encore formulé de question.",
  "material.editor.multiple_choice.answer_option_default": "Option de réponse",
  "material.editor.multiple_choice.correct": "Correct",
  "material.editor.multiple_choice.info.title": "Les élèves reçoivent des astuces de l'IA",
  "material.editor.multiple_choice.info.description": "Si une mauvaise réponse est sélectionnée, les élèves reçoivent une astuce.",
  "material.editor.multiple_choice.preview_cta": "Essayer",
  "material.editor.image.search_other": "Chercher une autre image",
  "material.editor.image.upload_other": "Télécharger une autre image",
  "material.editor.image.generate": "Générer une image",
  "material.editor.image.no_results": "Aucun résultat trouvé.",
  "material.editor.image.alternative_for": "Images alternatives pour \"{{keywords}}\"",
  "material.editor.image.source_label": "Source :",
  "material.editor.image.author_label": "Auteur :",
  "material.editor.image.suggestions_title": "Suggestions alternatives",
  "material.editor.file.uploading": "Fichier en cours de téléchargement",
  "material.editor.file.upload_error": "Le fichier n'a pas pu être téléchargé.",
  "material.editor.file.retry": "Réessayer",
  "material.editor.file.upload": "Télécharger un fichier",
  "material.editor.link.enter": "Entrer le lien",
  "material.editor.link.invalid": "Veuillez entrer un lien valide.",
  "material.editor.link.remove_preview": "Supprimer l'aperçu",
  "material.save_as_new_dialog.title": "Enregistrer un nouveau matériel",
  "material.save_as_new_dialog.description": "Entrez un nom pour le nouveau matériel.",
  "material.save_as_new_dialog.placeholder": "Entrer le nom",
  "material.save_as_new_dialog.confirm": "Enregistrer comme nouveau matériel",
  "material.chat.age_select.tooltip": "Âge des élèves : L'IA ajuste la difficulté et les méthodes à l'âge de vos élèves",
  "material.chat.language_select.tooltip": "Dans quelle langue l'IA doit-elle générer les résultats ?",
  "ipi.system_prompt.label": "Invite Système (si vide, l'invite par défaut est utilisée)",
  "ipi.system_prompt.placeholder": "L'invite principale",
  "ipi.usage.remaining_1": "Encore une demande possible",
  "ipi.prompt.too_generic": "Votre demande est trop générale. Veuillez indiquer un sujet, une matière ou un point de focalisation concret (par ex. « feuille de travail sur la photosynthèse » ou « explication de la Révolution française »). Cela permettra de créer un matériel adapté pour vous.",
  "ipi.prompt.rejected_by_agent": "Veuillez poser une question sur un sujet scolaire, adapté pour l'enseignement ou l'apprentissage.",
  "ipi.prompt.generic_error": "Quelquechose s'est mal passé. Veuillez réessayer.",
  "ipi.prompt_history.title": "Historique des prompts",
  "ipi.prompt_history.open": "Ouvrir l'historique des prompts",
  "ipi.prompt_history.empty_state": "Vous n'avez encore utilisé aucun prompt.",
  "ipi.prompt_history.select": "Utiliser le prompt",
  "ipi.prompt.failed": "Aucun matériel n'a pu être généré. Veuillez réessayer.",
  "ipi.more_tools.title": "Plus d'outils IA",
  "ipi.material.done_description_after": ", pour adapter le matériel.",
  "ipi.inspiration.heading": "Inspiration",
  "ipi.inspiration.try_example": "Essayer un exemple",
  "ipi.inspiration.examples.1.subject": "Compétences numériques",
  "ipi.inspiration.examples.1.title": "Intelligence Artificielle",
  "ipi.inspiration.examples.1.prompt": "Créez une feuille de travail où les élèves explorent pas à pas ce qu'est l'IA, ses avantages, inconvénients et dangers. Les élèves ont peu de connaissances sur le sujet.",
  "ipi.inspiration.examples.2.subject": "Compétences numériques",
  "ipi.inspiration.examples.2.title": "Médias sociaux",
  "ipi.inspiration.examples.2.prompt": "Créer une feuille de travail sur les médias sociaux. Traiter les opportunités, les risques et les règles pour un usage responsable. Les élèves connaissent les dangers de base d'Internet et utilisent différentes applications (principalement TikTok et Instagram).",
  "ipi.inspiration.examples.3.subject": "Transdisciplinaire",
  "material.ai_create.suggestion_5_label": "Introduction de cours",
  "ipi.inspiration.examples.3.title": "Durabilité",
  "ipi.inspiration.examples.3.prompt": "Créer une feuille de travail sur la durabilité à partir de différentes perspectives.",
  "ipi.inspiration.examples.4.subject": "Anglais",
  "ipi.inspiration.examples.4.title": "Fake-News",
  "ipi.inspiration.examples.4.prompt": "Créer un texte de lecture plus long avec des questions de compréhension interactives et des questions de réflexion sur le thème des Fake-News.",
  "ipi.rework": "Retravailler",
  "ai_assistant.rework_pending_review": "Une révision existante de ce matériel est encore en attente de validation ou en cours d'application. Validez-la ou rejetez-la avant d'en lancer une nouvelle.",
  "help_center.materials.title": "Créer et éditer du matériel",
  "help_center.materials.sub_title": "Un sous-titre",
  "help_center.materials.description": "Avec Teachino, vous pouvez créer du matériel pédagogique de haute qualité en quelques clics. Il est plus facile avec l'IA sur la page d'accueil. Entrez simplement un sujet et ajoutez des détails comme l'âge et la langue, dans quelle série le matériel doit être stocké ou ajoutez une source, par ex. un PDF ou un lien vers lequel l'IA doit se référer et c'est parti. L'IA créera pour vous un matériel adapté en quelques secondes, avec des images, des textes et des tâches. Plus vous fournissez de détails à l'IA, meilleur sera le résultat.",
  "help_center.materials.faq1.question": "Comment créer un matériel ?",
  "help_center.materials.faq1.answer": "Pour créer un matériel, allez sur la page d'accueil et entrez un sujet.",
  "navigation.profile_settings": "Paramètres du profil",
  "navigation.profile.trial_days_left": "{{days}} jours d'essai restants",
  "navigation.profile.grace_days_left": "{{days}} jours Pro restants",
  "material.tab_edit": "Éditer",
  "material.tab_preview": "Aperçu",
  "material.tab_evaluate": "Évaluer",
  "ipi.material.done_description": "Clique sur « Éditer » pour modifier le matériel ou « Régénérer » pour un nouvel essai avec l'IA.",
  "ipi.hints.improvements": "Conseil : Ajoute des détails souhaités comme <strong>focus</strong>, <strong>but d'apprentissage</strong>, <strong>connaissances préalables</strong>, <strong>durée</strong>, <strong>forme sociale</strong>, <strong>niveau de compétence</strong>, <strong>style de langue</strong>.",
  "ipi.feedback.thank_you": "Merci pour ton retour !",
  "ipi.feedback.regenerate": "Clique sur « Régénérer » pour essayer à nouveau.",
  "ipi.add_source.add_youtube": "Entrer le lien YouTube",
  "ipi.add_topic_description": "Dans quel thème le matériel doit-il être créé ? L'IA utilise le thème comme contexte supplémentaire.",
  "ipi.regenerate": "Régénérer",
  "ipi.regenerate.title": "Régénérer le matériel",
  "ipi.improve.hint.title": "Conseils",
  "ipi.improve.hint.1_label": "🧠 Trop difficile ?",
  "ipi.improve.hint.1_cta": "Ajuster l'âge",
  "ipi.improve.hint.2_label": "✍️ Trop vague ?",
  "ipi.improve.hint.2_cta": "Mentionner le focus",
  "ipi.improve.hint.3_label": "🎯 Imprécis ? ",
  "ipi.improve.hint.3_cta": "Ajouter le but d'apprentissage",
  "ipi.improve.hint.4_label": "🗣️ Langue incorrecte ?",
  "ipi.improve.hint.4_cta": "Choisir la langue.",
  "editor.tools.code.note": "Note d'enseignant",
  "editor.tools.youtube": "Youtube",
  "material.editor.assignments": "Tâches interactives",
  "material.editor.assignments_ai_hint": "Avec IA pour élèves",
  "material.editor.interactive_tag": "Interactif",
  "material.editor.interactive_ai_tag": "Interactif avec IA",
  "interactive_assignment.overview.legend.partially_correct": "Partiellement correct",
  "interactive_assignment.overview.legend.correct": "Correct",
  "interactive_assignment.overview.legend.started": "En cours",
  "interactive_assignment.overview.legend.attempts_and_hints": "1. Chiffre : Nombre de tentatives &middot; 2. Chiffre : Nombre de conseils utilisés",
  "interactive_assignment.overview.show_hints_and_attempts": "Montrer tentatives et conseils",
  "interactive_assignment.overview.one_attempt": "Une tentative.",
  "interactive_assignment.overview.many_attempts": "Tentatives",
  "interactive_assignment.no_courses.title": "Clique sur \"Partager\" pour partager ce matériel avec tes écoliers.",
  "interactive_assignment.no_courses_description": "Une fois que tes écoliers travaillent sur le matériel, tu pourras voir ici l'évaluation par écolier et par question.",
  "editor.file.description.placeholder": "Ajouter une description",
  "pathfindr.annotation_tool.welcome_modal.title": "Bonjour",
  "pathfindr.annotation_tool.welcome_modal.text": "Ici, tu peux voir et dessiner sur des documents.",
  "pathfindr.annotation_tool.welcome_modal.button": "Continuer",
  "pathfindr.annotation_tool.permission_modal.title": "Permission requise",
  "pathfindr.annotation_tool.permission_modal.text": "Tu dois autoriser l'accès à ta caméra et écran pour enregistrer ta session.",
  "pathfindr.annotation_tool.permission_modal.button_permission": "Accorder la permission",
  "pathfindr.annotation_tool.permission_modal.button_no_permission": "Continuer sans enregistrement",
  "pathfindr.annotation_tool.permission_modal.no_browser_support_title": "Pas de support navigateur",
  "pathfindr.annotation_tool.permission_modal.no_browser_support_text": "Ton navigateur ne supporte pas l'enregistrement d'écran. Raisons fréquentes : paramètres de sécurité manquants, un navigateur obsolète ou un manque de support sur les smartphones.",
  "pathfindr.annotation_tool.uploading_modal.title": "Téléchargement...",
  "pathfindr.annotation_tool.success_modal.title": "Hourra !",
  "pathfindr.annotation_tool.success_modal.text": "Tes fichiers ont été téléchargés",
  "pathfindr.annotation_tool.error_modal.title": "Erreur",
  "pathfindr.annotation_tool.error_modal.text": "Le fichier ne peut pas être affiché pour le moment. Merci de télécharger le fichier avec le bouton de téléchargement sur ton appareil pour l'ouvrir.",
  "pathfindr.annotation_tool.error_modal.button_download_video": "Télécharger la vidéo",
  "pathfindr.annotation_tool.error_modal.button_download_pdf": "Télécharger le PDF",
  "pathfindr.annotation_tool.error_modal.button_retry": "Réessayer",
  "pathfindr.annotation_tool.navbar.button_done": "Terminé",
  "pathfindr.annotation_tool.navbar.uploading_text": "Téléchargement...",
  "pathfindr.annotation_tool.navbar.button_cancel": "Annuler",
  "pathfindr.annotation_tool.navbar.helper_text_not_ready": "Enregistre ou modifie le document",
  "pathfindr.annotation_tool.navbar.helper_text_ready": "Prêt à télécharger",
  "pathfindr.annotation_tool.access_token_unvalid": "Ceci est une version de test, uniquement pour essais et démos !",
  "download_page_title": "Téléchargement de Teachino",
  "dashboard.title": "Accueil",
  "dashboard.greeting.morning": "Bonjour, {{name}}",
  "dashboard.greeting.afternoon": "Bon après-midi, {{name}}",
  "dashboard.greeting.evening": "Bonsoir, {{name}}",
  "dashboard.greeting.night": "Bonne nuit, {{name}}",
  "dashboard.greeting.free": "Tu utilises la version gratuite de Teachino.",
  "dashboard.greeting.trial": "Ta période d'essai gratuit se termine bientôt.",
  "dashboard.library.title": "Ta bibliothèque",
  "dashboard.library.topics": "Tes thèmes",
  "dashboard.library.topics_empty": "Les thèmes sont des unités thématiques, comme des chapitres dans un manuel scolaire. Une fois créés, réutilisables.",
  "dashboard.library.materials": "Tes matériels",
  "dashboard.library.materials_empty": "Contenu de cours : liens, feuilles de travail, notes, ... Organisé en thèmes et modifiable avec l'IA.",
  "dashboard.library.open_all_topics": "Ouvrir la bibliothèque",
  "dashboard.library.create_material": "Créer du matériel",
  "dashboard.library.create_topic": "Créer un thème",
  "dashboard.ai.title": "Ton assistant IA",
  "dashboard.ai.frequently_used": "Fonctions IA populaires",
  "dashboard.ai.ai_for_files": "IA pour fichiers",
  "dashboard.ai.ai_for_youtube": "IA pour vidéos YouTube",
  "dashboard.ai.ai_for_images": "IA pour images",
  "dashboard.ai.lesson_planning": "Planifier le cours avec IA",
  "dashboard.ai.create_topic": "Planifier le thème du cours",
  "dashboard.ai.create_period": "Créer le plan de progression",
  "dashboard.ai.use_with_students": "Utiliser IA avec les écoliers",
  "dashboard.ai.my_assignments": "Ouvrir mes exercices IA",
  "dashboard.ai.find_template": "Trouver un exercice IA",
  "dashboard.ai.show_all": "Montrer toutes les fonctions IA",
  "dashboard.timetable.title": "Ton emploi du temps",
  "dashboard.timetable.sub_title": "Tes prochains cours",
  "dashboard.timetable.open_timetable": "Ouvrir l'emploi du temps",
  "dashboard.timetable.empty_text": "Tout en un coup d'œil : entre ton emploi du temps pour gérer cours et tâches de manière claire !",
  "dashboard.timetable.timetable_cta": "Saisir l'emploi du temps",
  "dashboard.timetable.webuntis_cta": "Charger l'emploi du temps de WebUntis",
  "dashboard.onboarding.title": "Tes premiers pas avec Teachino",
  "dashboard.onboarding.step_1": "1. Crée un thème et un matériel",
  "dashboard.onboarding.step_2": "2. Modifie le matériel avec l'IA",
  "dashboard.onboarding.step_3": "3. Crée tes cours",
  "language.de": "Allemand",
  "language.en": "Anglais",
  "language.it": "Italien",
  "language.es": "Espagnol",
  "language.fr": "Français",
  "language.pt": "Portugais",
  "language.tr": "Turc",
  "language.po": "Polonais",
  "language.nl": "Néerlandais",
  "language.se": "Suédois",
  "language.ru": "Russe",
  "language.sl": "Slovène",
  "language.cs": "Tchèque",
  "language.lb": "Luxembourgeois",
  "language.ro": "Roumain",
  "language.rs": "Serbe",
  "language.hr": "Croate",
  "language.ur": "Ourdou",
  "language.hi": "Hindi",
  "language.sq": "Albanais",
  "language.ar": "Arabe",
  "ipi.page_title": "Créer du matériel avec l'IA",
  "ipi.title": "Décris un thème et reçois le matériel approprié",
  "ipi.sub_title": "L'IA crée du matériel éducatif interactif que tu peux directement modifier et ensuite partager avec tes écoliers.",
  "ipi.usage.title": "Quota IA",
  "ipi.usage.summary": "{{used}} sur {{limit}} demandes utilisées au cours des {{windowDays}} derniers jours",
  "ipi.usage.remaining": "Encore {{remaining}} demandes disponibles",
  "ipi.usage.limit_reached": "Vous avez atteint votre quota actuel. Réessayez plus tard.",
  "ipi.paywall.description": "Générez du matériel pédagogique avec l'IA – fiches interactives, exercices et idées de cours.",
  "ipi.usage.upgrade_cta": "Passer à la version Pro",
  "ipi.prompt.too_short": "Merci d'entrer une indication plus longue.",
  "ipi.prompt.placeholder": "Tape ici un thème et les détails souhaités (priorité, objectif d'apprentissage, connaissances préalables, ...)",
  "ipi.link.thena.title": "Vers l'assistant IA (Thena)",
  "ipi.link.thena.description": "Chat IA pour la vie scolaire",
  "ipi.link.student_ai.title": "Vers l'IA pour écoliers",
  "katex.fractions": "Fractions",
  "katex.exponents": "Exposants",
  "katex.subscripts": "Indices (inférieurs)",
  "katex.roots": "Racines",
  "katex.summation": "Somme",
  "katex.product": "Produit",
  "katex.limit": "Limite",
  "katex.integral": "Intégrale",
  "katex.infinity": "Infini",
  "katex.pi": "Pi",
  "katex.delta": "Delta (changement)",
  "katex.vector": "Vecteurs (gras ou avec flèche)",
  "katex.equality": "Égal / Inégal",
  "katex.shortFraction": "Fraction courte (en ligne)",
  "katex.scaledBrackets": "Crochets échelonnés automatiquement",
  "katex.arrows": "Flèches",
  "katex.sets": "Ensembles",
  "katex.emptysetNumbersets": "Ensemble vide / Ensembles de nombres",
  "katex.absoluteValue": "Valeur absolue",
  "katex.matrices": "Matrices",
  "katex.systemOfEquations": "Systèmes d'équations",
  "katex.fractionInExponent": "Fraction dans l'exposant",
  "katex.dots": "Points (suite)",
  "katex.overline": "Ligne supérieure (moyenne)",
  "katex.binomial": "Coefficient binomial",
  "katex.logarithm": "Logarithme",
  "katex.trigonometric": "Fonctions trigonométriques",
  "katex.derivative": "Dérivée",
  "katex.partialDerivative": "Dérivée partielle",
  "katex.gradient": "Nabla / Gradient",
  "katex.sumWithConditions": "Somme avec conditions",
  "katex.textInMath": "Texte dans une formule",
  "katex.exponential": "Fonction exponentielle",
  "katex.bracketedFraction": "Fraction avec crochets",
  "katex.approxIneq": "Approximativement égal / Inégal",
  "katex.doubleArrows": "Flèches doubles (équivalence)",
  "katex.brackets": "Crochets / Accolades",
  "katex.spacing": "Espacements en mode maths",
  "katex.enter_equation": "Entrer une formule (LaTeX)",
  "katex.preview": "Aperçu",
  "katex.preview.empty": "Une fois que tu entres une formule, l'aperçu apparaît ici.",
  "katex.show_all_tips": "Afficher tous les conseils",
  "katex.hide_all_tips": "Afficher moins de conseils",
  "info": "Infos",
  "error": "Erreur",
  "success": "Modifications enregistrées",
  "generic_created_at": "Créé le {{date}}",
  "generic_error": "Une erreur s'est produite. Merci de réessayer",
  "generic_name": "Nom",
  "generic_error_network": "Quelque chose a mal tourné. Merci de vérifier votre connexion Internet et réessayez.",
  "generic_slogan": "Planification annuelle. Planification hebdomadaire. Matériels.\nUne application. Simple et clair.",
  "generic_back": "Retour",
  "generic_confirm": "Confirmer",
  "generic_and": "et",
  "generic_save": "Sauvegarder",
  "generic_cancel": "Annuler",
  "generic_retry": "Réessayer",
  "generic_delete": "Supprimer",
  "generic_edit": "Éditer",
  "generic_done": "Terminé",
  "generic_topic": "Thème",
  "generic_topics": "Thèmes",
  "generic_folder": "Dossier",
  "generic_folders": "Dossiers",
  "generic_sub_folder": "Sous-dossier",
  "generic_sub_folders": "Sous-dossiers",
  "generic_item": "Matériel",
  "generic_material": "Matériel",
  "generic_materials": "Matériels",
  "generic_file_name": "Nom du fichier",
  "generic_file_description": "Description du fichier",
  "generic_items": "Matériels",
  "generic_title": "Titre",
  "generic_continue": "Continuer",
  "generic.copy_link": "Copier le lien",
  "generic_copy": "Copier",
  "generic_add": "Ajouter",
  "generic_next": "Suivant",
  "generic_close": "Fermer",
  "generic_hide": "Cacher",
  "generic_course": "Course",
  "generic_courses": "Tous les cours",
  "generic_template": "Collection",
  "generic_duplicate": "Dupliquer",
  "generic_move": "Déplacer",
  "generic_preview": "Aperçu",
  "generic_form_error_required": "Champ requis",
  "homepage_title": "Page d'accueil",
  "generic_first_name": "Prénom",
  "generic_first_name_placeholder": "Marie",
  "generic_last_name": "Nom de famille",
  "generic_last_name_placeholder": "Dupont",
  "generic_email": "Adresse e-mail",
  "generic_email_placeholder": "mon@email.fr",
  "generic_schoolyear": "Année scolaire",
  "generic_subject": "Matière",
  "generic_class": "Classe",
  "generic_clear_date": "Pas de date",
  "generic_duration": "Durée",
  "generic_duration_in_minutes": "Durée (en minutes)",
  "generic_visibility": "Visibilité",
  "generic_vacation": "Vacances",
  "generic_choose": "Choisir",
  "generic_search": "Rechercher",
  "generic_options": "Options",
  "generic_new_badge": "Nouveau !",
  "generic_empty_state": "Aucune donnée trouvée",
  "generic_substitution": "Remplacement",
  "generic_archived": "Supprimé",
  "generic_text_copied_to_clipboard": "Texte copié dans le presse-papiers",
  "generic_select_placeholder": "Choisissez une option...",
  "generic_teachino_pro": "Licence pour enseignants",
  "generic_upgrade": "Mise à niveau",
  "generic_class_level": "Niveau scolaire",
  "generic_form_error.not_a_number": "Veuillez entrer un nombre",
  "generic_upload_files": "Télécharger des fichiers",
  "generic_upload_images": "Télécharger des images",
  "generic_add_image": "Ajouter une image",
  "generic_find_images": "Rechercher des images",
  "generic_error_url_invalid": "URL invalide",
  "generic_sus_long": "Écoliers",
  "generic_n_years": "{{years}} ans",
  "generic_language": "Langue",
  "generic_create": "Créer",
  "generic_beta": "Bêta",
  "pro_feature_badge.tooltip": "Fonctionnalité disponible pendant la période d'essai ou avec une licence payante",
  "generic_enabled": "Activé",
  "generic_disabled": "Désactivé",
  "generic_optional": "(facultatif)",
  "generic_sus_short": "Élèves",
  "generic_form_error.max_line_length": "Ligne trop longue (max. {{maxLength}} caractères) : \"{{line}}\"",
  "generic_visibility_for_students": "Visibilité pour les élèves",
  "generic_drop_files_here": "Déposez votre fichier ici",
  "teachino_ai": "Teachino IA",
  "navigation.timetable": "Emploi du temps",
  "navigation.agenda": "Agenda",
  "navigation.timetable_week": "Emploi du temps",
  "navigation.timetable_list": "Liste",
  "navigation.library": "Matériels",
  "navigation.help": "Aide & Feedback",
  "navigation.profile": "Profil",
  "navigation.log_out": "Se déconnecter",
  "navigation.imprint": "Empreinte",
  "navigation.terms": "Conditions d'utilisation",
  "navigation.privacy": "Confidentialité",
  "navigation.courses": "Tous les cours",
  "navigation.collaboration": "Collections",
  "navigation.status": "Statut du serveur",
  "navigation.licenses": "Licence & Mise à niveau",
  "navigation.course.content": "Contenu du cours",
  "navigation.course.timeline": "Chronologie",
  "navigation.course.create": "Ajouter",
  "navigation.ai": "IA",
  "navigation.new_course": "Nouveau cours",
  "navigation.help_and_support": "Aide et support",
  "navigation.feedback": "Commentaires",
  "auth_password": "Mot de passe",
  "auth_button_login": "Se connecter",
  "auth_forgot_password": "Mot de passe oublié ?",
  "auth_signup_teacher_title": "S'inscrire à Teachino.",
  "auth_signup_tos": "Conditions d'utilisation",
  "auth_verify_title": "Confirmer l'adresse e-mail",
  "auth_verify_description_1": "Veuillez entrer le code que nous avons envoyé à ",
  "auth_verify_description_2": ".",
  "auth_verify_typo": "Erreur de frappe?",
  "auth_verify_spam": "Code non reçu? Vérifiez votre dossier spam.",
  "auth_verify_resend": "Envoyer l'e-mail de nouveau",
  "auth_verify_resend_change": "Changer l'adresse e-mail",
  "auth_verify_resend_save": "Sauvegarder l'adresse e-mail",
  "auth_verify_change_error_duplicate": "Cet e-mail est déjà enregistré à Teachino.",
  "auth_verify_change_login": "Se connecter avec mot de passe",
  "auth_verify_code_error": "Ce code est invalide ou expiré.",
  "auth_verify_code_empty": "Veuillez entrer le code reçu par e-mail.",
  "auth_verify_code_error_expired": "Ce code n'est plus valide.",
  "auth_verify_code_request_new_code": "Demander un nouveau code",
  "auth_verify_limit_exceeded": "Beaucoup d'e-mails demandés dans les dernières minutes. Veuillez patienter avant de demander plus d'e-mails.",
  "auth_masterdata_title": "Derniers détails pour finaliser votre inscription.",
  "auth_new_password": "Choisissez un mot de passe",
  "auth_masterdata_school_name.school": "Nom de votre école",
  "auth_masterdata_school_name.location": "Localisation de votre école",
  "auth_masterdata_school_name_placeholder.school": "ex : Lycée Einstein",
  "auth_masterdata_school_name_placeholder.location": "ex : Paris",
  "auth_masterdata_show_invite_code": "Optionnel : Entrer un code d'invitation",
  "auth_masterdata_invite_code": "Code d'invitation (Optionnel)",
  "auth_masterdata_complete": "Ouvrir Teachino",
  "auth_password_requirement_letter": "une lettre",
  "auth_password_requirement_number": "un chiffre",
  "auth_password_requirement_length": "{{number}} caractères",
  "auth_reset_code_title": "Si {{email}} est enregistré sur Teachino, nous vous avons envoyé un code pour réinitialiser le mot de passe.",
  "auth_reset_password_title": "Entrez votre adresse e-mail pour réinitialiser votre mot de passe.",
  "auth_reset_password_button": "Réinitialiser le mot de passe",
  "auth_reset_password_new_password": "Veuillez choisir un nouveau mot de passe.",
  "auth_reset_password_code": "Code de confirmation",
  "auth_login.title": "Bon retour !",
  "auth.signup_v2.page_title": "Continuer avec Teachino",
  "auth.signup_v2.trust_privacy": "Conforme à la protection des données",
  "auth.signup_v2.trust_ph_salzburg": "Développé avec la PH Salzburg",
  "auth.signup_v2.role_label": "Rôle",
  "auth.signup_v2.teacher_section": "Je suis enseignant·e",
  "auth.signup_v2.student_section": "Je suis élève",
  "auth.signup_v2.signup_title": "Créer votre compte gratuit",
  "auth.signup_v2.signup_description": "Il n’existe pas encore de compte Teachino pour {{email}}. Saisissez votre nom et choisissez un mot de passe.",
  "auth_login.send_login_link_instead": "Recevoir un lien de connexion",
  "auth_login.password_required": "Veuillez saisir votre mot de passe.",
  "auth_login.wrong_password": "Ce mot de passe est incorrect. Réessayez ou recevez plutôt un lien de connexion.",
  "auth.signup_v2.invalid_email": "Saisissez une adresse e-mail valide.",
  "auth.signup_v2.name_required": "Saisissez votre prénom et votre nom.",
  "auth.signup_v2.password_invalid": "Choisissez un mot de passe qui remplit toutes les conditions.",
  "auth.signup_v2.show_password": "Afficher le mot de passe",
  "auth.signup_v2.hide_password": "Masquer le mot de passe",
  "auth.signup_v2.code_password_hint": "Pour votre sécurité, saisissez à nouveau votre mot de passe.",
  "auth.signup_v2.newsletter_opt_in": "Je souhaite recevoir des informations utiles sur Teachino par e-mail",
  "auth.signup_v2.luxembourg_title": "Vous venez du Luxembourg ?",
  "auth.signup_v2.luxembourg_body": "Teachino est gratuit pour vous. Connectez-vous avec IAM pour activer la licence.",
  "auth.signup_v2.luxembourg_iam_login": "Se connecter avec IAM",
  "auth.signup_v2.luxembourg_without_iam": "Continuer sans IAM",
  "auth.signup_v2.request_error": "Nous n'avons pas pu envoyer le code. Réessayez plus tard.",
  "auth.signup_v2.or_continue_with": "ou connectez-vous via un portail",
  "auth.signup_v2.choose_page_title": "Essayer Teachino",
  "auth.signup_v2.intent_title": "Que souhaitez-vous faire avec Teachino ?",
  "auth.signup_v2.intent_description": "Choisissez tout ce qui vous intéresse.",
  "auth.signup_v2.intent_option_record_grades": "Documenter les notes",
  "auth.signup_v2.intent_option_record_participation": "Documenter la participation",
  "auth.signup_v2.intent_option_plan_lessons": "Planifier des cours individuels",
  "auth.signup_v2.intent_option_plan_school_year": "Planification annuelle",
  "auth.signup_v2.intent_option_organize_materials": "Organiser le matériel",
  "auth.signup_v2.intent_option_create_materials": "Créer du matériel",
  "auth.signup_v2.intent_option_use_ai_with_students": "Utiliser l’IA avec les élèves",
  "auth.signup_v2.intent_option_share_with_colleagues": "Partager du matériel avec des collègues",
  "auth.signup_v2.intent_skip": "Passer",
  "auth.signup_v2.legal_prefix": "Lors de votre première connexion, vous acceptez les documents suivants :",
  "auth.signup_v2.code_page_title": "Saisir le code de connexion",
  "auth.signup_v2.code_title": "Consultez vos e-mails",
  "auth.signup_v2.code_description": "Nous avons envoyé un code à six chiffres à {{email}}.",
  "auth.signup_v2.code_description_generic": "Nous vous avons envoyé un code à six chiffres par e-mail.",
  "auth.signup_v2.code_label": "Code de vérification",
  "auth.signup_v2.code_error_invalid": "Ce code est invalide. Vérifiez-le et réessayez.",
  "auth.signup_v2.code_error_expired": "Ce code a expiré. Demandez un nouveau code.",
  "auth.signup_v2.code_error_network": "Nous n'avons pas pu vérifier le code. Réessayez.",
  "auth_signup.description": "Donnez-nous votre adresse e-mail pour commencer.",
  "profile.general.title": "Mettre à jour les informations personnelles",
  "profile.email-subscription.title": "Notifications par e-mail",
  "profile.email-subscription.success_message": "Paramètres enregistrés",
  "profile.email.title": "Mettre à jour l'adresse e-mail",
  "profile.password.title": "Mettre à jour le mot de passe",
  "profile.password.old_password": "Mot de passe actuel",
  "profile.password.new_password": "Nouveau mot de passe",
  "profile.password.new_password_2": "Confirmer le nouveau mot de passe",
  "profile.password.wrong_title": "Mot de passe incorrect",
  "profile.password.wrong_description": "Veuillez vérifier le mot de passe actuel. Le nouveau mot de passe n'a pas été enregistré.",
  "profile.password.success_title": "Mot de passe changé",
  "profile.password.success_description": "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
  "auth_login.pending_integration_hint": "Connectez-vous une fois avec votre adresse e-mail et votre mot de passe. Vous pourrez ensuite associer {{displayName}} à votre compte Teachino et, la prochaine fois, la connexion via {{displayName}} suffira.",
  "auth_login.code.sent_to": "Nous avons envoyé un code de connexion à {{email}}. Saisissez-le ici ou cliquez sur le lien dans l’e-mail.",
  "auth_login.code.sent_generic": "Saisissez le code de connexion reçu par e-mail.",
  "profile.password.by_code_hint": "Vous vous êtes inscrit sans mot de passe ou avez oublié le vôtre ? Définissez un nouveau mot de passe avec un code que nous envoyons à votre adresse e-mail.",
  "profile.password.by_code_request": "Envoyer le code par e-mail",
  "profile.password.by_code_sent": "Nous avons envoyé un code à {{email}}.",
  "profile.password.by_code_save": "Enregistrer le mot de passe",
  "profile.data.success_title": "Données enregistrées",
  "profile.data.success_description": "Vos informations personnelles ont été enregistrées.",
  "profile.language": "Langue",
  "profile.curriculum.title": "Pays et profil scolaire",
  "profile.curriculum.description": "Ces paramètres sont utilisés pour adapter les matières, les niveaux de classe et les résultats de l'IA.",
  "profile.curriculum.success_title": "Profil mis à jour",
  "profile.curriculum.success_description": "Le pays, la région et le type d'école ont été enregistrés.",
  "profile.export_library_action": "Lancer l'exportation",
  "profile.export_library": "Exporter et télécharger la bibliothèque",
  "profile.export_library_description": "Cette fonctionnalité vous permet d'exporter tous les matériaux de votre bibliothèque et de les télécharger sur votre ordinateur.",
  "profile.export_library_tech_details": "Pour de grandes quantités de données, cet export peut prendre quelques minutes ou heures. Dès que l'export est prêt à être téléchargé, vous recevrez un e-mail. L'export peut être lancé une fois toutes les 12 heures seulement.",
  "profile.export_library_success": "Export lancé ! Vous recevrez un e-mail dès que vos données seront prêtes à être téléchargées.",
  "profile.delete_account.title": "Supprimer le compte",
  "profile.delete_account.description": "Supprimez définitivement votre compte Teachino. Toutes les intégrations seront déconnectées et les données de votre compte ne pourront pas être restaurées.",
  "profile.delete_account.action": "Supprimer le compte",
  "profile.delete_account.confirm_title": "Supprimer votre compte ?",
  "profile.delete_account.confirm_description": "Cette action est irréversible. Vos intégrations seront déconnectées, vous serez déconnecté(e) et vous recevrez un e-mail de confirmation.",
  "profile.delete_account.confirm_pro_license": "Votre licence Pro individuelle sera également résiliée lorsque vous supprimerez votre compte.",
  "profile.delete_account.confirm_instruction": "Pour confirmer, saisissez l'adresse e-mail affichée ci-dessous.",
  "profile.delete_account.email_mismatch": "L'adresse e-mail ne correspond pas.",
  "profile.delete_account.reason_question": "Pourquoi supprimez-vous votre compte ?",
  "profile.delete_account.reason_hint": "Votre réponse est facultative et nous aide à améliorer Teachino.",
  "profile.delete_account.reason.too_expensive": "Teachino est trop cher pour moi",
  "profile.delete_account.reason.missing_feature": "Il me manque une fonctionnalité",
  "profile.delete_account.reason.too_complicated": "Teachino est trop compliqué pour moi",
  "profile.delete_account.reason.no_time_or_not_needed": "Je n'ai pas le temps ou je n'en ai pas besoin",
  "profile.delete_account.reason.switched_to_other_tool": "Je suis passé(e) à un autre outil",
  "profile.delete_account.reason.privacy_concerns": "J'ai des préoccupations concernant la protection des données",
  "profile.delete_account.reason.duplicate_account": "J'ai déjà un autre compte Teachino",
  "profile.delete_account.reason.other": "Autre",
  "profile.delete_account.reason_text_label": "Souhaitez-vous nous dire autre chose ?",
  "profile.delete_account.reason_text_placeholder": "Votre avis (facultatif)",
  "profile.checklist.show": "Afficher à nouveau les conseils sur la page d’accueil",
  "profile.checklist.success": "La liste de conseils s’affichera à nouveau sur la page d’accueil",
  "profile.new_course_view": "Nouvel affichage du cours",
  "profile.new_course_view_description": "L'affichage des cours et la navigation sont en cours de refonte. Des fonctionnalités supplémentaires seront ajoutées dans les semaines à venir avant l'activation pour tous les utilisateurs.",
  "profile.you_can_enable_new_course_view": "Vous avez la possibilité d'activer cette fonctionnalité en avant-première ici.",
  "profile.activate_new_course_view": "Activer le nouvel affichage du cours",
  "profile.deactivate_new_course_view": "Désactiver le nouvel affichage du cours",
  "timetable.course_first_banner.title": "Une nouvelle structure pour votre enseignement",
  "timetable.course_first_banner.blog_link": "Lire tous les détails dans l'article de blog",
  "timetable.course_first_banner.enabled_state": "Le nouvel affichage du cours est activé. Vous pouvez revenir en arrière à tout moment.",
  "course_name": "Nom",
  "course_short_name": "Nom abrégé",
  "course_create_title": "Créer un nouveau cours",
  "course_create_success_title": "{{name}} créé!",
  "course_create_color": "Choisir une couleur",
  "course_create_char_limit_error": "Le nom du cours ne doit pas dépasser {{limit}} caractères",
  "course_create_short_name_char_limit_error": "Le nom abrégé ne doit pas dépasser {{limit}} caractères",
  "course_create_name_required": "Veuillez entrer un nom de cours.",
  "course_empty.title": "Aujourd'hui est un bon jour pour planifier votre cours.",
  "course_empty.description_1": "Créez votre première série et remplissez-la de matériels!",
  "course.empty_read_only": "Il n'y a pas de séries ou de matériels dans ce cours.",
  "course.plan": "Planification",
  "course.page.title": "Vos cours",
  "course.page.description": "Créez un cours pour chaque classe et matière que vous enseignez. Par exemple : \"8A Géographie\".",
  "library.recent_materials": "Dernièrement créé",
  "library.generic_materials": "Matériaux généraux",
  "library.generic_materials.description": "Tous les matériels qui ne sont assignés à aucune série",
  "library.topics.description.title": "Organisez les matériels en thèmes pour une meilleure vue d'ensemble.",
  "library.topics.description.description_1": "Pour cela, ouvrez un matériel et choisissez le thème approprié sous Détails.",
  "library.topics.description.description_2": "Les thèmes correspondent aux sections de l'année scolaire, par exemple un plus grand thème ou un chapitre.",
  "library.create_course.title_course": "Créer un nouveau cours",
  "library.create_course.title_template": "Créer une nouvelle collection",
  "library.create_course.title_from_template": "Créer un cours à partir d'une collection",
  "library.create_course.placeholder_name_course": "ex : 1A Mathématiques",
  "library.create_course.placeholder_short_name_course": "ex : 1AM",
  "library.create_course.placeholder_name_template": "Filière Géographie Année 1",
  "library.create_course.placeholder_short_name_template": "GEO1",
  "library.create_course.button_course": "Créer un nouveau cours",
  "library.create_course.button_template": "Créer une nouvelle collection",
  "library.new_items.empty_state.description": "Téléchargez des matériaux existants ou créez-en directement dans Teachino.",
  "library.items_selected_1": "1 Matériel",
  "library.items_selected_many": "{{number}} Matériels",
  "library.topics_selected_0": "0 Thèmes",
  "library.topics_selected_1": "1 Thème",
  "library.topics_selected_many": "{{number}} Thèmes",
  "library.new_items.empty_state.cta": "Créer du matériel",
  "library.all_topics.empty_state.title": "Aucun thème créé.",
  "library.all_topics.empty_state.description": "Vos matériels sont organisés en thèmes dans Teachino. Dès que vous créez un thème, il apparaît ici et peut être réutilisé dans chaque année scolaire et dans chaque classe parallèle.",
  "library.all_topics.empty_state.cta": "Créer un thème",
  "library.search.all_topics.no_results": "La recherche pour \"{{search}}\" n'a donné aucun résultat approprié",
  "library.my_topics": "Tous les thèmes",
  "library.unsorted_topics": "Thèmes non triés",
  "library.unsorted_topics.empty_state.title": "Performance propre ! 🧹🧽",
  "library.unsorted_topics.empty_state.description_0": "Vous n'avez pas de thèmes non triés.",
  "library.unsorted_topics.empty_state.description_1": "Nous aimons l'ordre et vous aussi, apparemment !",
  "library.topic_details.no_courses": "Ce thème n'est encore assigné à aucun cours.",
  "library.topic.cannot_bulk_delete.title": "Les chapitres n'ont pas pu être supprimés",
  "library.topic.cannot_bulk_delete.description": "Le thème \"{{topic}}\" ne peut pas être supprimé.",
  "library.topic.cannot_bulk_duplicate.title": "Les chapitres n'ont pas pu être dupliqués",
  "library.topic.cannot_bulk_duplicate.description": "Le thème \"{{topic}}\" ne peut pas être dupliqué.",
  "library.sort.default": "Tri personnalisé",
  "library.sort.created": "Par date de création",
  "library.sort.date": "Par date",
  "library.sort.alphabetically": "Alphabétiquement",
  "library.course.topics": "Thèmes dans {{courseName}}",
  "library.course.remove_topic": "retirer du cours",
  "course_settings.title": "Paramètres pour {{courseName}}",
  "course_settings.collaboration_title": "Inviter des collègues à {{courseName}}",
  "course_settings.collaboration_leave": "Gérer la participation",
  "course_settings.team_teaching": "Co-enseignement",
  "course_settings.invite_colleagues": "Inviter des collègues",
  "course_settings.ai_settings": "Paramètres IA pour {{courseName}}",
  "course_settings.all_settings": "Tous les paramètres",
  "course_settings.tabs.aria_label": "Sections des paramètres du cours",
  "course_settings.tabs.general.title": "Paramètres généraux",
  "course_settings.tabs.general.description": "Nom, apparence, collaboration et statut du cours",
  "course_settings.tabs.ai.title": "Paramètres IA",
  "course_settings.tabs.ai.description": "Contexte du cours et instructions IA supplémentaires",
  "course_settings.tabs.students.description": "Élèves, codes d'accès et groupes d'apprentissage",
  "course_settings.tabs.students.section_description": "Gérer les élèves et leurs codes d'accès",
  "course_settings.details.title": "Détails",
  "course_settings.details.sub_title": "Nom, nom abrégé, couleur, année scolaire",
  "course_settings.close_title": "Supprimer le cours",
  "course_settings.close_sub_title": "Supprimer le cours. Les matériaux restent disponibles pour les années scolaires suivantes.",
  "course_settings.close_title_template": "Supprimer la collection",
  "course_settings.close_description": "Le cours n'est plus montré pour la planification. Les matériaux restent accessibles via l'entrée de menu \"Cours supprimés\" dans la bibliothèque.",
  "course_settings.close_description_template": "La collection sera supprimée et tous les membres perdront l'accès. Les thèmes & matériels utilisés dans les cours restent disponibles.",
  "course_settings.close_warning": "Supprimer \"{{courseName}}\" ?",
  "course_settings.close_button": "Supprimer le cours",
  "course_settings.close_button_template": "Supprimer la collection",
  "course_settings.close.success_title": "Cours supprimé",
  "course_settings.close.success_description": "Le cours \"{{courseName}}\" a été supprimé.",
  "course_settings.collaboration.title": "Collaborer",
  "course_settings.collaboration.sub_title": "Collaborer avec d'autres enseignants",
  "course_settings.collaboration.description_1": "Enseigner est plus amusant ensemble ! Invitez vos collègues à partager des matériaux et planifier des cours ensemble !",
  "course_settings.collaboration.invite.title": "Inviter des collègues à {{courseName}}",
  "course_settings.collaboration.invite.cta": "Inviter des collègues",
  "course_settings.collaboration.invite.description": "Choisissez les permissions que votre collègue doit recevoir.",
  "course_settings.collaboration.invite.access.read_only": "Lecture seule",
  "course_settings.collaboration.invite.access.read_only_description": "Peut voir le cours et copier les supports, mais ne peut pas les modifier.",
  "course_settings.collaboration.invite.access.write": "Écriture",
  "course_settings.collaboration.invite.access.write_description": "Peut modifier les supports partagés du cours et collaborer directement dans le cours.",
  "course_settings.collaboration.invite.role_title": "Inviter {{roleName}} à {{courseName}}",
  "course_settings.collaboration.invite.link.title": "Envoyer un lien d'invitation",
  "course_settings.collaboration.invite.link.description": "Copiez le lien et envoyez-le aux collègues avec qui vous souhaitez collaborer. Le lien reste valable 7 jours.",
  "course_settings.collaboration.invite.search.title": "Chercher un collègue",
  "course_settings.collaboration.invite.search.description": "Les enseignants ayant la même licence scolaire peuvent être invités directement.",
  "course_settings.collaboration.invite.search.cta": "Inviter",
  "course_settings.collaboration.invite.search.placeholder": "Entrez un nom pour chercher",
  "course_settings.collaboration.invite.search.success": "Collègue ajouté au cours.",
  "course_settings.collaboration.leave.cta": "Quitter la collaboration",
  "course_settings.collaboration.teachers": "Enseignants dans {{courseName}}",
  "course_settings.collaboration.role.owner": "Créateur",
  "course_settings.collaboration.role.teacher": "Éditeur",
  "course_settings.collaboration.role.teacher_description": "Peut éditer les matériaux de tous les membres et dupliquer dans sa propre bibliothèque.",
  "course_settings.collaboration.role.co_teacher": "Co-éditeur",
  "course_settings.collaboration.role.co_teacher_description": "Peut ajouter et éditer ses propres matériaux. Peut dupliquer tous les thèmes et matériaux dans sa propre bibliothèque.",
  "course_settings.collaboration.role.guest": "Invité",
  "course_settings.collaboration.role.guest_description": "Peut voir les thèmes et matériaux et les dupliquer dans sa propre bibliothèque.",
  "course_settings.collaboration.role.sub_teacher": "Remplaçant",
  "course_settings.collaboration.remove_teacher": "Retirer un collègue",
  "course_settings.collaboration.remove_teacher_description": "{{collaboratorName}} ne peut plus accéder à {{courseName}}.",
  "course_settings.collaboration.remove_myself": "Quitter la collaboration",
  "course_settings.collaboration.remove_myself_description": "Vous perdez l'accès à {{courseName}} et aux matériaux stockés là-bas.",
  "course_settings.collaboration.member_since": "Membre depuis le {{date}}",
  "course_invite.title": "{{courseOwner}} vous invite à collaborer.",
  "course_invite.description": "Avec Teachino, vous pouvez rassembler vos matériaux en un seul endroit et planifier les cours ensemble.",
  "course_invite.accept": "Accepter l'invitation",
  "course_invite.signup_accept": "Créer un compte & Accepter l'invitation",
  "course_invite.login_accept": "Connectez-vous & Accepter l'invitation",
  "course_invite.already_member": "Partagez le lien de cette page avec vos collègues pour planifier ensemble les cours.",
  "course_invite.open_course": "Ouvrir le cours",
  "course_invite.open_collection": "Ouvrir la collection",
  "course_invite.expired": "Ce lien a expiré.",
  "course_invite.expired_call_to_action": "Veuillez demander à {{courseOwner}} un nouveau lien.",
  "tenant_invite.title": "La plateforme pédagogique qui réfléchit avec vous.",
  "tenant_invite.description": "Ressources, planification, apprentissage interactif et documentation au même endroit – reliés par un assistant IA qui réfléchit avec vous et vous accompagne.",
  "tenant_invite.accept": "Accepter l'invitation",
  "tenant_invite.signup_accept": "Créer un compte et accepter l'invitation",
  "tenant_invite.login_accept": "Se connecter et accepter l'invitation",
  "tenant_invite.already_member": "Vous êtes déjà membre de cette école.",
  "tenant_invite.continue": "Continuer vers Teachino",
  "tenant_invite.expired": "Ce lien d'invitation a expiré.",
  "tenant_invite.expired_call_to_action": "Veuillez demander à {{tenantName}} un nouveau lien.",
  "course_plan.create_topic": "Créer un nouveau thème",
  "course_plan.create_material_in_topic": "Créer un nouveau matériel dans {{topicName}}",
  "course_plan.add_topic": "Ajouter un thème",
  "course_plan.add_from_library": "Ajouter un thème depuis la bibliothèque",
  "course_plan.unorganised_topic": "Non trié",
  "course_plan.unorganised_topic_help": "Les matériaux non assignés à un thème apparaissent ici. Déplacez ces matériaux dans un thème afin de pouvoir les réutiliser dans la bibliothèque.",
  "create_item.confirm_delete_snippet": "Le matériel ne sera pas sauvegardé !",
  "course_plan.manage_content_button": "Ouvrir la planification annuelle",
  "course_plan.open_library": "Ouvrir la bibliothèque",
  "course_plan.empty_state_1": "Commencez la planification",
  "course_plan.empty_state_2": "Cliquez sur \"Créer du matériel\" pour planifier cette leçon, ou choisissez des matériaux dans la bibliothèque.",
  "course_plan.primary_note.title": "Note pour cette leçon",
  "course_plan.primary_note.mobile.button_empty": "Appuyez ici pour noter les éléments administratifs concernés uniquement par cette leçon.",
  "course_plan.primary_note.mobile.button_with_text": "Éditer",
  "course_plan.items.title": "Matériaux de la leçon",
  "course_plan.drag_drop_tutorial": "Faites glisser les matériaux ici pour les ajouter à la leçon",
  "emoji.skin.2": "2",
  "emoji.skin.3": "3",
  "emoji.skin.4": "4",
  "emoji.skin.5": "5",
  "emoji.skin.6": "6",
  "emoji.remove": "Retirer le symbole",
  "action": "Actions",
  "error_page.title": "Quelque chose s'est mal passé",
  "error_page.title_404": "Page non trouvée",
  "error_page.button": "Retour à la page d'accueil",
  "public.nav.teacher_info": "Voici à quoi ressemble {{name}} du point de vue de vos écoliers. Envoyez-leur le lien vers cette page et ils pourront accéder aux matériels immédiatement.",
  "public.nav.teacher_cta": "Copier le lien & envoyer aux écoliers",
  "public.empty_content.teacher": "Aucun matériel n'est encore visible pour les écoliers. Ouvrez un thème. Vous pouvez y débloquer les matériaux individuellement pour les écoliers.",
  "public.empty_content.student": "Votre enseignant n'a pas encore débloqué de matériels pour vous.",
  "public.empty_material.student": "Ce matériel est encore vide. Dès que votre enseignant ajoutera du contenu, vous le verrez ici.",
  "public.hidden_material.student.title": "Ce matériel n'est pas encore visible pour vous.",
  "public.hidden_material.student.description": "Dès que votre enseignant le débloquera, il apparaîtra dans l'aperçu du cours.",
  "public.logged_in_as": "Vous éditez le matériel en tant que {{studentNickname}}. Ce n'est pas vous ? Cliquez ici pour vous déconnecter.",
  "public.all_header": "Tous les matériels débloqués",
  "public.recently_shared": "Partagés récemment",
  "student_course.empty.title": "Pas encore de matériel",
  "student_course.empty.description": "Ton enseignant n’a encore rien partagé avec toi. Reviens plus tard.",
  "library.empty": "Il n'y a pas encore de matériels dans votre bibliothèque.",
  "library.success_toast": "Thème ajouté au cours !",
  "library.topic_count_0": "Aucun thème",
  "library.topic_details.empty_state": "Remplissez le thème de matériels",
  "library.topic.move_to_folder": "Déplacer dans un dossier",
  "library.topic.move_to_folder.modal.move_one_description": "Déplacer \"{{topic}}\"",
  "library.topic.move_to_folder.modal.move_many_description": "Déplacer {{number}} thèmes",
  "library.topic.move_to_folder.modal.confirm": "Déplacer vers \"{{folder}}\"",
  "library.topic.move_to_folder.toast.success": "Thème déplacé avec succès",
  "library.topic.copy_to_folder": "Dupliquer dans un dossier",
  "library.topic.copy_to_folder.modal.move_one_description": "Dupliquer \"{{topic}}\"",
  "library.topic.copy_to_folder.modal.move_many_description": "Dupliquer {{number}} thèmes",
  "library.topic.copy_to_folder.modal.confirm": "Dupliquer vers \"{{folder}}\"",
  "library.topic.copy_to_folder.toast.success": "Thème dupliqué avec succès",
  "library.topic.rename.toast.success": "Thème renommé",
  "library.folder.rename.toast.success": "Dossier renommé",
  "library.folder.feature_description": "Organisez les thèmes en dossiers",
  "library.topic.goals_updated.toast.success": "Objectifs d'apprentissage et compétences enregistrés",
  "library.topic.goals.empty_button": "Entrer les objectifs d'apprentissage et les compétences",
  "library.topic.add_to_course": "Ajouter au cours",
  "library.topics.add_to_courses.bulk.description": "{{count}} dossiers seront ajoutés aux cours que vous sélectionnez.",
  "library.topics.add_to_courses.toast.success": "Dossiers ajoutés aux cours",
  "library.topic.courses_school_year_filter": "Année scolaire {{schoolYear}}",
  "library.topic.create_with_name": "Créer le nouveau thème {{name}}",
  "library.topic.create.title": "Créer un nouveau thème",
  "library.topic.create.label": "Nom du thème",
  "library.topic.create.button": "Créer le thème",
  "library.topic.create.hints": "Théorème de Pythagore",
  "library.topic.create.error": "Veuillez entrer un nom pour le thème.",
  "library.topic.create.description": "Les thèmes sont des unités thématiques, comme les chapitres d'un manuel.<br />Dans l'étape suivante, vous pouvez ajouter des matériaux au thème.",
  "library.topic.create.examples": "<strong>Exemples :</strong> \"Théorème de Pythagore\", \"Changement climatique\", \"Simple Past\"",
  "library.create_topic.empty_state.title": "Créez votre premier thème maintenant ! 📚📝",
  "library.create_topic.empty_state.description": "Avec Teachino, vous structurez vos matériaux en thèmes. Les thèmes servent d'unités thématiques supérieures, par exemple, les chapitres d'un manuel",
  "library.create_topic.empty_state.input_placeholder": "ex : \"Formation des glaciers\" ou \"Introduction au théorème de Pythagore\"",
  "library.show_archived_courses": "Afficher les cours supprimés",
  "library.hide_archived_courses": "Masquer les cours supprimés",
  "library.archived_courses_empty": "Les cours dont vous n'avez plus besoin peuvent être supprimés, par exemple à la fin de l'année scolaire. Ces cours apparaissent ici afin que vous puissiez toujours accéder aux matériels.",
  "library.templates_empty": "Vous pouvez organiser des matériaux dans des collections et les éditer ensemble avec des collègues.",
  "library.courses_empty": "Créez un premier cours pour commencer avec Teachino.",
  "library.add_from_library": "Ajouter un thème depuis la bibliothèque",
  "library.add_from_library_closed_courses": "Cours supprimés",
  "library.add_from_library_closed_courses_empty": "Les cours des années scolaires précédentes apparaîtront ici.",
  "library.add_from_library.header": "{{number}} thèmes trouvés",
  "library.add_from_library.show_all": "Tous les thèmes",
  "library.add_from_library.empty_title": "Aucun thème trouvé",
  "library.add_from_library.empty_description": "Aucun thème approprié n'a été trouvé dans la bibliothèque. Vous pouvez en créer un nouveau à la place.",
  "library.duplicate_item.title": "Dupliquer le matériel",
  "library.move_item.title": "Déplacer le matériel",
  "library.move_item.warning_title": "Attention : Les données peuvent être perdues !",
  "library.move_item.warning_description": "Si ce matériel a déjà été planifié dans un cours, l'association au cours et aux heures d'enseignement sera perdue !",
  "library.move_item.warning_description_many": "Si les matériaux ont déjà été planifiés dans un cours, l'association au cours et aux heures d'enseignement sera perdue !",
  "library.duplicate_item.new_name": "Nouveau nom",
  "library.duplicate_item.new_topic": "Nouveau thème",
  "library.duplicate_item.new_name_prefix": "Copie de",
  "library.duplicate_item.success": "Le matériel a été dupliqué",
  "library.duplicate_topic.title": "Dupliquer le thème",
  "library.duplicate_topic.course": "Nouveau cours / Nouvelle collection",
  "library.duplicate_topic.success": "Le thème a été dupliqué.",
  "library.template.create_from_template.tooltip": "Un nouveau cours est créé, contenant tous les thèmes, matériaux et réglages de cette collection.",
  "library.no_topics.empty_state.title": "Organisation pour vos matériaux",
  "library.no_topics.empty_state.description": "Dans la bibliothèque, vous pouvez organiser les matériaux et les plans de cours en thèmes. Créez un premier thème pour commencer.",
  "library.folder_tree.empty_state.description": "Les dossiers offrent un niveau d'organisation supplémentaire pour organiser vos thèmes",
  "library.folder_tree.empty_state.cta": "Créer un dossier",
  "library.folder.empty_state.title": "Dossier vide",
  "library.folder.empty_state.description": "\"{{folder}}\" ne contient pas encore de thèmes. Créez-en un nouveau ou déplacez un thème existant dans ce dossier.",
  "library.folder.create": "Créer un dossier",
  "library.folder.name.label": "Nom du dossier",
  "library.folder.delete": "Supprimer le dossier",
  "library.folder.delete.folder_not_empty": "Seuls les dossiers vides peuvent être supprimés.",
  "library.folder.delete.please_delete_subfolders": "Veuillez retirer tous les sous-dossiers et thèmes de \"{{folder}}\"",
  "library.folder.delete.are_you_sure": "Supprimer vraiment le dossier \"{{folder}}\" ? Cette action ne peut pas être annulée.",
  "library.folder.rename": "Renommer le dossier",
  "library.folder.convert_to_template": "Convertir en collection",
  "library.folder.add_to_course": "Ajouter au cours",
  "library.folder.add_to_courses.description": "Toutes les séquences et tous les supports du dossier « {{folder}} », y compris les sous-dossiers ({{count}} séquences), seront ajoutés aux cours que vous sélectionnez.",
  "library.folder.convert_to_template.description": "Cela crée une nouvelle collection contenant une copie de toutes les séquences et de tous les supports de ce dossier.",
  "library.folder.convert_to_template.name.label": "Nom de la collection",
  "library.folder.convert_to_template.cta": "Créer la collection",
  "library.folder.convert_to_template.toast.success": "Collection créée",
  "library.collection.create_from_topics.button": "Créer une collection",
  "library.collection.create_from_topics.title": "Créer une collection",
  "library.collection.create_from_topics.description": "{{count}} unités seront copiées comme dossiers distincts dans une collection. L’arborescence des dossiers de la bibliothèque n’est pas conservée.",
  "library.collection.create_from_topics.name.label": "Nom de la collection",
  "library.collection.create_from_topics.cta": "Créer la collection",
  "library.collection.create_from_topics.toast.success": "Collection créée",
  "library.collection.create_from_topics.no_eligible_topics": "Sélectionnez au moins une unité. Les matériels génériques ne peuvent pas être ajoutés à une collection.",
  "collection.add_content_menu.import_material": "Ajouter depuis un cours",
  "collection.edit": "Modifier la collection",
  "collection.rename": "Renommer la collection",
  "collection.name_description": "Quel nom donner à la collection ?",
  "collection.archive": "Supprimer la collection",
  "collection.archive_description": "La collection sera supprimée et tous les membres perdront l'accès. Les thèmes & matériels utilisés dans les cours restent disponibles.",
  "collection.archived_toast": "Collection supprimée. La collection « {{collectionName}} » a été supprimée.",
  "navigation.collections": "Collections",
  "collections.my_title": "Mes collections",
  "collections.shared_title": "Partagées avec moi",
  "collections.create": "Créer une collection",
  "collections.my.empty_title": "Pas encore de collections",
  "collections.my.empty_description": "Créez votre première collection pour partager des séquences et des supports avec des collègues et les réutiliser dans vos cours.",
  "collections.shared.empty_title": "Aucune collection partagée",
  "collections.shared.empty_description": "Les collections auxquelles des collègues vous invitent apparaîtront ici.",
  "collections.owner_you": "Vous",
  "collection.name_and_gradient": "Nom et apparence",
  "collection.gradient.regenerate": "Régénérer",
  "template.sync.success": "Synchronisation réussie !",
  "template.sync.error": "Échec de la synchronisation.",
  "library.file_upload.choose_files": "Choisir des fichiers",
  "library.file_upload.drag_here": "Glissez les fichiers ici ou",
  "library.file_upload.error": "Le fichier n'a pas pu être téléchargé.",
  "features.timetable.lesson": "Cours",
  "features.timetable.page_timetable": "Emploi du temps",
  "features.timetable.no_course": "Aucun cours disponible pour créer un emploi du temps.",
  "features.timetable.info_text_block": "Utilisez ce formulaire si vous avez des cours à différentes heures les différents jours.",
  "features.timetable.empty_state": "Ajouter une unité de cours",
  "features.timetable.row.label_course": "Cours",
  "features.timetable.row.label_day_of_week": "Jour",
  "features.timetable.row.label_from": "de",
  "features.timetable.row.label_to": "à",
  "features.timetable.row.label_remove": " ",
  "features.timetable.failed_save": "L'emploi du temps est incorrect.",
  "course_create_topic_placeholder": "Saisir un nouveau thème",
  "course_plan_now": "Planifier",
  "topic.name": "Nom du thème",
  "topic.action.edit": "Éditer le thème",
  "topic.action.sort": "Trier le thème",
  "topic.lesson_goals": "Objectifs d'apprentissage & compétences",
  "topic.lesson_goals.placeholder": "Écrire quelque chose ...",
  "topic.lesson_goals_title": "Objectifs d'apprentissage & compétences pour {{topicName}}",
  "topic.lesson_goals_description": "L'IA peut générer de nouveaux objectifs ou optimiser votre texte. Lorsque vous créez des matériaux pour {{topicName}} avec l'IA, ces objectifs et compétences seront inclus.",
  "topic.lesson_goals_placeholder": "Les écoliers peuvent ...",
  "topic.dates_title": "Période de {{topicName}}",
  "topic.dates_description": "Ici, vous pouvez indiquer quand le thème sera enseigné dans chaque cours. Lorsque vous créez de nouveaux matériels dans le thème, ceux-ci seront automatiquement disponibles dans chaque cours.",
  "topic.delete": "Supprimer le thème et les matériaux",
  "topic.read_only": "🔒 Ce thème ne peut pas être édité par vous. Vous pouvez dupliquer les matériaux dans votre bibliothèque et les éditer là.",
  "course.print": "Imprimer",
  "course.settings": "Paramètres",
  "course.settings_ai": "Paramètres IA",
  "course.search": "Rechercher dans {{courseName}}",
  "course.search.empty": "Aucun matériel correspondant trouvé dans le cours",
  "course.search.empty_description": "Vous souhaitez ajouter des matériaux de la bibliothèque au cours ? Alors sélectionnez \"Ajouter\" en haut à droite > \"Ajouter depuis la bibliothèque\".",
  "topic_instance.all_topics": "Tous les thèmes",
  "topic_instance.current_topics": "Actuel",
  "topic_instance.current_topics_tooltip": "Tous les thèmes qui, selon la planification annuelle, correspondent au jour de l'enseignement. Vous pouvez ajuster les données dans la bibliothèque.",
  "topic_instance.create.create_topic": "Thème",
  "topic_instance.create.create_topic_save": "Créer",
  "topic_instance.create.add_to_multiple_courses_closed": "Ajouter à plusieurs cours",
  "topic_instance.create.add_to_course_0": "Ajouter à un cours",
  "topic_instance.create.add_to_course_1": "Ajouter à un cours",
  "topic_instance.create.add_to_course_many": "Ajouter à {{number}} cours",
  "topic_instance.create.add_to_course_with_name": "Ajouter à {{course}}",
  "topic_instance.create.add_to_course_disabled": "Ajouter à un cours",
  "topic_instance.add_course_modal.title": "Ajouter le thème au cours",
  "topic_instance.add_course_modal.description": "Choisir les cours auxquels {{topic}} doit être ajouté :",
  "topic_instance.no_items": "Aucun matériel",
  "topic_instance.show_all_items": "Déployer tous les {{number}} matériaux",
  "topic_instance.show_all_items_short": "Déployer les matériaux",
  "topic_summary_item_0": "Aucun matériel",
  "topic_summary_item_1": "1 Matériel",
  "topic_summary_item_many": "{{number}} Matériels",
  "topic_instance.empty": "Créer des matériaux pour {{topicName}} avec vos matériaux ou inspirez-vous de l'IA.",
  "item.tooltip.past_dates": "Enseigné le : {{dates}}",
  "item.tooltip.future_dates": "Prévu pour : {{dates}}",
  "item.tooltip.single_snippet": "un bloc",
  "item.tooltip.double_snippets": "deux blocs",
  "item.tooltip.multiple_snippets": "plusieurs blocs",
  "item.menu.make_visible": "Afficher pour les élèves",
  "item.menu.make_not_visible": "Cacher pour les élèves",
  "item.menu.hidden_for_class": "Caché pour les écoliers",
  "item.menu.visible_for_class": "Visible pour les écoliers",
  "item.menu.item_made_visible": "Le matériel est maintenant visible par les écoliers",
  "item.menu.item_made_not_visible": "Le matériel n'est plus visible par les écoliers",
  "item.menu.edit_item": "Renommer le matériel",
  "item.name": "Nom",
  "item_add_placeholder": "Taper un nouveau matériel pour \"{{topicName}}\"",
  "page_title_reset_password": "Réinitialiser le mot de passe",
  "page_title_verify_password": "Confirmer le mot de passe",
  "page_title_login": "Se connecter",
  "page_title_logout": "Se déconnecter",
  "page_title_signup": "S'inscrire",
  "page_title_signup_masterdata": "Finaliser l'inscription",
  "page_title_verify_email": "Confirmer l'e-mail",
  "page_title_course_settings": "Paramètres",
  "page_title_course_create": "Créer un cours",
  "calendar_week": "Semaine civile",
  "add_note_error": "La note n'a pas pu être créée",
  "edit_note_error": "La note n'a pas pu être enregistrée",
  "remove_note_error": "La note n'a pas pu être retirée",
  "note_placeholder": "Entrer une note",
  "weekday_date_picker_reader_text": "Choisir une date",
  "weekday_menu_note": "Note",
  "weekday_move_to": "Déplacer à {{date}}",
  "note_empty_error": "Veuillez ajouter un peu de matériel à votre note",
  "offline_mode": "Mode hors ligne",
  "online_mode": "En ligne",
  "back_online": "Vous êtes de nouveau en ligne !",
  "offline_text": "Vous êtes hors ligne, la fonctionnalité est limitée.",
  "today": "Aujourd'hui",
  "view_menu_options": "Afficher les options de menu",
  "item_detail.planned_on": "Planifié le",
  "item_detail.planned": "Planification",
  "item_detail.not_planned": "Pas encore planifié",
  "item_detail.title_empty": "Veuillez entrer un titre.",
  "item_detail.title_heading": "Modifier le nom",
  "item_detail.duration_heading": "Durée",
  "item_detail.duration_description": "Dans ce champ, vous pouvez indiquer en minutes le temps prévu pour ce matériel en classe.",
  "item_detail.duration.error_le_0": "La durée minimale est d'une minute",
  "item_detail.add_duration": "Ajouter une durée",
  "item_detail.edit_duration": "Modifier la durée",
  "item_detail.remove_duration": "Supprimer la durée",
  "item_detail.banner.template": "Ce matériel se trouve dans une collection.",
  "item_detail.banner.course_only": "Ce matériel n'est disponible que dans ce cours car il a été lié à un carnet de notes de cours.",
  "item_detail.empty_snippet_list": "Aucun matériel n'a encore été téléchargé pour ce matériel.",
  "item_detail.tag.course_only": "Carnet de classe",
  "item_detail.tag.course_only_description": "Ce matériel n'est pas disponible dans la bibliothèque car il a été lié au carnet de notes de classe de ce cours.",
  "item_detail.new_snippet": "Ajouter un nouveau bloc",
  "item_detail.new_snippet_text_heading": "Nouveau texte",
  "item_detail.edit_snippet_text_heading": "Éditer le texte",
  "item_detail.new_snippet_note_heading": "Nouvelle note",
  "item_detail.edit_snippet_note_heading": "Éditer la note",
  "item_detail.new_snippet_link_url_heading": "Nouveau lien",
  "item_detail.edit_snippet_link_url_heading": "Éditer le lien",
  "item_detail.new_snippet_link_title_heading": "Nom du lien",
  "item_detail.snippet_text": "Texte",
  "item_detail.snippet_link": "Lien",
  "item_detail.snippet_note": "Note",
  "item_detail.snippet_file": "Fichier",
  "item_detail.snippet_file_choose": "Choisir un fichier",
  "item_detail.snippet_external_file": "OneDrive",
  "item_detail.snippet_image": "Image",
  "item_detail.snippet_ai": "IA",
  "item_detail.snippet_external_content_class_notes": "Note de classe",
  "item_detail.snippet_external_content_notes": "OneNote",
  "item_detail.snippet_external_content_file": "OneDrive",
  "item_detail.snippet_link.link_placeholder": "Entrer le lien",
  "item_detail.snippet_link.title_placeholder": "Nom (Optionnel)",
  "item_detail.snippet_text_description": "Explications, références au manuel scolaire",
  "item_detail.snippet_link_description": "vers des sites web, vidéos, fichiers cloud",
  "item_detail.snippet_note_description": "Notes privées, instructions didactiques, non visibles par les écoliers",
  "item_detail.snippet_file_description": "Feuilles de travail, présentations, images …",
  "item_detail.snippet_external_file_description": "Lier des fichiers et dossiers",
  "item_detail.snippet_image_description": "Photos, graphiques",
  "item_detail.snippet_ai_description": "Générer des questions, objectifs d'apprentissage, glossaire, etc. avec l'IA",
  "item_detail.minute_0": "Minutes",
  "item_detail.minute_1": "Minute",
  "item_detail.minute_many": "Minutes",
  "item_detail.snippet_include_link_preview": "Intégrer un aperçu de lien",
  "item_detail.note_warning": "Seulement visible par les enseignants",
  "item_detail.confirm_delete_item_pre": " ",
  "item_detail.confirm_delete_item_post": "et supprimer tous les blocs associés ?",
  "item_detail.force_delete_text_pre": "Ce matériel a été planifié dans les cours suivants :",
  "item_detail.force_delete_text_post": "Voulez-vous tout de même le supprimer ?",
  "item_detail.file_upload_message": "Vous pouvez glisser-déposer des fichiers ici ou",
  "item_detail.image_upload_message": "Vous pouvez glisser-déposer des images ici ou",
  "item_detail.file_upload_button_text": " sélectionner",
  "item_detail.file_upload_processing": "Les fichiers sont en cours de téléchargement",
  "item_detail.file_upload_success": "Téléchargé avec succès",
  "item_detail.maximum_file_label": "Taille max : {{fileSize}}",
  "item_detail.file_unacceptable_type": "Type de fichier non accepté",
  "item_detail.file_too_large": "Fichier trop grand",
  "item_detail.file_empty": "Les fichiers vides ne peuvent pas être téléchargés.",
  "item_detail.file_changed": "Les dessins ne sont pas enregistrés. Veuillez les utiliser uniquement pour la présentation !",
  "item_detail.file_start_edit_mode": "Dessiner",
  "item_detail.file_download": "Télécharger le fichier",
  "item_detail.delete_snippet_title": "Supprimer le bloc",
  "item_detail.delete_snippet_description": "Voulez-vous vraiment supprimer ce bloc ?",
  "item_detail.delete_snippet_description_dynamic": "Êtes-vous sûr de vouloir supprimer {{name}} ?",
  "item_detail.delete_snippet_warning": "Cette action ne peut pas être annulée.",
  "item_detail.add_to_lesson": "Ajouter à la leçon",
  "item_detail.remove_from_lesson": "Retirer de la leçon",
  "item_detail.added_to_lesson": "Ajouté à la leçon",
  "item_detail.presentation": "Présenter",
  "item_detail.add_material": "Ajouter des matériaux",
  "item_detail.edit_details": "Éditer les détails",
  "item_detail.back_to_content": "Retour au matériel",
  "item_detail.add_description": "Ajouter une description",
  "delete_topic.delete_message_pre": "Voulez-vous",
  "delete_topic.delete_message_post": "supprimer de ce cours ? Le thème et les matériaux restent disponibles dans la bibliothèque.",
  "delete_topic.delete_button": "Supprimer",
  "course_students.share.title": "Écoliers",
  "course_students.share.sub_title": "Partager l'accès à Teachino avec les écoliers via un lien ou un code QR",
  "course_students.share.description": "Ce lien peut être partagé avec les écoliers (ou les parents).",
  "course_students.share.create_link": "Créer un lien.",
  "course_students.share.show_qr_code": "QR-Code et lien",
  "course_students.preview.description": "Les écoliers ne voient que les matériaux que vous avez partagés avec eux. Vous les reconnaîtrez par le symbole œil.",
  "course_students.preview.description_2": "Les notes ne peuvent pas être vues par les écoliers.",
  "course_students.share.expiration": "Ce lien est valable pour toute l'année scolaire.",
  "course_students.share.generate_new": "Révoquer le lien",
  "course_students.share.invalidate.confirm_title": "Lien bloqué",
  "course_students.share.invalidate.confirm_description": "Ce lien ne peut plus être utilisé. Vous pouvez ensuite créer un nouveau lien et le partager.",
  "course_students.share.invalidate.description": "Ce lien est invalide. Veuillez demander un nouveau lien à votre enseignant.",
  "course_students.share_link": "Vue élève",
  "course_students.mapping_not_unique_title": "Plusieurs cours Teachino disponibles pour cet enseignement.",
  "course_students.mapping_not_unique_description": "Quel cours souhaitez-vous ouvrir ?",
  "course_students.share_item.title": "Partager le matériel avec les écoliers",
  "course_students.share_item.description_not_visible": "Dès que vous débloquez le matériel, vous pouvez partager un QR-Code ou un lien avec vos écoliers. De plus, vos écoliers verront alors le matériel dans la vue élève.",
  "course_students.share_item.description": "Scannez le code ou copiez le lien",
  "course_students.share_item.make_visible": "Débloquer",
  "course_students.preview.header": "Partagez ce lien avec vos écoliers",
  "course_students.preview.preview": "Aperçu",
  "course_students.preview.preview_description": "Voici à quoi ressemble le cours pour vos écoliers",
  "course_students.access_cards.print_filename_all_students": "Tous les élèves",
  "course_students.accounts.title": "Élèves",
  "course_students.accounts.loading": "Chargement des élèves",
  "course_students.accounts.empty": "Aucun élève ajouté pour l’instant",
  "course_students.accounts.empty_connect_webuntis": "Veuillez connecter votre cours à WebUntis pour importer des élèves.",
  "course_students.accounts.table.name": "Nom",
  "course_students.accounts.table.code": "Code",
  "course_students.accounts.table.last_active": "Dernière activité",
  "course_students.privacy_banner.message": "Les données personnelles des élèves ne peuvent être saisies qu'après la conclusion d'un contrat de traitement des données (AVV). D'ici là, tu peux faire des essais avec les élèves de test 01-30.",
  "course_students.privacy_banner.austria_message": "Pour utiliser les données des élèves en Autriche, connecte-toi via le Bildungsportal (BIP). Sinon, la direction de ton école peut signer le contrat de traitement des données.",
  "course_students.privacy_banner.connect_bip": "Se connecter avec BIP",
  "course_students.privacy_banner.sign": "Faire signer le contrat AVV par la direction de l'école",
  "course_students.privacy_banner.learn_more": "En savoir plus",
  "course_students.privacy_banner.read_more": "Lire la suite",
  "course_students.accounts.table.no_activity": "Aucune activité pour l’instant",
  "course_students.accounts.table.qr": "QR",
  "course_students.accounts.actions.open_qr": "Ouvrir le QR",
  "course_students.accounts.actions.show_code": "Afficher le code",
  "course_students.accounts.actions.print_code": "Imprimer le code",
  "course_students.accounts.actions.regenerate_code": "Régénérer le code",
  "course_students.accounts.actions.delete": "Supprimer",
  "course_students.accounts.actions.print_all": "Tous les élèves",
  "course_students.accounts.actions.add_students": "Ajouter des élèves",
  "course_students.accounts.actions.copy_access_link": "Copier le lien d'accès",
  "course_students.accounts.actions.print_access_code": "Imprimer le code d'accès",
  "course_students.accounts.actions.rename": "Renommer l'élève",
  "course_students.accounts.actions.print_codes": "Imprimer les codes d'accès",
  "course_students.accounts.actions.manage_groups": "Gérer les groupes d'apprentissage",
  "course_students.accounts.actions.assign_groups": "Attribuer",
  "course_students.accounts.import.title": "Synchroniser avec {{integration}}",
  "course_students.accounts.import.description": "Importer les élèves de {{course}}. Les élèves existants restent inchangés.",
  "course_students.accounts.import.action": "Synchroniser les élèves",
  "course_students.accounts.import.created": "{{count}} nouveaux élèves importés depuis {{integration}}.",
  "course_students.accounts.import.no_new": "Aucun nouvel élève n'a été trouvé dans {{integration}}.",
  "course_students.accounts.import.provider_error": "Impossible de charger les élèves depuis {{integration}}. Veuillez réessayer.",
  "course_students.accounts.import.provider_error_eduplaces": "Impossible de charger les élèves depuis {{integration}}. Veuillez réessayer. L'accès aux données des élèves doit être activé par l'école.",
  "course_students.accounts.import.error": "Les élèves n'ont pas pu être synchronisés avec {{integration}}.",
  "course_students.accounts.import.source_tag": "De {{integration}}",
  "course_students.accounts.import.new_available": "{{count}} nouveaux élèves peuvent être importés.",
  "course_students.accounts.import.auto_failed": "Le cours a été connecté, mais les élèves n'ont pas pu être importés automatiquement. Relance la synchronisation sous \"Modifier le cours\" > \"Gérer les élèves\".",
  "course_students.accounts.import.license_missing_title": "Import des élèves non disponible",
  "course_students.accounts.import.license_missing_description": "Votre école a besoin d'une licence scolaire Teachino incluant les comptes élèves pour importer automatiquement les élèves depuis l'intégration connectée. Contactez votre direction ou Teachino.",
  "course_students.accounts.import.license_missing_toast": "Le cours a été connecté. Les élèves n'ont pas été importés : votre école a besoin d'une licence scolaire Teachino incluant les comptes élèves.",
  "course_students.accounts.student_code.title": "Accès pour {{studentName}}",
  "course_students.accounts.add_students.description": "Saisissez les noms des élèves – écrivez un nom par ligne.",
  "course_students.accounts.add_students.name_too_long": "Un nom d'élève peut comporter au maximum {{maxLength}} caractères.",
  "course_students.accounts.add_students.placeholder": "Anna\nBoris\nChris\n...",
  "course_students.accounts.add_students.test_students_intro": "Ces accès de test seront créés :",
  "course_students.accounts.add_students.test_students_kept": "Les élèves déjà présents ({{count}}) restent inchangés : leurs codes d’accès et leurs données ne changent pas.",
  "course_students.accounts.add_students.create_count_one": "Créer {{count}} accès",
  "course_students.accounts.add_students.create_count_many": "Créer {{count}} accès",
  "course_students.accounts.delete_student.title": "Supprimer l'élève",
  "course_students.accounts.delete_student.confirm": "Voulez-vous vraiment supprimer « {{studentName}} » ?",
  "course_students.accounts.data_footprint.answers_one": "{{count}} réponse",
  "course_students.accounts.data_footprint.answers_many": "{{count}} réponses",
  "course_students.accounts.data_footprint.grades_one": "{{count}} note",
  "course_students.accounts.data_footprint.grades_many": "{{count}} notes",
  "course_students.accounts.data_footprint.notes_one": "{{count}} note",
  "course_students.accounts.data_footprint.notes_many": "{{count}} notes",
  "course_students.accounts.delete_student.data_intro": "Ces données seront supprimées :",
  "course_students.accounts.delete_student.data_unknown": "Toutes les soumissions, réponses et notes seront supprimées.",
  "course_students.accounts.delete_student.permanent_hint": "Cette action est irréversible. Vous pourrez recréer ce nom ensuite : l’accès sera vide et aura un nouveau code.",
  "course_students.accounts.delete_student.confirm_checkbox": "Oui, je comprends que ces données seront supprimées.",
  "course_students.accounts.delete_student.deleted_toast": "« {{studentName}} » a été supprimé.",
  "course_students.accounts.feature_banner.aria_label": "Comptes élèves",
  "course_students.accounts.feature_banner.title": "Accès personnels pour les élèves",
  "course_students.accounts.feature_banner.description": "Tous les élèves reçoivent un code personnel et peuvent accéder aux matériels à tout moment, y compris leurs propres réponses et soumissions. En tant qu'enseignant, vous pouvez rendre les matériels visibles pour des élèves individuels.",
  "course_students.accounts.feature_banner.activate": "Activer les accès élèves",
  "course_students.accounts.school_license_promo.title": "Accès personnalisés pour les élèves",
  "course_students.accounts.school_license_promo.description": "Partagez des matériels de manière ciblée avec des élèves individuels. Les élèves voient tous leurs matériels, y compris les réponses, dans un accès personnel. Cette fonction est incluse dans la licence scolaire Teachino.",
  "course_students.accounts.personalized_access.title": "Accès personnalisés pour les élèves",
  "course_students.accounts.personalized_access.description": "Les élèves se connectent avec leur propre code. Les matériels peuvent être rendus visibles pour des élèves individuels.",
  "course_students.accounts.disable.title": "Désactiver les accès personnalisés ?",
  "course_students.accounts.disable.message": "Les élèves ne pourront plus se connecter avec leur code personnel.",
  "course_students.accounts.disable.info": "Les comptes élèves créés dans ce cours sont conservés et vous pourrez réactiver l'accès plus tard.",
  "course_students.accounts.disable.confirm": "Désactiver",
  "course_students.accounts.login_share.title": "Comment les élèves obtiennent l'accès :",
  "course_students.accounts.login_share.step_create": "Créez les élèves dans le cours",
  "course_students.accounts.login_share.step_personal_code": "Tous les élèves reçoivent un code personnel.",
  "course_students.accounts.login_share.step_print": "Imprimez les codes et distribuez-les",
  "course_students.accounts.login_share.step_open_prefix": "Les élèves ouvrent",
  "course_students.accounts.login_share.step_enter_code": "et saisissent leur code",
  "course_students.accounts.login_share.step_visible_materials": "Les élèves voient les matériels rendus visibles pour eux, y compris toutes leurs réponses",
  "course_students.accounts.preview.description": "Voici comment les élèves voient ce matériel. Vous pouvez essayer ici les tâches interactives et les chatbots.",
  "course_students.accounts.visibility.all_students": "Tous les élèves",
  "course_students.groups.title": "Groupes d'apprentissage",
  "course_students.groups.create": "Créer un groupe d'apprentissage",
  "course_students.groups.edit": "Modifier le groupe d'apprentissage",
  "course_students.groups.delete": "Supprimer le groupe d'apprentissage",
  "course_students.groups.assign": "Attribuer des groupes d'apprentissage",
  "course_students.groups.empty": "Aucun groupe d'apprentissage créé",
  "course_students.groups.empty_in_group": "Aucun élève dans ce groupe d'apprentissage",
  "course_students.groups.new_group": "Nouveau groupe d'apprentissage",
  "course_students.groups.student_label": "Élève",
  "course_students.groups.table_column": "Groupes d'apprentissage",
  "course_students.groups.description": "Créez des groupes pour des élèves ayant des besoins d'apprentissage, des besoins de soutien ou des forces similaires",
  "course_students.groups.create.description": "Créez un groupe d'apprentissage et sélectionnez éventuellement directement les premiers élèves.",
  "course_students.groups.edit.description": "Modifiez le nom et la couleur du groupe d'apprentissage et choisissez quels élèves doivent en faire partie.",
  "course_students.groups.assign.description": "Choisissez les groupes d'apprentissage auxquels cet élève doit être associé.",
  "course_students.groups.manage_members.title": "Gérer les élèves",
  "course_students.groups.manage_members.description": "Choisissez quels élèves doivent faire partie de ce groupe d'apprentissage.",
  "course_students.groups.manage_members.empty": "Aucun élève dans ce cours",
  "course_students.groups.assign.empty": "Aucun groupe d'apprentissage dans ce cours",
  "course_students.groups.name_placeholder": "p. ex. Groupe d'apprentissage A",
  "course_students.groups.name_placeholder_edit": "p. ex. particulièrement motivés, allemand langue seconde",
  "course_students.groups.delete_confirm": "Voulez-vous vraiment supprimer le groupe d'apprentissage « {{groupName}} » ? Les élèves ne seront pas supprimés.",
  "student_accounts.page_title": "Connexion élève",
  "student_accounts.login.code_label": "Code",
  "student_accounts.login.code_placeholder": "XXXXX-XXXXX",
  "student_accounts.login.submit": "Se connecter",
  "student_accounts.login.logging_in": "Connexion en cours…",
  "student_accounts.login.heading": "Ouvrir les ressources dans Teachino",
  "student_accounts.login.choose_method": "Comment souhaitez-vous continuer ?",
  "student_accounts.login.received_code": "J’ai reçu un code de mon enseignant·e",
  "course_students.reusable_share.course_title": "Partager le lien du cours",
  "course_students.reusable_share.course_description": "Partagez ce lien ou ce QR-Code. Les élèves se connectent avec leur code d’accès personnel.",
  "course_students.reusable_share.material_title": "Partager le lien du matériel",
  "course_students.reusable_share.material_description": "Partagez ce lien ou ce QR-Code pour diriger les élèves vers ce matériel après la connexion.",
  "course_students.reusable_share.show_qr_code": "Afficher le QR-Code",
  "course_students.reusable_share.copy_public_tooltip": "Les élèves peuvent s’inscrire eux-mêmes via ce lien. Ils reçoivent ensuite un code d’accès personnel.",
  "course_students.reusable_share.copy_code_tooltip": "Les élèves peuvent ouvrir ce lien et se connecter avec leur code d’accès personnel.",
  "course_students.reusable_share.qr_description": "Ce code QR mène au cours.",
  "course_students.reusable_share.qr_code_description": "Les élèves peuvent utiliser ce code QR pour se connecter avec leur code d’accès personnel.",
  "course_students.reusable_share.qr_public_description": "Les élèves peuvent utiliser ce code QR pour s’inscrire eux-mêmes. Ils reçoivent ensuite un code d’accès personnel.",
  "course_students.reusable_share.student_codes": "Codes d’accès de tes élèves",
  "course_students.reusable_share.material_disabled": "Rendez le matériel visible pour au moins un élève avant de le partager.",
  "course_students.self_registration.title": "Activer l’inscription autonome des élèves",
  "course_students.self_registration.description": "Les élèves ouvrent le lien et saisissent leur nom ou leurs initiales. Ils reçoivent un code pour y accéder à nouveau plus tard.",
  "course_students.self_registration.toggle_label": "Autoriser l’auto-inscription",
  "course_students.self_registration.link_description": "Envoie ce lien à tes élèves.",
  "course_students.self_registration.saved": "Paramètre enregistré",
  "course_students.self_registration.material_banner": "Les élèves disposant de ce lien peuvent créer leur propre compte. Ils recevront un code d’accès pour accéder de nouveau au cours plus tard.",
  "student_accounts.self_registration.no_code": "Je n’ai pas encore de code",
  "student_accounts.self_registration.description": "Saisis ton nom ou tes initiales.",
  "student_accounts.self_registration.name_label": "Ton nom",
  "student_accounts.self_registration.name_placeholder": "Saisis ton nom",
  "student_accounts.self_registration.submit": "Créer le compte",
  "student_accounts.self_registration.error": "Le compte n’a pas pu être créé. Réessaie.",
  "student_accounts.self_registration.code_title": "Voici ton code",
  "student_accounts.self_registration.code_description": "Garde bien ce code. Tu en auras besoin quand tu reviendras.",
  "student_accounts.self_registration.code_warning": "Note-le ou demande à un adulte de t’aider à l’enregistrer.",
  "student_accounts.self_registration.code_teacher_note": "Ton enseignant peut gérer les codes.",
  "student_accounts.self_registration.continue": "Suivant",
  "course_students.merge.action": "Fusionner ce compte en double",
  "course_students.merge.title": "Fusionner un compte en double",
  "course_students.merge.description": "{{sourceName}} ({{sourceCode}}) sera supprimé. Choisissez le compte qui doit conserver les données regroupées.",
  "course_students.merge.target_label": "Compte à conserver",
  "course_students.merge.target_placeholder": "Choisir le compte à conserver",
  "course_students.merge.newest_wins_hint": "Toutes les données sont transférées vers le compte sélectionné. Son nom et son code restent inchangés. En cas de conflit, la valeur la plus récente est conservée.",
  "course_students.merge.confirm": "Fusionner et supprimer le double",
  "course_students.merge.success": "{{sourceName}} a été fusionné avec {{targetName}}",
  "student_accounts.login.description": "Saisissez le code que vous avez reçu de votre enseignant.",
  "student_accounts.login.teacher_cta": "Vous êtes enseignant ? Connectez-vous ici",
  "student_accounts.login.code_invalid": "Le code est invalide. Veuillez le vérifier et réessayer.",
  "student_accounts.login.code_invalid_characters": "Le code ne peut contenir que des lettres et des chiffres.",
  "student_accounts.login.code_length": "Le code doit comporter exactement 10 caractères",
  "student_accounts.login.error_generic": "Une erreur s'est produite lors de la connexion. Veuillez réessayer.",
  "student_accounts.logout.dialog_title": "Votre accès à Teachino",
  "student_accounts.logout.logged_in_as": "Vous êtes connecté en tant que",
  "student_accounts.logout.switch_course_title": "Changer de cours ou se déconnecter",
  "student_accounts.logout.switch_course_message": "Si vous souhaitez accéder à un autre cours ou si quelqu'un d'autre doit continuer sur cet appareil, cliquez sur Se déconnecter. Vous pourrez vous reconnecter plus tard avec votre code d'accès personnel.",
  "student_accounts.access_card.website": "Site web",
  "student_accounts.access_card.personal_code": "Code d'accès personnel",
  "student_accounts.access_card.code_copied": "Code copié",
  "material.student_visibility.title": "Visibilité pour les élèves",
  "material.student_visibility.summary_all": "Matériel visible pour tous les élèves",
  "material.student_visibility.summary_partial": "Matériel visible pour {{visible}} sur {{total}} élèves",
  "material.student_visibility.toggle_all_hint": "Ce bouton rend le matériel visible pour tous les élèves",
  "material.student_visibility.add_students_prefix": "Vous pouvez ajouter des élèves dans le cours sous",
  "material.student_visibility.add_students_suffix": "les ajouter.",
  "material.student_visibility.show_for_groups": "Afficher pour les élèves des groupes d'apprentissage",
  "material.student_visibility.guest_readonly_hint": "En tant qu'invité, vous pouvez voir la visibilité mais pas la modifier.",
  "course_settings.collaboration.empty": "Aucun enseignant invité",
  "link.copied.title": "Lien copié",
  "link.open.new_tab": "Ouvrir dans un nouvel onglet",
  "link.copied.description": "Vous pouvez maintenant envoyer le lien",
  "emoji.name": "Symbole",
  "emoji.title": "Sélectionner un symbole",
  "emoji.search": "Recherche",
  "emoji.not_found": "Aucune icône trouvée",
  "emoji.category.search": "Résultats de recherche",
  "emoji.category.recent": "Icônes utiles",
  "emoji.category.people": "Émoticônes & Personnes",
  "emoji.category.nature": "Animaux & Nature",
  "emoji.category.foods": "Repas & Boissons",
  "emoji.category.activity": "Activité",
  "emoji.category.places": "Lieux",
  "emoji.category.objects": "Objets",
  "emoji.category.symbols": "Symboles",
  "emoji.category.flags": "Drapeaux",
  "emoji.category.custom": "Autres",
  "emoji.skin.choose": "Choisir une couleur de peau standard",
  "emoji.skin.1": "1",
  "features.timetable.back_to_quick_entry": "Retour au formulaire d'entrée rapide",
  "features.timetable.back_to_quick_entry_description": "Es-tu sûr? Si tu réactives le formulaire d'entrée rapide, toutes tes entrées actuelles seront perdues.",
  "timetable_edit.vacation_title": "Vacances",
  "timetable_edit.vacation_name_placeholder": "Vacances d'été, jour férié, …",
  "timetable_edit.vacation_date_range": "Période",
  "timetable_edit.vacation_name": "Nom",
  "timetable_edit.vacation_add": "Ajouter des vacances",
  "timetable_edit.vacation_default_name": "Vacances en {{month}}",
  "timetable.week_not_loaded": "L'emploi du temps pour cette semaine n'a pas pu être chargé. Veuillez réessayer ou choisir une autre semaine.",
  "timetable.integration_not_available_title": "WebUntis non accessible – vue limitée de l'emploi du temps",
  "timetable.integration_not_available_desc1": "Les heures déjà planifiées apparaissent dans la liste",
  "timetable.integration_not_available_desc2": "Les heures non planifiées sur Teachino n'apparaissent pas",
  "timetable.integration_not_available_desc3": "Lorsque WebUntis sera à nouveau disponible, l'emploi du temps complet sera automatiquement affiché",
  "timetable.integration_not_available_desc4": "À tout moment, tous les matériaux peuvent être ouverts via \"Cours\" et \"Bibliothèque\"",
  "timetable_edit.edit_vacations": "Entrer des vacances",
  "timetable_edit.edit_vacations.description": "Ici, tu peux saisir des vacances pour qu'elles soient prises en compte dans l'emploi du temps.",
  "timetable_edit.old_vacations_hidden": "Les vacances des années précédentes sont automatiquement masquées.",
  "timetable_edit.add_period": "Événement",
  "timetable_edit.vacation_deleted": "Vacances supprimées",
  "timetable_edit.vacation_updated": "Vacances enregistrées",
  "timetable_edit.vacation_not_allowed_title": "Les vacances sont synchronisées automatiquement",
  "timetable_edit.vacation_not_allowed_description": "Comme tu as activé une interface d'emploi du temps, tes vacances sont automatiquement transférées sur Teachino.",
  "timetable_edit.vacation_not_allowed_cta": "Gérer les intégrations",
  "timetable_edit.create_period_title": "Créer un événement",
  "timetable_edit.edit_period_title": "Modifier l'événement",
  "timetable_edit.period_label": "Description",
  "timetable_edit.period_label_placeholder": "ex. Réunion, …",
  "timetable_edit.period_label_error": "Veuillez entrer une description",
  "timetable_edit.period_date": "Date",
  "timetable_edit.period_date_time": "Date et heure",
  "timetable_edit.period_date_time_error": "Veuillez vérifier la date et l'heure",
  "timetable_edit.period_date_error": "Veuillez sélectionner une date.",
  "timetable_edit.period_time": "Heure",
  "timetable_edit.period_note_loading": "Chargement de la note…",
  "timetable_edit.period_note_placeholder": "Note pour ce jour de cours",
  "timetable_edit.period_type": "Type d'événement",
  "timetable_edit.period_type_course": "Cours",
  "timetable_edit.period_type_course_description": "Heures supplémentaires dans tes cours",
  "timetable_edit.period_type_other": "Événement",
  "timetable_edit.period_type_other_description": "Réunions, remplacements, rendez-vous personnels, …",
  "timetable_edit.cancel": "Annuler",
  "timetable_edit.add_material_from_library": "Ajouter un matériel de la bibliothèque",
  "timetable_edit.cancel_warning_title": "Confirmer annullement",
  "timetable_edit.cancel_warning_description": "Veuillez confirmer que cette leçon ne se tiendra pas.",
  "timetable_edit.cancel_warning_confirm": "Leçon annulée",
  "timetable_edit.uncancel": "Rétablir le cours",
  "timetable_edit.uncancel_warning_title": "Rétablir le cours annulé",
  "timetable_edit.uncancel_warning_description": "Rétablir ce cours dans l’emploi du temps ?",
  "timetable_edit.remove_warning_title": "Supprimer l'entrée",
  "timetable_edit.remove_warning_description": "Veuillez confirmer que cette entrée doit être supprimée.",
  "timetable_edit.remove_warning_confirm": "Supprimer l'entrée",
  "timetable_edit.7_days": "Afficher Sam/Dim",
  "timetable_edit.5_days": "Masquer Sam/Dim",
  "timetable.empty_state_header": "Emploi du temps et événements",
  "timetable.empty_state_description": "Ici tu as une vue sur ta semaine et peux préparer tes leçons.",
  "timetable.empty_state_button": "Entrer l'emploi du temps",
  "timetable.add_different_times_per_day": "Choisir des heures différentes pour chaque jour",
  "timetable.edit_no_lesson": "Pas de cours",
  "timetable.edit": "Modifier l'emploi du temps",
  "timetable.edit.choose": "Choisis un cours pour cette leçon",
  "timetable.edit.choose_missing": "Le cours souhaité manque dans la liste?",
  "timetable.edit.choose_create": "Créer un nouveau cours",
  "timetable.edit.empty.title": "Entre ton emploi du temps",
  "timetable.edit.empty.description": "Clique sur ➕ dans une leçon et choisis le cours approprié.",
  "timetable.edit.add_row": "Ajouter une heure",
  "timetable.edit.add_row_error": "Aucune leçon après 23:00 possible. Veuillez modifier les heures des leçons précédentes.",
  "agenda.all_entries_section": "Agenda",
  "agenda.all_entries": "Afficher tout",
  "agenda.todos": "À faire",
  "agenda.empty.description": "Il n'y a pas encore d'événements pour ce cours dans la période choisie. Veuillez enregistrer un emploi du temps ou créer une leçon individuelle.",
  "agenda.empty.date_range": "Période :",
  "todo_title": "À faire",
  "todo_item_placeholder": "Entrer une tâche",
  "todo_edit_due_date": "Modifier la date d'échéance",
  "todo_move_to_another_date": "Choisir une autre date",
  "todo_change_course": "Changer de cours",
  "todo_no_course": "Aucun cours",
  "todo_page_overdue": "Tâches en retard",
  "todo_add_date": "Ajouter une date",
  "todo_error_fetch": "Erreur : Impossible de récupérer les tâches du serveur",
  "todo_error_edit": "Erreur : Impossible de modifier la tâche",
  "todo_error_delete": "Erreur : Impossible de supprimer la tâche",
  "todo_success_change_date_header": "La date a été modifiée",
  "todo_success_change_date_description": "La date a été changée pour le {{date}}.",
  "todo_success_done_header": "Tâche \"{{text}}\"",
  "todo_success_done_description": "La tâche a été marquée comme terminée.",
  "course_day.back_to_lession": "Retour à la leçon",
  "course_plan.todo_header": "À faire pour {{date}}",
  "course_plan.note_saved": "Planification enregistrée !",
  "course_plan.item_added": "Matériel ajouté à la leçon !",
  "course_plan.statistics.planned_0": "Aucun matériel planifié",
  "course_plan.statistics.planned_1": "1 matériel planifié",
  "course_plan.statistics.planned_many": "{{number}} matériels planifiés",
  "course_plan.statistics.done_0": "Aucun matériel terminé",
  "course_plan.statistics.done_1": "1 matériel terminé",
  "course_plan.statistics.done_many": "{{number}} matériels terminés",
  "course_plan.statistics.visible_0": "Aucun matériel visible pour les écoliers",
  "course_plan.statistics.visible_1": "1 matériel visible pour les écoliers",
  "course_plan.statistics.visible_many": "{{number}} matériels visibles pour les écoliers",
  "tutorial.detail_planning_header": "Planification de détails",
  "tutorial.detail_planning_description": "Ajoute des matériaux du cours à des leçons individuelles. Tu peux consigner des informations générales avec des notes (activités supplémentaires, phases de leçon, déroulement de la leçon).",
  "tutorial.annual_planning_header": "Contenus des cours",
  "tutorial.annual_planning_description": "Les thèmes reflètent la structure de ton année scolaire. Pour chaque thème, tu peux créer des matériaux. Tu peux utiliser les matériaux et thèmes dans plusieurs cours et années scolaires suivantes. Clique pour cela sur 'Bibliothèque'.",
  "tutorial.student_access_header": "Lien pour les écoliers",
  "tutorial.student_access_description": "Ce lien peut être partagé avec les écoliers ou les parents. Ils ne voient que les matériaux qui ont été rendus publics grâce à l'icône de l'œil.",
  "tutorial.team_teaching_header": "Co-enseignement",
  "tutorial.team_teaching_description": "Tu peux planifier ce cours avec d'autres enseignants. Invite-les avec un lien. Tes matériaux personnels ne peuvent être modifiés que par toi.",
  "tutorial.snippets_header": "Matériel",
  "tutorial.snippets_description": "Ici tu peux ajouter des textes, des images, des fichiers, des liens … à tes matériaux. Avec des notes, tu peux noter des choses que seuls les enseignants devraient voir. Par exemple, solutions, méthodes, rappels pour l'année prochaine.",
  "tutorial.lessons_page_header": "Leçons",
  "tutorial.lessons_page_description": "Ici tu vois toutes les leçons de ce cours. Tu peux déplacer librement des matériaux d'une leçon à une autre.",
  "integration.connect_title": "Connecter les profils",
  "integration.settings_title": "Intégrations",
  "integration.settings_remove": "Déconnecter",
  "integration.settings_remove_title": "Déconnecter",
  "integration.settings_remove_description": "La connexion aux cours et à l'emploi du temps sera interrompue. La connexion par SSO ne sera plus possible. Si tu n'as pas encore défini de mot de passe, tu peux le réinitialiser via ton adresse e-mail.",
  "integration.settings_connect": "Connecter",
  "integration.settings_coming_soon_cta": "En savoir plus",
  "integration.disconnected_notice.title": "Connexion à {{displayName}} supprimée",
  "integration.disconnected_notice.description": "{{displayName}} n'autorise plus Teachino à accéder à ton compte – soit ton école a désactivé l'intégration, soit ton accès a été supprimé. Nous avons donc supprimé la connexion. Tes cours et tes supports dans Teachino sont conservés. Dès que tu auras de nouveau accès, tu pourras rétablir la connexion.",
  "integration.disconnected_notice.open_settings": "Ouvrir les intégrations",
  "integration.disconnected_notice.dismiss": "J'ai compris",
  "integration.authenticate.header": "Connecter {{displayName}} à Teachino",
  "integration.authenticate.integration_profile": "Profil {{displayName}}",
  "integration.authenticate.teachino_profile": "Profil Teachino",
  "integration.authenticate.error_generic": "Une erreur s'est produite lors de la connexion. Veuillez ouvrir Teachino via app.teachino.io ou nous contacter à hallo@teachino.io",
  "integration.authenticate.student_creation_failed": "Votre accès élève n'a pas pu être créé. Veuillez ouvrir à nouveau Teachino depuis WebUntis ou contacter votre enseignant.",
  "integration.authenticate.redirect_triggered": "Vous allez être redirigé sous peu.",
  "integration.authenticate.not_possible_title": "Déjà lié à un autre compte Teachino",
  "integration.authenticate.not_possible_description": "Ce compte {{displayName}} est déjà lié à un autre compte Teachino et ne peut pas être lié à ton compte actuel. Tu peux te déconnecter et continuer avec le compte lié, ou rester dans ton compte actuel.",
  "integration.authenticate.login_conflict_title": "Tu es connecté à un autre compte Teachino",
  "integration.authenticate.login_conflict_description": "Ce compte {{displayName}} est lié à un compte Teachino différent de celui que tu utilises actuellement. Pour te connecter via cette intégration, déconnecte-toi d'abord de ton compte Teachino actuel.",
  "integration.authenticate.current_account": "Compte actuellement connecté : {{email}}",
  "integration.authenticate.sign_out_and_continue": "Se déconnecter et continuer avec {{displayName}}",
  "integration.authenticate.not_possible_back_link": "Rester dans mon compte actuel",
  "integration.authenticate.cannot_signup": "Il semble que tu aies déjà un profil Teachino. Veuillez sélectionner \"J'utilise déjà Teachino\" et connecte-toi. Ensuite, tu peux connecter le profil.",
  "integration.authenticate.signup_conflict_description": "Tu as déjà un compte Teachino. Connecte-toi pour le lier à cette intégration.",
  "integration.authenticate.create_account": "Créer un nouveau compte",
  "integration.authenticate.help": "Pour obtenir de l'aide, veuillez nous contacter à hallo@teachino.io",
  "integration.authenticate_untis.description": "Avec Teachino, tu peux préparer tes leçons basées sur ton emploi du temps WebUntis et intégrer ta planification dans le cahier de classe.",
  "integration.authenticate_digreg.description": "Avec Teachino, tu peux préparer tes leçons basées sur ton emploi du temps du Registre Numérique et intégrer ta planification dans le cahier de classe.",
  "integration.authenticate_microsoft.description": "Connecte des fichiers de OneDrive et des pages de OneNote à Teachino.",
  "integration.authenticate_bip.description": "La connexion de Teachino et du BIP permet la connexion automatique à Teachino.",
  "integration.authenticate_cgie.description": "La connexion de Teachino et du CGIE permet la connexion automatique à Teachino et l'activation d'une licence gratuite.",
  "integration.authenticate.sign_up": "Je suis nouveau sur Teachino",
  "integration.authenticate.log_in": "J'utilise déjà Teachino",
  "integration.authenticate.successful": "{{displayName}} et Teachino ont été connectés!",
  "integration.authenticate.open_teachino_hint": "Veuillez ouvrir Teachino sur app.teachino.io et vous connecter avec votre adresse e-mail et votre mot de passe.",
  "integration.authenticate.open_teachino": "Ouvrir Teachino",
  "integration.admininfo.title": "L’intégration Teachino est activée ! 👏",
  "integration.admininfo.description": "Les enseignant·e·s voient désormais Teachino dans WebUntis et peuvent travailler avec Teachino.",
  "integration.admininfo.explore_title": "1. Découvrir Teachino 👀",
  "integration.admininfo.open_website": "Ouvrir le site web",
  "integration.admininfo.try_title": "Essayer vous-même ?",
  "integration.admininfo.try_description": "Connectez-vous à WebUntis avec un utilisateur ayant le rôle d’enseignant·e, puis cliquez sur Teachino. Au lieu de cette page, vous verrez alors la planification des cours.",
  "integration.admininfo.inform_title": "2. Informer vos collègues 📣",
  "integration.admininfo.inform_description": "Modèle de texte à envoyer par e-mail ou messagerie",
  "integration.admininfo.mail_text": "Chères et chers collègues,\nJe viens d’activer l’intégration WebUntis avec Teachino. Teachino utilise l’intelligence artificielle pour aider à créer des supports et donne aux élèves un retour grâce à l’IA. Vous pouvez dès maintenant essayer Teachino. Vous trouverez plus d’informations et un court guide sur https://help.teachino.io/\nBien cordialement",
  "integration.admininfo.copy_text": "Copier le texte et l’envoyer",
  "integration.admininfo.copied_title": "Texte copié",
  "integration.admininfo.copied_description": "Vous pouvez maintenant coller le texte dans votre messagerie et l’envoyer.",
  "integration.admininfo.meeting_title": "3. Convenir d’une visioconférence avec Teachino 📆",
  "integration.admininfo.meeting_description": "Nous vous présentons volontiers Teachino lors d’une visioconférence et répondons à toutes vos questions.",
  "integration.admininfo.schedule": "Choisir un rendez-vous",
  "integration.admininfo.contact": "Contacter l’équipe Teachino",
  "integration.not_ready.title": "Activer l’intégration Teachino 🚀",
  "integration.not_ready.description": "Veuillez remplir ce formulaire. Nous conviendrons ensuite d’une courte visioconférence pour vous présenter les principales fonctions de Teachino et mettre en place la période d’essai avec vous.",
  "integration.not_ready_student.title": "Teachino n’est pas encore activé pour ton école.",
  "integration.not_ready_student.description": "Dès que ton enseignant·e activera Teachino, tu verras ici des supports de cours et bien plus encore.",
  "integration.settings_connected_with": "Connecté à : {{displayName}}",
  "integration.ical.description": "Importe les entrées d'emploi du temps depuis un flux iCal et associe les noms d'entrées du calendrier aux cours Teachino sur cette page.",
  "integration.ical.connect_title": "Connecter le flux iCal",
  "integration.ical.edit_title": "Modifier le flux iCal",
  "integration.ical.edit_feed": "Modifier le lien",
  "integration.ical.save_feed": "Enregistrer le flux iCal",
  "integration.ical.modal_description": "Collez l'URL d'abonnement iCal du calendrier que vous souhaitez afficher dans l'emploi du temps.",
  "integration.ical.url_label": "URL iCal",
  "integration.ical.url_placeholder": "https://example.com/calendar.ics",
  "integration.ical.url_required": "Veuillez saisir une URL iCal.",
  "integration.ical.mapping_hint": "Utilisez exactement le même nom d'entrée de calendrier pour toutes les entrées du même cours afin que l'association du cours fonctionne correctement.",
  "integration.ical.invalid_feed_url": "Impossible de connecter ce flux. Veuillez vous assurer d'avoir collé l'URL d'abonnement iCal et non le lien vers la page du calendrier.",
  "integration.ical.connected_courses.description": "Associez les cours Teachino aux entrées du calendrier de votre calendrier.",
  "integration.untis.description": "Connecte Teachino avec WebUntis pour synchroniser ton emploi du temps et ton cahier de classe. Ton école doit activer l'intégration dans WebUntis. Ouvre ensuite WebUntis et clique là-bas sur Teachino",
  "integration.edupage.description": "Connecte Teachino à EduPage pour importer ton emploi du temps et associer les matières EduPage à tes cours Teachino.",
  "integration.edupage.connect_title": "Connecter l'emploi du temps EduPage",
  "integration.edupage.edit_title": "Modifier l'emploi du temps EduPage",
  "integration.edupage.edit_feed": "Modifier la connexion EduPage",
  "integration.edupage.save_feed": "Enregistrer l'emploi du temps EduPage",
  "integration.edupage.tutorial_step_1": "Dans EduPage, ouvre \"Enseignement\" → \"Événements\".",
  "integration.edupage.tutorial_step_2": "Sous \"Événements\", sélectionne \"Emploi du temps\".",
  "integration.edupage.tutorial_step_3": "Sélectionne \"Exporter\", puis \"Activer Webcal\".",
  "integration.edupage.tutorial_step_4": "L'URL Webcal s'affiche alors. Copie-la et colle-la ci-dessous.",
  "integration.edupage.tutorial_image_alt": "Boîte de dialogue EduPage permettant d'activer Webcal pour l'emploi du temps",
  "integration.edupage.url_label": "URL Webcal EduPage",
  "integration.edupage.url_placeholder": "https://ton-ecole.edupage.org/webcal?pwd=...",
  "integration.edupage.url_required": "Saisis ton URL Webcal EduPage.",
  "integration.edupage.invalid_feed_url": "Impossible de connecter cet emploi du temps EduPage. Vérifie que tu as collé l'URL Webcal provenant d'EduPage.",
  "integration.edupage.connected_courses.description": "Associe tes cours Teachino aux matières de ton emploi du temps EduPage.",
  "integration.edupage.external_course": "Matière dans EduPage",
  "integration.bip.description": "Pour les enseignants en Autriche : connecte Teachino avec le portail éducatif.",
  "integration.cgie.description": "Pour les enseignants au Luxembourg : utilise la connexion IAM du CGIE pour utiliser Teachino gratuitement.",
  "integration.digreg.description": "Pour les enseignants au Tyrol du Sud : connecte Teachino avec le Registre Numérique pour synchroniser ton emploi du temps et ton cahier de classe. Ton école doit activer l'intégration dans le Registre Numérique.",
  "integration.microsoft.description": "Connecte ton profil Microsoft à Teachino pour accéder à ton cahier OneNote. Tu peux connecter des équipes individuelles avec des cours dans Teachino pour accéder aux cahiers de classe.",
  "integration.ical.external_course": "Nom de l'entrée du calendrier",
  "integration.untis.external_course": "Cours dans WebUntis",
  "integration.digreg.external_course": "Désignation dans le Registre Numérique",
  "integration.microsoft.external_course": "Équipe dans Microsoft Teams",
  "integration.teachino.external_course": "Cours dans Teachino",
  "integration.cgie.connect.title": "Enregistrer avec IAM chez Teachino",
  "integration.cgie.connect.description": "Dans le cadre de l'empreinte IA, Teachino est mis gratuitement à disposition de tous les enseignants au Luxembourg.",
  "integration.cgie.connect.start": "Commencer avec Teachino",
  "integration.cgie.connect.login": "J'utilise déjà Teachino",
  "integration.cgie.connect.terms_prefix": "Les",
  "integration.cgie.connect.terms_suffix": "de Teachino s’appliquent dans le cadre de la collaboration entre Teachino et le SCRIPT. Les données sont supprimées après 24 mois d’inactivité.",
  "integration.connect_course.title": "Connecter le cours avec Teachino",
  "integration.connect_course.description": "Quel cours Teachino aimerais-tu associer avec \"{{externalCourseName}}\"?",
  "integration.connect_course.ignore": "Ne plus afficher {{courseName}}",
  "integration.connect_course.ignore_confirm": "Les leçons de {{courseName}} disparaîtront également de votre emploi du temps. Vous pouvez annuler cette action à tout moment sous « Modifier l’emploi du temps ».",
  "integration.connect_course.select": "Choisir un cours",
  "integration.connect_course.successful_connect": "Cours connecté!",
  "integration.connect_course.successful_ignore": "Cours caché!",
  "integration.connect_course.ignore_title": "Le cours est caché.",
  "integration.connect_course.ignore_restore": "Réafficher {{courseName}}",
  "integration.course_connected.description": "{{externalCourseName}} est connecté à {{internalCourseName}} dans Teachino.",
  "integration.connect_course.create": "Créer {{courseName}}",
  "integration.connect_course.header": "Comment {{courseName}} doit-il apparaître dans Teachino?",
  "integration.connect_course.new": "En tant que nouveau cours",
  "integration.connect_course.connect": "ou connecté à un cours existant",
  "integration.settings.connected_courses.title": "Connexions",
  "integration.settings.connected_courses.description": "Connectez vos cours de Teachino pour synchroniser les données.",
  "integration.settings.course_ignored": "Caché",
  "integration.settings.remove_course_title": "Rompre la connexion",
  "integration.settings.course_not_connected": "Non connecté",
  "integration.settings.course_connect": "Connecter le cours",
  "integration.settings.remove_course_description": "Le cours réapparaîtra en gris clair dans ton emploi du temps et pourra être reconnecté là.",
  "integration.export_classregister.title": "Écrire le contenu dans le cahier de classe",
  "integration.export_classregister.description": "Ce texte ne sera pas enregistré dans Teachino.",
  "integration.export_classregister.send_to_classregister": "Écrire dans le cahier de classe",
  "integration.export_classregister.send_to_classregister_successfull": "Cahier de classe complété",
  "integration.export_classregister.send_to_classregister_successfull_description": "Le contenu a été écrit dans le cahier de classe.",
  "integration.export_classregister.send_to_classregister_unsuccessfull": "Impossible de compléter le cahier de classe.",
  "integration.export_classregister.send_to_classregister_unsuccessfull_description": "Veuillez vérifier si cette leçon est présente dans le cahier de classe et si le contenu peut être écrit pour cette leçon.",
  "integration.export_classregister.tooltip": "Exporter le texte pour le cahier de classe",
  "integration.export_classregister": "Cahier de classe",
  "integration.export_classregister.copy": "Copier le texte",
  "integration.export_classregister.copy_success_title": "Texte copié dans le presse-papiers",
  "integration.export_classregister.copy_success_description": "Le texte peut maintenant être inséré dans le cahier de classe.",
  "onboarding_tutorial.enter_courses_description_1": "Veuillez créer un cours par matière et classe que vous enseignez.\nSi vous enseignez deux matières dans une classe, veuillez créer deux cours.",
  "onboarding_tutorial.enter_courses_more_lines": "ajouter un autre cours",
  "onboarding_tutorial.enter_courses_button": "Commencer avec Teachino",
  "onboarding_tutorial.enter_courses_extra_note": "Vous pouvez créer d'autres cours et modifier les couleurs plus tard",
  "onboarding_tutorial.enter_courses_placeholder_1": "Géographie",
  "onboarding_tutorial.enter_courses_placeholder_2": "Histoire",
  "onboarding_tutorial.enter_courses_placeholder_3": "Histoire",
  "onboarding_tutorial.select_first_step.title": "Vous êtes prêt à démarrer!",
  "onboarding_tutorial.select_first_step.description": "Comment souhaitez-vous commencer avec Teachino?",
  "onboarding_tutorial.select_first_step.option_ai": "Essayer l'IA",
  "onboarding_tutorial.select_first_step.option_plan": "Planifier la leçon dans l'emploi du temps",
  "onboarding.create_topic.description": "Dans Teachino, une gamme désigne une section d'une année scolaire, p. ex. un chapitre du manuel ou une grande unité thématique.",
  "onboarding.create_topic.header_1": "Planifions votre cours - commençons par une gamme!",
  "onboarding.create_topic.header_2": "Tapez un nom significatif pour votre première gamme ou choisissez un exemple.",
  "onboarding.create_topic.name_placeholder": "Entrez le nom de la gamme.",
  "onboarding.create_topic.material_empty_title": "Prêt! Votre matériel attend maintenant des contenus.",
  "onboarding.create_topic.material_empty_description": "Commencez avec une fonction IA ou écrivez simplement.",
  "onboarding.create_topic.error.name_too_short": "Veuillez entrer un nom significatif d'au moins 5 caractères ou choisir un exemple.",
  "onboarding.topic_created.description": "Pour chaque gamme, vous pouvez créer des matériaux. Les matériaux sont les contenus pédagogiques concrets, comme p. ex. des feuilles de travail, des liens, des notes ou des tableaux de leçon.",
  "onboarding.topic_created.header_1": "Vous avez créé votre première gamme",
  "onboarding.topic_created.header_2": "La gamme est encore vide, remplissons-la maintenant avec des matériaux! L'IA vous aide.",
  "onboarding.topic_created.no_materials_in_topic": "0 matériaux",
  "onboarding.topic_created.add_materials": "Remplir la gamme avec du matériel",
  "onboarding.create_material.description": "L'IA propose des suggestions pour la création et la différenciation des matériels. Elle se base sur vos matériels existants, fichiers et liens. Vous pouvez même ajouter votre programme scolaire.",
  "onboarding.create_material.header_1": "Quel matériel souhaitez-vous créer en premier ?",
  "onboarding.create_material.header_2": "Vous voyez des suggestions d'IA pour la série {{topic}} pour ",
  "onboarding.create_material.age": "{{age}}-ans",
  "onboarding.create_material.video": "Regardez la vidéo tutorielle",
  "onboarding.create_material.title_1": "Qu'est-ce qu'un matériel ?",
  "onboarding.create_material.text_1": "Tout – du fichier à toute l'heure de cours",
  "onboarding.create_material.title_2": "Comment ça fonctionne :",
  "onboarding.create_material.text_2_a": "Écrivez vous-même ou téléchargez des images, PDF, vidéos",
  "onboarding.create_material.text_2_b": "Utilisez l'IA pour ajuster, simplifier, différencier",
  "onboarding.create_material.text_2_c": "Créez des tâches pour des sections spécifiques",
  "onboarding.create_material.text_2_d": "Les matériels sont rapidement créés et formatables de manière flexible",
  "item_detail.teachino_ai_questions": "Questions",
  "item_detail.teachino_ai_questions.reproduction.title": "Reproduction",
  "item_detail.teachino_ai_questions.reproduction.description": "Répétition des faits",
  "item_detail.teachino_ai_questions.reorganisation.title": "Réorganisation",
  "item_detail.teachino_ai_questions.reorganisation.description": "Expliquer, traiter et organiser de manière autonome",
  "item_detail.teachino_ai_questions.reflection.title": "Réflexion",
  "item_detail.teachino_ai_questions.reflection.description": "Interpréter et évaluer, reconnaître les relations, résoudre des problèmes",
  "item_detail.teachino_ai_context": "IA pour ce texte",
  "ai_setting.language": "Dans quelle langue l'IA doit-elle générer des résultats ?",
  "feature_course.onboarding.subject.other_lesson_language_label": "Langue du cours",
  "feature_course.onboarding.subject.other_lesson_language_placeholder": "Saisir la langue du cours",
  "feature_course.onboarding.subject.default_course_language": "Français",
  "ai_setting.description": "Avec ces paramètres, vous pouvez influencer les suggestions de l'IA de Teachino. L'IA se base sur ces paramètres et sur le matériel utilisé.",
  "ai_setting.no_permission": "Les paramètres de l'IA ne peuvent être modifiés que par le créateur du cours.",
  "ai_setting.inline_header": "Paramètres pour l'IA",
  "ai_setting.inline_sub_header": "Programme, langue, ...",
  "ai_setting.curriculum_other": "Entrer un programme personnalisé",
  "ai_setting.age": "Quel âge ont les élèves pour lesquels les résultats de l'IA seront utilisés ?",
  "ai_settings.age_placeholder": "Âge des élèves en années",
  "ai_setting.subject": "Indiquez le sujet aussi précisément que possible",
  "ai_setting.curriculum": "Programme / Curriculum",
  "ai_setting.curriculum_country": "Pays",
  "ai_setting.curriculum_state": "Région",
  "ai_setting.curriculum_name": "Type d'école",
  "ai_setting.curriculum_description": "Copiez le programme, le curriculum ou le curriculum scolaire dans le champ de texte. L'IA de Teachino pourra s'y référer. Ce texte peut contenir jusqu'à 18 000 caractères et ne doit inclure que les sections pertinentes pour le niveau/classe.",
  "ai_setting.curriculum_placeholder": "Vous pouvez coller tout le texte non formaté ici",
  "ai_setting.curriculum_maxlength": "Le programme / Curriculum doit avoir un maximum de {{max_length}} caractères. Les textes plus longs seront coupés.",
  "ai_setting.curriculum.school_type": "Type d'école",
  "ai_setting.curriculum.subject": "Sujet",
  "ai_setting.curriculum.class_level": "Niveau scolaire / Classe",
  "ai_setting.curriculum.disclaimer": "<strong>Votre programme n'est pas disponible ?</strong> Pas de problème ! Choisissez simplement <strong>\"entrer un programme personnalisé\"</strong>, copiez votre programme et déposez-le dans le champ de texte correspondant. <strong>Besoin d'aide ou de questions ?</strong> Consultez notre <a class=\"underline text-primary-500\" href=\"https://www.teachino.io/hilfe#faq\" target=\"_blank\">page d'aide</a>.",
  "ai_setting.checkmarks.age": "Âge des élèves",
  "ai_setting.checkmarks.subject": "Sujet",
  "ai_setting.checkmarks.language": "Langue de l'enseignement",
  "ai_setting.checkmarks.curriculum_available": "Programme disponible",
  "ai_setting.cta_settings.description": "Aucun paramètre d'IA n'est défini pour ce cours. Indiquez l'âge, le sujet, le programme, ... pour améliorer les résultats.",
  "ai_setting.cta_settings.button": "Saisir des données",
  "ai_setting.cta_curriculum.description": "Pour de meilleurs résultats, chargez votre programme.",
  "ai_setting.cta_curriculum.button": "Saisir le programme",
  "ai.generate_short": "Inspiration IA",
  "ai.prompt_selector.generic": "Que souhaitez-vous créer ?",
  "ai.prompt_selector.period": "Comment l'IA doit-elle aider ?",
  "ai.course.topics.title": "Reihe",
  "ai.course.topics.description": "Suggestions pour des séries",
  "ai.topic.goals.title": "Objectifs d'apprentissage",
  "ai.topic.goals.description": "Objectifs d'apprentissage pour cette série",
  "ai.topic.items.title": "Matériels",
  "ai.topic.items.description": "Suggestions pour des matériels",
  "ai.topic.hooks.title": "Exercices d'activation",
  "ai.topic.hooks.description": "Idées créatives pour commencer l'heure",
  "ai.topic.real_world.title": "Liens thématiques",
  "ai.topic.real_world.description": "Exemples quotidiens en rapport avec la matière",
  "ai.topic.team_building.title": "Activités d'échauffement",
  "ai.topic.team_building.description": "Jeux et exercices pour la classe",
  "ai.topic.cross_subject.title": "Travail interdisciplinaire",
  "ai.topic.cross_subject.description": "Idées de projets interdisciplinaires",
  "ai.item.questions.title": "Questions",
  "ai.item.questions.description": "Génère des questions à différents niveaux",
  "ai.item.summary.title": "Résumé",
  "ai.item.summary.description": "Rédige une introduction pour les élèves",
  "ai.item.glossary.title": "Glossaire",
  "ai.item.glossary.description": "Trouve des mots importants et les définit",
  "ai.item.goals.title": "Objectifs détaillés",
  "ai.item.goals.description": "Crée des objectifs d'apprentissage appropriés pour ce matériel",
  "ai.snippet.questions.description": "Génère des questions appropriées au texte",
  "ai.snippet.glossary.description": "Trouve des mots importants dans le texte et les définit",
  "ai.snippet.simplify.title": "Simplifier",
  "ai.snippet.simplify.description": "Simplifie ce texte",
  "ai.snippet.simplify.title.age": "Texte pour ce cours",
  "ai.snippet.simplify.description.age": "Formule le texte adapté à l'âge des élèves",
  "ai.snippet.simplify.title.A1": "Texte - A1",
  "ai.snippet.simplify.description.A1": "Réécrit le texte pour le niveau A1",
  "ai.snippet.simplify.title.A2": "Texte - A2",
  "ai.snippet.simplify.description.A2": "Réécrit le texte pour le niveau A2",
  "ai.snippet.simplify.title.B1": "Texte - B1",
  "ai.snippet.simplify.description.B1": "Réécrit le texte pour le niveau B1",
  "ai.snippet.simplify.title.B2": "Texte - B2",
  "ai.snippet.simplify.description.B2": "Réécrit le texte pour le niveau B2",
  "ai.snippet.simplify.title.C1": "Texte - C1",
  "ai.snippet.simplify.description.C1": "Réécrit le texte pour le niveau C1",
  "ai.snippet.simplify.title.C2": "Texte - C2",
  "ai.snippet.simplify.description.C2": "Réécrit le texte pour le niveau C2",
  "ai.snippet.simplify.title.simple_language": "Texte - Langage simple",
  "ai.snippet.simplify.description.simple_language": "Formule le texte selon les règles du langage simplifié",
  "ai.snippet.extend.title": "Continuer à écrire",
  "ai.snippet.extend.description": "Élargit et complète le texte",
  "ai.snippet.material_for_text.title": "Tâche",
  "ai.snippet.material_for_text.description": "Crée une tâche pour le texte",
  "ai.snippet.group_work_for_text.title": "Travail en groupe pour 4 groupes",
  "ai.snippet.group_work_for_text.description": "Crée des travaux de groupe pour le texte",
  "ai.questions.reproduction.title": "Reproduction",
  "ai.questions.reproduction.description": "Reproduction de faits",
  "ai.questions.reorganisation.title": "Réorganisation",
  "ai.questions.reorganisation.description": "Explication, traitement et organisation autonomes",
  "ai.questions.reflection.title": "Réflexion",
  "ai.questions.reflection.description": "Interpréter et évaluer, reconnaître les relations, résoudre des problèmes",
  "ai.loading.1": "Le curriculum est analysé",
  "ai.loading.2": "Planification annuelle en cours de traitement",
  "ai.loading.3": "Lien avec le thème en cours",
  "ai.loading.4": "Objectifs d'apprentissage pris en compte",
  "ai.loading.5": "Matériels en cours de lecture",
  "ai.success.title": "Propositions générées.",
  "ai.success.description": "Vous pouvez modifier ou désélectionner les suggestions.",
  "ai.success.questions.title": "Propositions générées.",
  "ai.success.questions.description": "Les questions sont visibles pour les élèves. Les réponses sont stockées uniquement pour les enseignants.",
  "ai.course_selector.title": "Veuillez sélectionner un cours pour que l'IA ait suffisamment de contexte.",
  "ai.topic_selector.title": "Veuillez sélectionner le thème auquel l'IA doit se référer.",
  "ai.topic_selector.empty": "Il n'y a pas encore de thèmes dans ce cours. Veuillez les créer dans la bibliothèque.",
  "ai.error.no_results_generated": "Malheureusement, Teachino IA n'a pu générer aucune inspiration appropriée. Veuillez vérifier que les paramètres de cours, le thème et le matériel utilisent des textes significatifs sur lesquels l'IA peut se baser. Plus il y a de contexte, meilleurs sont les résultats.",
  "ai.error.cta": "Redémarrer",
  "ai.loading.generating": "Génération d'inspiration IA",
  "ai.success.saved": "Matériels IA enregistrés dans Teachino.",
  "ai.name": "Thena – Votre assistante personnelle IA",
  "ai.assistant.title": "Assistant IA",
  "material.ai.create.quick_actions_label": "Générer avec l’IA :",
  "ai.assistant.new_chat": "Nouvelle discussion",
  "ai.assistant.open": "Ouvrir la discussion",
  "ai.assistant.launcher.tooltip": "Ouvrir l'assistant IA",
  "ai.assistant.period_context.date_only": "L'enseignant consulte la leçon du {{formattedDate}}. Les nouveaux matériels créés ici doivent être planifiés pour le {{planningTargetDate}}.",
  "ai.assistant.period_context.pill_date_only": "{{formattedDate}}",
  "ai.assistant.composer.remove_period_context": "Retirer le contexte de la leçon",
  "ai.assistant.generated_material.open_conversation": "Ouvrir dans l'assistant",
  "ai.assistant.generated_material.open_when_ready": "Le matériel est en cours de génération par l’IA. Dès qu’il sera prêt, vous pourrez l’ouvrir.",
  "ai.assistant.generated_material.created_in_folder": "Créé dans le dossier {{folderName}}",
  "ai.assistant.generated_material.target_folder_label": "Dossier : {{folderName}}",
  "ai.assistant.generated_material.prompt_label": "Prompt de génération utilisé",
  "ai.material.approval.tag_create": "Vérifier le matériel",
  "ai.material.approval.tag_rework": "Retravail à réviser",
  "ai.material.approval.banner_create_title": "L'IA a créé ce matériel",
  "ai.material.approval.banner_create_description": "Vérifiez le contenu et approuvez la modification, ou adaptez le matériel.",
  "ai.material.approval.banner_rework_title": "L'IA a modifié ce matériel",
  "ai.material.approval.banner_rework_description": "Vérifiez les modifications et approuvez-les, ou adaptez le matériel.",
  "ai.material.approval.approve_button": "Vérifié",
  "ai.assistant.close": "Fermer",
  "ai.assistant.back_to_start": "Retour au début",
  "ai.assistant.back_to_chat": "Retour à la discussion",
  "ai.assistant.mode_fullscreen": "Plein écran",
  "ai.assistant.mode_sidebar": "Barre latérale",
  "ai.assistant.mode_floating": "Flottant",
  "ai.assistant.display_mode": "Affichage du chat",
  "ai.assistant.expand": "Agrandir",
  "ai.assistant.collapse": "Réduire",
  "ai.assistant.history.title": "Historique des discussions",
  "ai.assistant.history.recent": "Discussions récentes",
  "ai.assistant.history.conversation": "Discussion",
  "ai.assistant.history.delete": "Supprimer la discussion",
  "ai.assistant.history.show": "Tout afficher",
  "ai.assistant.history.load_more": "Afficher plus",
  "ai.assistant.history.loading_recent": "Chargement des discussions récentes…",
  "ai.assistant.history.just_now": "À l'instant",
  "ai.assistant.history.minutes_ago": "il y a {{count}} min",
  "ai.assistant.history.hours_ago": "il y a {{count}} h",
  "ai.assistant.history.days_ago": "il y a {{count}} j",
  "ai.assistant.history.needs_confirmation": "Confirmation requise",
  "ai.assistant.history.running": "Réponse en cours",
  "ai.assistant.history.unread": "Nouveaux messages non lus",
  "ai.assistant.suggestions.title": "Suggestions",
  "ai.assistant.suggestion.lesson.title": "Planifier un cours",
  "ai.assistant.suggestion.lesson.prompt": "Aide-moi à planifier mon prochain cours pour cette classe.",
  "ai.assistant.suggestion.material.title": "Créer du matériel",
  "ai.assistant.suggestion.material.prompt": "Crée une fiche d'exercices différenciée pour mon prochain cours sur le thème : ",
  "ai.assistant.suggestion.material.question": "Sur quel thème doit porter le matériel ?",
  "ai.assistant.suggestion.material.suggest_prompt": "Crée une fiche d'exercices différenciée pour mon prochain cours.",
  "ai.assistant.suggestion.support.title": "Aider les élèves",
  "ai.assistant.suggestion.support.prompt": "Suggère des moyens d'aider les élèves en difficulté.",
  "ai.assistant.suggestion.reflect.title": "Réfléchir au cours",
  "ai.assistant.suggestion.reflect.prompt": "Aide-moi à réfléchir au cours d'aujourd'hui et à planifier les prochaines étapes.",
  "ai.assistant.messages.load_earlier": "Charger les messages précédents",
  "ai.assistant.message.copy": "Copier",
  "ai.assistant.message.helpful": "Utile",
  "ai.assistant.message.not_helpful": "Pas utile",
  "ai.assistant.message.feedback_received": "Merci pour votre retour.",
  "ai.assistant.message.sending": "Envoi en cours",
  "ai.assistant.message.failed": "Échec de l'envoi. Votre texte a été restauré.",
  "ai.assistant.message.show_more": "Afficher plus",
  "ai.assistant.message.show_less": "Afficher moins",
  "ai.assistant.message.link_redirect_limit": "Nous n’avons pas pu ouvrir ce lien, car il comporte trop de redirections. Utilise l’URL directe de la page de destination ou importe le document.",
  "ai.assistant.attachment.unreadable": "Le fichier n'a pas pu être lu",
  "ai.assistant.attachment.unreadable_hint": "Le contenu de ce fichier n'a pas pu être extrait, l'assistant IA ne peut donc pas l'utiliser. Collez le texte directement ou téléversez à nouveau le fichier au format PDF ou image.",
  "ai.assistant.composer.add_source": "Ajouter une source",
  "ai.assistant.composer.attachment_limit": "Vous pouvez ajouter jusqu’à {{count}} sources par message.",
  "ai.assistant.composer.remove_material_context": "Retirer le contexte du matériel",
  "ai.assistant.composer.placeholder": "Interroger l'assistant IA…",
  "ai.assistant.course_selection.section_title": "Cours de cette année scolaire",
  "ai.assistant.course_selection.loading": "Chargement des cours…",
  "ai.assistant.course_selection.error": "Impossible de charger les cours",
  "ai.assistant.course_selection.empty": "Aucun cours disponible",
  "ai.assistant.course_selection.select_course": "Sélectionner un cours",
  "ai.assistant.course_selection.continue": "Sélectionnez un cours pour continuer",
  "ai.assistant.course_selection.setup_required": "Configuration requise",
  "ai.assistant.course_selection.owner_setup_required": "La personne responsable du cours doit compléter les paramètres du cours",
  "ai.assistant.course_setup.banner.description": "Ajoute la matière et la classe pour de meilleurs résultats",
  "ai.assistant.course_setup.banner.action": "Compléter les paramètres de l’IA",
  "ai.assistant.course_selection.selected": "Cours sélectionné",
  "ai.assistant.user_selection.other": "Autre chose",
  "ai.assistant.user_selection.selected": "Sélectionné",
  "ai.assistant.user_selection.other_placeholder": "Saisissez votre propre réponse…",
  "ai.assistant.user_selection.submit": "Envoyer la réponse",
  "ai.assistant.topic_question.suggest": "Afficher des suggestions",
  "ai.assistant.topic_question.subject_label": "Mon thème",
  "ai.assistant.topic_question.subject_placeholder": "Saisissez un thème…",
  "ai.assistant.topic_question.submit": "Envoyer le thème",
  "ai.assistant.composer.send": "Envoyer le message",
  "ai.assistant.run.stop": "Arrêter la réponse",
  "ai.assistant.stream.connecting": "Connexion en cours",
  "ai.assistant.stream.reconnecting": "Reconnexion en cours",
  "ai.assistant.tool.working": "Traitement en cours…",
  "ai.assistant.tool.search_images": "Recherche d’images adaptées…",
  "ai.assistant.tool.read_product_guidance": "Vérification des actions disponibles…",
  "ai.assistant.tool.search_help_center": "Recherche dans le centre d’aide…",
  "ai.assistant.tool.read_help_article": "Lecture de l’article d’aide…",
  "ai.assistant.tool.search_web": "Recherche sur le Web…",
  "ai.assistant.tool.search_wikipedia": "Recherche sur Wikipédia…",
  "ai.assistant.tool.search_youtube": "Recherche sur YouTube…",
  "ai.assistant.tool.load_youtube_transcript": "Lecture de la transcription vidéo…",
  "ai.assistant.tool.load_webpage": "Lecture de la page Web…",
  "ai.assistant.tool.list_courses": "Chargement des cours…",
  "ai.assistant.tool.list_course_content": "Lecture du contenu du cours…",
  "ai.assistant.tool.search_course_materials": "Recherche dans les supports du cours…",
  "ai.assistant.tool.load_materials": "Chargement des supports…",
  "ai.assistant.tool.read_course_timetable": "Consultation de l’emploi du temps…",
  "ai.assistant.tool.read_course_planning": "Consultation de la planification…",
  "ai.assistant.tool.read_students": "Chargement des élèves…",
  "ai.assistant.tool.read_student_documentation": "Lecture du suivi des élèves…",
  "ai.assistant.tool.create_course_materials": "Création des supports…",
  "ai.assistant.tool.edit_course_material": "Adaptation du support…",
  "ai.assistant.tool.convert_worksheet": "Conversion de la fiche…",
  "ai.assistant.tool.create_course_folders": "Création des dossiers…",
  "ai.assistant.tool.create_todo": "Création de la tâche…",
  "ai.assistant.tool.mark_todos_done": "Validation des tâches…",
  "ai.assistant.tool.add_lesson_note": "Ajout de la note de cours…",
  "ai.assistant.tool.add_period_tags": "Ajout des étiquettes de séance…",
  "ai.assistant.tool.create_student_documentation": "Création du suivi d’élève…",
  "ai.assistant.tool.set_material_visibility": "Mise à jour de la visibilité du support…",
  "ai.assistant.tool.plan_materials_for_date": "Planification des supports…",
  "ai.assistant.tool.remove_materials_from_date": "Retrait des supports de la date…",
  "ai.assistant.tool.move_course_content": "Déplacement du contenu du cours…",
  "ai.assistant.tool.copy_course_content": "Copie du contenu du cours…",
  "ai.assistant.tool.request_user_selection": "Préparation des options…",
  "ai.assistant.tool.request_course_selection": "Préparation de la sélection du cours…",
  "ai.assistant.action.default_title": "Action",
  "ai.assistant.action.discarded": "Rejetée",
  "ai.assistant.error.response": "Une erreur s'est produite. Veuillez réessayer.",
  "ai.assistant.context.current_course": "Cours actuel",
  "ai.assistant.context.current_folder": "Dossier actuel",
  "ai.assistant.context.current_material": "Matériel actuel",
  "ai.assistant.context.course": "Cours",
  "ai.assistant.context.material": "Matériel",
  "ai.assistant.job.cancel": "Annuler la génération",
  "ai.assistant.job.cancel_all": "Tout annuler",
  "ai.assistant.job.review": "Vérifier",
  "ai.assistant.job.stage.create.planning": "Vérification et planification de la demande",
  "ai.assistant.job.stage.create.creating": "Rédaction du contenu",
  "ai.assistant.job.stage.create.preparing": "Création des images et préparation du matériel",
  "ai.assistant.job.stage.rework.planning": "Vérification et planification de la révision",
  "ai.assistant.job.stage.rework.creating": "Révision du matériel",
  "ai.assistant.job.stage.rework.preparing": "Intégration et préparation des modifications",
  "ai.assistant.job.stage.conversion.planning": "Lecture de la fiche de travail",
  "ai.assistant.job.stage.conversion.creating": "Conversion des exercices",
  "ai.assistant.job.stage.conversion.preparing": "Préparation du matériel",
  "ai.assistant.job.stage.saving": "Enregistrement du matériel",
  "ai.assistant.job.progress.queued": "Dans la file d’attente",
  "ai.assistant.job.progress.step": "Étape {{step}} sur {{stepCount}} · {{stage}}",
  "ai.assistant.job.progress.elapsed": "en cours depuis {{duration}}",
  "ai.assistant.job.progress.patience_hint": "Cela prend généralement 1 à 2 minutes. Vous pouvez continuer à travailler : nous vous préviendrons dès que le matériel sera prêt.",
  "ai.assistant.job.ready.image_omissions": "Prêt – remarque sur les images",
  "ai.assistant.job.image_omissions": "Une image n’a pas pu être intégrée. Le document est disponible.",
  "ai.assistant.job.image_required_missing": "Au moins une image demandée manque. Le document est disponible.",
  "ai.assistant.job.image_optional_details": "Image supplémentaire omise – détails de la recherche",
  "ai.assistant.job.image_details": "Pourquoi l’image manque-t-elle ?",
  "ai.assistant.job.image_reason.no_suitable_candidate": "La recherche n’a fourni aucune image adaptée et vérifiée.",
  "ai.assistant.job.image_reason.search_unavailable": "Le service d’images était indisponible pendant cette recherche.",
  "ai.assistant.job.image_reason.verification_unavailable": "L’adéquation de l’image n’a pas pu être vérifiée de manière fiable.",
  "ai.assistant.job.image_reason.generation_failed": "L’image n’a pas pu être créée ou enregistrée correctement.",
  "ai.assistant.job.image_reason.omitted_from_output": "Une image prévue n’a pas été intégrée au document final.",
  "ai.assistant.job.image_reason.not_attempted": "La génération s’est terminée sans l’image demandée ; aucune tentative n’a été enregistrée.",
  "ai.assistant.job.ready.title": "Prêt à ouvrir",
  "ai.assistant.job.failed.title": "Échec de la création",
  "ai.assistant.job.ready.toast": "« {{title}} » est prêt",
  "ai.assistant.job.ready.toast_many": "{{count}} matériels sont prêts",
  "ai.assistant.job.ready.badge_aria_zero": "Aucun matériel terminé dans l’assistant IA",
  "ai.assistant.job.ready.badge_aria_one": "1 matériel terminé dans l’assistant IA",
  "ai.assistant.job.ready.badge_aria_many": "{{number}} matériels terminés dans l’assistant IA",
  "ai.assistant.job.open_material": "Ouvrir le matériel",
  "ai.assistant.job.open_preview": "Ouvrir l’aperçu du matériel",
  "ai.personification": "Thena – Votre assistante IA",
  "ai.you": "Vous",
  "ai.prompt.placeholder": "Comment puis-je vous aider aujourd'hui ?",
  "ai.prompt.continue": "Tapez votre réponse...",
  "ai.prompt.hint.1": "Traduisez le résultat",
  "ai.prompt.hint.1_prompt": "Traduisez le résultat en ",
  "ai.prompt.hint.2": "Raccourcissez le résultat",
  "ai.prompt.hint.2_prompt": "Raccourcissez le résultat",
  "ai.prompt.hint.3": "Prolongez le résultat",
  "ai.prompt.hint.3_prompt": "Prolongez le résultat",
  "ai.prompt.hint.4": "Simplifiez le résultat",
  "ai.prompt.hint.4_prompt": "Simplifiez le résultat au niveau de langue A2",
  "ai.prompt.hint.5": "Que pourrais-je faire d'autre ?",
  "ai.prompt.hint.5_prompt": "Faites-moi cinq suggestions de prompts IA courts que je pourrais utiliser en texte pour poursuivre le résultat.",
  "ai.course_first_banner.text": "Vous cherchez le champ de saisie du prompt ? Vous le trouverez désormais dans chaque cours. L'IA reçoit ainsi davantage de contexte et enregistre le matériel au bon endroit. Choisissez un cours dans la barre de navigation pour commencer.",
  "ai.tasks.show_more": "afficher plus",
  "ai.tasks.show_less": "afficher moins",
  "ai.disclaimer": "L'IA peut faire des erreurs. Ne saisissez aucune donnée personnelle.",
  "ai.disclaimer_students": "Ce chat utilise l'intelligence artificielle. Les réponses sont générées par l'IA et peuvent être inexactes ou incorrectes. Gardez une attitude critique et vérifiez les informations si nécessaire. Ne partagez pas de données personnelles. Amusez-vous bien en discutant !",
  "ai.area_youtube_error.description": "Thena n'a pas pu lire les sous-titres. Veuillez copier les sous-titres dans le champ ci-dessous pour que Thena puisse générer des matériaux.",
  "ai.area_youtube.title": "IA pour les vidéos",
  "ai.area_youtube.description": "Thena lit les sous-titres des vidéos et crée des matériaux appropriés. Entrez simplement le lien de la vidéo. Thena ne peut pas encore lire les vidéos sans sous-titres.",
  "ai.area_youtube.label": "Lien de la vidéo Youtube",
  "ai.area_youtube.error": "Veuillez entrer un lien valide vers une vidéo Youtube.",
  "ai.area_youtube.iframe_error": "Erreur d'affichage de la vidéo",
  "ai.area_docs.title": "IA pour les documents",
  "ai.area_docs.description": "Thena lit les textes dans les documents et crée des matériaux appropriés.",
  "ai.area_docs.types": "Fichiers pris en charge :",
  "ai.area_websites.title": "IA pour les sites web",
  "ai.area_websites.description": "Thena lit le texte sur le site et crée des matériaux appropriés.",
  "ai.area_text.title": "IA pour les textes",
  "ai.area_text.description": "Thena lit le texte saisi et crée des matériaux appropriés. Vous pouvez également télécharger des sous-titres de vidéos.",
  "ai.area_images.title": "IA pour les images",
  "ai.area_images.description": "Thena reconnaît les textes sur les photos, les lit et crée des matériaux appropriés.",
  "ai.course_settings_age_missing.before": "(Astuce : Vous pouvez entrer l'âge de vos élèves dans les",
  "ai.course_settings_age_missing.label": "paramètres du cours",
  "ai.course_settings_age_missing.after": ", pour le sauvegarder pour les discussions futures. Plus j'ai d'informations sur votre cours, meilleures seront mes réponses.)",
  "onboarding_tutorial.enter_courses_header": "Dernière étape : créer des cours",
  "library.title": "Matériels & Thèmes",
  "library.new_items": "Nouveaux matériaux",
  "library.search_topics": "Chercher",
  "library.search_hint": "Veuillez entrer au moins 3 caractères",
  "library.remove_topic_from_course": "Retirer le thème du cours",
  "library.add_dates": "Date de début et de fin",
  "library.add_dates_placeholder": "Choisir la date de début et de fin",
  "library.remove_dates": "Supprimer la période",
  "library.remove_topic": "Supprimer \"{{topic}}\" ?",
  "library.remove_course_topic": "Retirer \"{{topic}}\" du cours ?",
  "library.remove_item": "Supprimer \"{{item}}\" ?",
  "library.remove_topics": "Supprimer {{number}} thèmes ?",
  "library.remove_course_topics": "Retirer {{number}} thèmes du cours ?",
  "library.remove_items": "Supprimer {{number}} matériaux ?",
  "library.remove_topic.confirm": "Supprimer {{topic}}",
  "library.remove_course_topic.confirm": "Retirer {{topic}} du cours",
  "library.remove_topics.confirm": "Supprimer les thèmes",
  "library.remove_course_topics.confirm": "Retirer les thèmes du cours",
  "library.remove_item.confirm": "Supprimer {{item}}",
  "library.remove_items.confirm": "Supprimer {{number}} matériaux",
  "library.remove_topic_pre": "Voulez-vous ",
  "library.remove_course_topic_pre": "Voulez-vous ",
  "library.remove_topic_post": " supprimer définitivement ? Le thème et tous les matériaux qu'il contient seront irrémédiablement supprimés.",
  "library.remove_course_topic_post": " retirer du cours ? Toutes les données de planification seront perdues. Le thème reste dans la bibliothèque.",
  "library.remove_item_pre": "Voulez-vous ",
  "library.remove_item_post": " supprimer définitivement ? Les matériaux seront irrémédiablement supprimés.",
  "library.remove_topics.description": "Voulez-vous supprimer définitivement {{number}} thèmes ? Les thèmes et tous les matériaux qu'ils contiennent seront irrémédiablement supprimés.",
  "library.remove_course_topics.description": "Voulez-vous retirer {{number}} thèmes du cours ? Toutes les données de planification seront perdues. Les thèmes restent dans la bibliothèque.",
  "library.remove_items.description": "Voulez-vous supprimer définitivement {{number}} matériaux ? Les matériaux seront irrémédiablement supprimés.",
  "library.remove_topic_force_pre": "Le thème ",
  "library.remove_item_force_pre": "Le matériel ",
  "library.remove_topic_force_post": " est utilisé dans les cours (ouverts) ",
  "library.remove_item_force_post": " est utilisé dans les cours (ouverts) ",
  "library.remove_topic_force_end": ". Voulez-vous le supprimer avec tous les matériaux qu'il contient et également supprimer toutes les planifications associées passées et futures ?",
  "library.remove_item_force_end": ". Voulez-vous supprimer le matériel et également supprimer toutes les planifications associées passées et futures ?",
  "library.remove_topics_force_pre": "Les thèmes sont utilisés dans les cours (ouverts) ",
  "library.remove_items_force_pre": "Les matériaux sont utilisés dans les cours (ouverts) ",
  "library.remove_topics_force_end": ". Voulez-vous les supprimer avec tous les matériaux qu'ils contiennent et également supprimer toutes les planifications associées passées et futures ?",
  "library.remove_items_force_end": ". Voulez-vous supprimer les matériaux et également supprimer toutes les planifications associées passées et futures ?",
  "library.remove_item.success_one": "Matériel supprimé",
  "library.remove_item.success_many": "Matériaux supprimés",
  "library.topics_autocomplete.label": "Choisir un thème",
  "library.topics_autocomplete.placeholder": "Chercher un thème",
  "library.topics_autocomplete.current_course": "Thèmes dans le cours",
  "library.topics_autocomplete.all_courses": "Tous les thèmes",
  "library.topics_autocomplete.create_description": "Dans quel thème le matériel doit-il être créé?",
  "library.topics_autocomplete.new_topic": "Nouveau thème",
  "library.topics_autocomplete.back": "Retourner à la liste",
  "library.duplicate_items.duplicate_one_description": "Dupliquer {{item}}",
  "library.duplicate_items.duplicate_many_description": "Dupliquer {{number}} matériels",
  "library.duplicate_items.confirm": "Dupliquer vers {{topic}}",
  "library.duplicate_items.success": "Matériau dupliqué",
  "library.move_items.move_one_description": "Déplacer {{item}}",
  "library.move_items.move_many_description": "Déplacer {{number}} matériels",
  "library.move_items.confirm": "Déplacer vers {{topic}}",
  "library.move_items.success": "Matériau déplacé",
  "library.add_topic_to_courses": "Ajouter le thème aux cours",
  "library.add_topic_to_courses.link": "Ajouter le thème à d'autres cours",
  "presentation.title": "Mode présentation",
  "presentation.course_title": "{{courseName}} le {{date}}",
  "presentation.empty.title": "Aucun matériel prévu",
  "presentation.empty.description": "Une fois l'heure planifiée, elle peut être présentée ici sur le projecteur ou le tableau numérique. Vous contrôlez quels éléments vos élèves peuvent voir.",
  "presentation.empty.material": "Ce matériau est vide.",
  "presentation.empty.cta": "Vers l'emploi du temps",
  "create_item.create_item": "Créer un matériel",
  "create_item.generate_item": "Générer un matériel avec l'IA",
  "create_item.new_item": "Nouveau matériel",
  "create_item.save_item": "Enregistrer le matériel",
  "create_item.topic_tooltip": "Les matériaux sont assignés à des thèmes pour un accès facilité ultérieur.",
  "create_item.topic_only_description": "Choisissez le thème dans lequel {{itemName}} doit être enregistré.",
  "create_item.topic_only_footer_course": "Vous trouverez le matériel ensuite dans le cours et dans votre bibliothèque",
  "create_item.search_topic": "Choisir un thème",
  "create_item.title_label": "Nom du matériel",
  "create_item.new_topic": "Créer un nouveau thème",
  "create_item.new_topic_extension": "créer",
  "create_item.item_input_placeholder": "Feuille de travail, exercice dans le manuel, vidéo, …",
  "create_item.generic_error": "Erreur lors de la création du matériel",
  "create_item.add_snippets": "Ajouter des contenus",
  "create_item.empty_title": "Veuillez entrer un nom pour le matériel.",
  "create_item.empty_topic": "Veuillez sélectionner un thème auquel ce matériel doit être associé.",
  "create_item.empty_link": "Veuillez fournir un lien valide.",
  "create_item.successful": "Matériel créé!",
  "select_course.empty_state": "Vous n'avez pas encore créé de cours.",
  "upgrade.feature_discovered.dialog_title": "Mise à niveau nécessaire",
  "upgrade.feature_discovered.title": "Profite de toutes les fonctionnalités",
  "upgrade.feature_discovered.description": "Souscris une licence maintenant et continue à travailler sans limites.",
  "upgrade.feature_discovered.cta": "En savoir plus",
  "upgrade.soft_paywall.grace_days_left": "Encore {{days}} jours d'accès gratuit.",
  "upgrade.soft_paywall.trial_days_left": "Encore {{days}} jours d'essai.",
  "upgrade.feature.ai.title": "Accès à l'assistant IA Thena",
  "upgrade.feature.ai.description": "Votre assistant IA en classe",
  "upgrade.feature.ai.description_2": "Thena est votre assistant IA personnel et interactif ",
  "upgrade.feature.ai.perk.trained_for_schools.title": "développé spécialement pour les écoles",
  "upgrade.feature.ai.perk.personalised.title": "résultats personnalisés",
  "upgrade.feature.ai.perk.personalised.description": "Références au programme, curriculum, aux heures programmées et à l'âge des élèves",
  "upgrade.feature.ai.perk.high_quality.title": "résultats de haute qualité",
  "upgrade.feature.ai.perk.high_quality.description": "Des prompts préconfigurés fournissent des résultats de qualité. De plus, par chat, les propositions peuvent être personnalisées et des demandes spécifiques peuvent être formulées.",
  "upgrade.feature.ai.perk.pro": "Tout ce qui est inclus dans la Licence pour enseignants pour 5 enseignants ou plus",
  "upgrade.feature.ai.perk.collaboration": "Collaboration dans les groupes disciplinaires, l'enseignement en équipe et les remplacements",
  "upgrade.feature.overview.title": "Accès illimité aux fonctions existantes et nouvelles",
  "upgrade.feature.overview.description": "Votre assistant IA en classe",
  "upgrade.feature.overview.description_2": "Thena est votre assistant IA personnel et interactif",
  "upgrade.feature.overview.perk.planning": "Planification annuelle et détaillée",
  "upgrade.feature.overview.perk.webuntis": "Intégration avec l'emploi du temps et le carnet de bord WebUntis",
  "upgrade.feature.overview.perk.library": "Bibliothèque personnelle",
  "upgrade.feature.overview.perk.collaborate": "Partager et traiter le matériel avec les collègues",
  "upgrade.feature.overview.perk.teamteaching": "Enseignement en équipe: planification conjointe des cours",
  "upgrade.feature.overview.perk.microsoft_integration": "Intégration avec OneNote, OneDrive et Microsoft Teams",
  "upgrade.feature.overview.perk.timetable": "Emploi du temps flexible (vacances, suppléances et rendez-vous privés)",
  "upgrade.feature.overview.perk.student_materials": "Matériaux pour élèves (via un lien)",
  "upgrade.feature.overview.perk.presentation_mode": "Mode de présentation",
  "upgrade.feature.storage.title": "Espace de stockage illimité",
  "upgrade.feature.storage.description": "Désormais, toute votre documentation trouve sa place !",
  "upgrade.feature.storage.description_2": "Avec la Licence pour enseignants, tu obtiens <strong>un espace de stockage illimité.</strong>",
  "upgrade.feature.daily_changes.title": "Emploi du temps flexible",
  "upgrade.feature.daily_changes.description": "Réglez les vacances, les remplacements, les annulations et les rendez-vous privés avec Teachino de manière simple.",
  "upgrade.feature.presentation.title": "Mode de présentation",
  "upgrade.feature.presentation.description": "Présentez vos matériaux en classe sur le tableau numérique ou via le projecteur.",
  "upgrade.feature.students.title": "Accès pour les élèves",
  "upgrade.feature.students.description": "Rendez votre planification et vos matériaux disponibles pour les élèves et les parents.",
  "upgrade.feature.student_evaluation.title": "Évaluation et retour",
  "upgrade.feature.student_evaluation.description": "Consultez les résultats par élève et par question, et donnez un retour individualisé sur les rendus.",
  "upgrade.feature.ipi.title": "Création illimitée de matériaux par IA",
  "upgrade.feature.ipi.description": "Générez des fiches interactives, des exercices et des idées de cours – sans limite.",
  "upgrade.feature.integration.title": "Intégré avec votre carnet de bord (WebUntis/Registre Numérique)",
  "upgrade.feature.integration.description": "Synchronisez l'emploi du temps et le carnet de bord pour les garder à jour.",
  "upgrade.feature.collaboration.title": "Collaboration avec les collègues",
  "upgrade.feature.collaboration.description": "Créez, éditez et partagez des matériaux avec vos collègues. La collaboration n'a jamais été aussi facile.",
  "upgrade.feature.school.perk.shareable": "Partage <strong>simple</strong> de matériaux au sein de l'école",
  "upgrade.feature.school.perk.collaborative": "<strong>Planification collective</strong> des cours (par exemple, dans les groupes disciplinaires)",
  "upgrade.feature.school.perk.training": "Accompagnement et formation du corps enseignant (webinaires gratuits, accompagnement individuel sur demande)",
  "upgrade.feature.school.perk.student_accounts": "Comptes élèves personnels avec code d'accès individuel",
  "upgrade.feature.school.perk.cost_relief": "Réduction des coûts pour les enseignants",
  "upgrade.school.description": "L'équipe Teachino est heureuse de se rendre (virtuellement) dans votre école et de présenter au corps enseignant les avantages de la licence scolaire en détail.",
  "upgrade.school.cta": "Demander une offre",
  "upgrade.buy.cta": "Souscrire une licence Pro",
  "upgrade.buy.trainee.discount": "🌱 Les stagiaires économisent sur la <strong>Licence pour enseignants</strong>",
  "upgrade.buy.trainee.cta_two_years": "50% pendant 2 ans",
  "upgrade.buy.trainee.cta_one_year": "25% pendant 1 an",
  "upgrade.buy.payment_cycle.label": "Durée",
  "upgrade.buy.payment_cycle.option_multiple": "{{months}} mois",
  "upgrade.buy.payment_cycle.option_one": "1 mois",
  "upgrade.buy.payment_cycle.price": "{{price}} / mois",
  "upgrade.buy.save_percent": "économisez {{percent}}%",
  "upgrade.buy.tag.loved": "Le plus populaire",
  "upgrade.buy.tag.cheapest": "Économisez {{percent}}%",
  "upgrade.discover.title": "Tu as découvert une fonction de la Licence pour enseignants !",
  "upgrade.discover.description": "Avec Pro, profitez de matériaux IA, d'un accès élèves et de toutes les fonctions avancées sans limite. Achetez vous-même ou demandez une licence scolaire.",
  "upgrade.discover.cta_buy": "Souscrire la Licence pour enseignants",
  "upgrade.discover.cta_school": "Demander une licence scolaire",
  "upgrade.discover.cta_school_extend": "Prolonger la licence scolaire",
  "upgrade.license_page.title_0": "Vos licences actuelles",
  "upgrade.license_page.title_1": "Votre licence actuelle",
  "upgrade.license_page.title_many": "Vos licences actuelles",
  "upgrade.license_page.upgrade.personal_licenses": "Licence personnelle",
  "upgrade.license_page.upgrade.tenant_licenses": "Licence scolaire",
  "upgrade.license_page.dpa_signed": "DPA signé",
  "upgrade.license_page.student_data_can_be_managed": "Les données des élèves peuvent être gérées",
  "upgrade.license_page.license_started_at": "Commencée le :",
  "upgrade.license_page.license_renews_at": "Renouvelée le :",
  "upgrade.license_page.license_expires_at": "Expire le :",
  "upgrade.license_page.license_expired_at": "Expirée le :",
  "upgrade.license_page.license_id": "Numéro de licence :",
  "upgrade.license_page.pro_offer_title": "Licence pour enseignants",
  "upgrade.license_page.pro_offer_subtitle": "Tout ce dont tu as besoin pour ton enseignement – sans limites, de la planification au retour d'information.",
  "upgrade.license_page.features": "Fonctionnalités incluses",
  "upgrade.license_page.manage": "Gérer",
  "upgrade.license_page.upgrade_school.title": "Licence pour écoles",
  "upgrade.license_page.upgrade_school.subtitle": "Un système commun pour l'enseignement numérique dans toute l'école",
  "upgrade.license_page.free_license_label": "Licence gratuite",
  "upgrade.license_page.trainee_discount": "🌱 Les stagiaires économisent sur la <strong>Licence pour enseignants</strong>",
  "upgrade.license_page.legal_billing": "Votre abonnement se renouvelle automatiquement pour la durée choisie. Résiliation jusqu'à 24 h à l'avance, effective à la fin de la période. <a href=\"/legal/terms\" target=\"_blank\" class=\"underline\">Détails dans les conditions d'utilisation</a>",
  "upgrade.license_page.school_perk_pro": "Tout ce qui est inclus dans la Licence pour enseignants pour 5 enseignants ou plus",
  "upgrade.feature.files_unlimited": "Stockage illimité (jusqu'à 50 Mo par fichier)",
  "upgrade.feature.files_restricted": "250 Mo de stockage",
  "upgrade.feature.daily_changes": "Modifications quotidiennes dans l'emploi du temps (annulations, remplacements, vacances, rendez-vous personnels, ...)",
  "upgrade.feature.collaboration_teamteaching": "Teamteaching dans les cours",
  "upgrade.feature.collaboration_course_templates": "Collaboration et création de collections",
  "upgrade.feature.collaboration_substitutions": "Partager les matériaux et les plans avec les remplaçants",
  "upgrade.feature.student_access": "Accès pour les élèves",
  "upgrade.feature.ai_basic": "Suggestions simples de l'IA",
  "upgrade.feature.ai_advanced": "Suggestions avancées de l'IA basées sur les matériaux et le plan d'études/curriculum scolaire",
  "upgrade.feature.integration_timetable": "Intégration avec l'emploi du temps & cahier de classe",
  "upgrade.feature.presentation": "Mode présentation",
  "upgrade.feature.ai_curriculum_title": "Résultats plus précis avec référence au curriculum",
  "upgrade.feature.ai_curriculum_description": "Avec une licence Pro ou une licence scolaire, vous pouvez télécharger un curriculum scolaire ou choisir parmi des programmes d'études préconfigurés. Cela améliore la précision et la qualité des résultats de l'IA.",
  "upgrade.plan.teacher_pro": "Enseignant Pro",
  "upgrade.plan.teachino_school": "Licence pour écoles",
  "upgrade.plan.cgie_pro": "Licence dans le cadre du Compas de l'IA du Script.",
  "upgrade.plan.teacher_free": "Gratuit",
  "upgrade.plan.teacher_free_light": "Gratuit",
  "upgrade.plan.dpa_only": "Accord de traitement des données signé",
  "upgrade.plan.type.friends": "Amis & Famille Teachino",
  "upgrade.plan.teachino_school_complete": "Licence pour écoles y compris le pack IA",
  "upgrade.plan.teachino_school_trial": "Licence pour écoles - Licence d'essai",
  "upgrade.plan.teachino_school_expired": "Licence pour écoles - Licence expirée",
  "upgrade.plan.teachino_school_suedtirol": "Teachino École Tyrol du Sud",
  "upgrade.plan.teachino_pro_ai": "Enseignant Pro y compris le pack IA",
  "upgrade.plan.teachino_school_complete_trial": "Licence pour écoles y compris le pack IA",
  "upgrade.plan.teacher_pro_trial": "Licence pour enseignants",
  "upgrade.plan.teacher_pro_beta": "Amis & Famille Teachino",
  "upgrade.plan.type.paid": "Payé",
  "upgrade.plan.type.free": "Gratuit",
  "upgrade.plan.type.trial": "Test gratuit",
  "upgrade.plan.type.expired": "Licence expirée",
  "upgrade.upgrade_required.title": "Mise à niveau nécessaire !",
  "upgrade.upgrade_required.description": "Cette fonctionnalité est disponible uniquement avec la Licence pour enseignants.",
  "upgrade.upgrade_required.description_2": "Mettez à niveau maintenant et profitez de toutes les fonctionnalités !",
  "upgrade.license_information.in_trial": "Ta période d'essai de la Licence pour enseignants se termine dans 5 jours ! Assure-toi d'avoir accès à toutes les fonctionnalités avec la",
  "upgrade.license_information.in_free": "Vous utilisez la version gratuite de Teachino ! Obtenez l'accès à toutes les fonctionnalités avec le",
  "upgrade.usp.trust": "Des milliers d'enseignants utilisent déjà la Licence pour enseignants quotidiennement",
  "upgrade.page.subtitle": "Débloquez la création illimitée de matériaux par IA, l'accès élèves et toutes les fonctions Pro – en licence personnelle ou scolaire.",
  "upgrade.page.features_heading": "Ce que t'apporte la Licence pour enseignants",
  "upgrade.page.pricing_heading": "Choisissez votre durée",
  "upgrade.usp.1": "Accès illimité à l'IA",
  "upgrade.usp.2": "Espace de stockage illimité",
  "upgrade.usp.3": "Rendez-vous personnels, tâches & vacances",
  "upgrade.feature.personal_planning.description": "Gérez rendez-vous personnels, tâches et vacances dans votre planification.",
  "upgrade.page.feature.storage.description": "Espace de stockage illimité pour tous vos supports pédagogiques.",
  "upgrade.page.feature.student_share.description": "Partagez l'accès à Teachino avec les élèves via un lien ou un code QR.",
  "upgrade.page.feature.class_register.description": "Transférez le contenu de cours planifié directement dans le cahier de classe (WebUntis/Registre numérique).",
  "upgrade.usp.4": "Intégration avec WebUntis",
  "upgrade.legal.billing": "Votre abonnement se renouvelle automatiquement pour la durée choisie. Résiliation jusqu'à 24 h à l'avance, effective à la fin de la période. <a href=\"/legal/terms\" target=\"_blank\" class=\"underline\">Détails dans les conditions d'utilisation</a>",
  "upgrade.plan.cta": "Mettre à niveau maintenant",
  "difusion.teacher_dashboard.title": "Tableau de bord enseignant",
  "difusion.teacher_dashboard.select_class": "Sélectionner une classe",
  "difusion.teacher_dashboard.students": "Élèves",
  "difusion.teacher_dashboard.reload": "Recharger",
  "difusion.teacher_dashboard.export_csv": "Exporter CSV",
  "difusion.teacher_dashboard.try_leo": "Essayer LEO",
  "difusion.teacher_dashboard.loading_classes": "Chargement des classes…",
  "difusion.teacher_dashboard.loading_students": "Chargement des élèves…",
  "difusion.teacher_dashboard.error": "Erreur",
  "difusion.teacher_dashboard.invalid_session": "Session invalide. Veuillez vous reconnecter.",
  "difusion.teacher_dashboard.load_students_error": "Erreur lors du chargement des élèves",
  "difusion.teacher_dashboard.no_classes": "Aucune classe disponible",
  "difusion.teacher_dashboard.no_students": "Aucun élève trouvé pour cette classe",
  "difusion.teacher_dashboard.surname": "NOM",
  "difusion.teacher_dashboard.name": "PRÉNOM",
  "difusion.teacher_dashboard.status": "STATUT",
  "difusion.teacher_dashboard.completed_conversations": "CONVERSATIONS TERMINÉES",
  "difusion.teacher_dashboard.last_activity": "DERNIÈRE ACTIVITÉ",
  "difusion.teacher_dashboard.chat_history": "HISTORIQUE DU CHAT",
  "difusion.teacher_dashboard.class_id": "ID de classe",
  "difusion.teacher_dashboard.status.not_started": "Non commencé",
  "difusion.teacher_dashboard.status.in_progress": "En cours",
  "difusion.teacher_dashboard.status.completed": "Terminé",
  "difusion.teacher_dashboard.class_fallback": "Classe {{number}}",
  "embed.error.no_auth": "Échec de la connexion",
  "embed.error.no_account": "Veuillez accéder à Teachino via le menu principal (à gauche) pour commencer. Une fois que vous vous êtes inscrit, vous verrez ici les matériaux prévus pour la leçon.",
  "embed.error.no_course_mapping": "Le matériel de cette leçon n'est visible que par les enseignants qui enseignent ou remplacent cette leçon.",
  "embed.error.no_course_found": "Aucun matériau n'a été rendu accessible pour ce cours dans Teachino.",
  "embed.error.no_course_found_description": "Avec Teachino, les enseignants peuvent préparer numériquement le cours et mettre les matériaux à disposition.",
  "embed.student.course_list.title": "Choisis ton cours",
  "embed.student.course_list.description": "Tu as accès à ces cours dans Teachino.",
  "embed.student.course_list.change_course": "Changer de cours",
  "embed.student.session_expired.title": "Ta connexion a expiré",
  "embed.student.session_expired.description": "Reconnecte-toi via le Digitales Register. Ensuite, tu retrouveras directement tes cours.",
  "embed.student.session_expired.action": "Se connecter via le Digitales Register",
  "embed.student.session_expired.description_eduplaces": "Reconnecte-toi via Eduplaces. Ensuite, tu retrouveras directement tes cours.",
  "embed.student.session_expired.action_eduplaces": "Se connecter via Eduplaces",
  "embed.student.session_expired.description_untis": "Reconnecte-toi via WebUntis. Ensuite, tu retrouveras directement tes cours.",
  "embed.student.session_expired.action_untis": "Se connecter via WebUntis",
  "embed.course.day_empty": "Aucun matériau n'a encore été libéré pour cette date.",
  "embed.error_generic.title": "La connexion à WebUntis n'a pas pu être établie.",
  "embed.error_generic.help": "Vous pouvez toujours accéder à votre bibliothèque à tout moment. Si l'emploi du temps de WebUntis ne se charge pas, vous pouvez sous Profil > Intégration déconnecter le calendrier et l'entrer manuellement pour continuer la planification de vos cours.",
  "embed.error.continue": "Continuer vers Teachino",
  "period.item_context.remove": "Retirer le matériel de la journée",
  "period.open_period": "Ouvrir la leçon",
  "period.start_presentation": "Commencer la présentation",
  "template.tag.topic": "Cette série se trouve dans une collection.",
  "template.tag.item": "Ce matériau se trouve dans une collection.",
  "template.topic.updates_available": "Des mises à jour sont disponibles pour cette série.",
  "template.topic.sync_topic_info.title": "Mettre à jour la série",
  "template.topic.sync_topic_info.description": "Met à jour la série (nom, objectifs, etc.) sans ajouter de nouveaux matériaux.",
  "template.topic.sync_new_items.title": "Ajouter de nouveaux matériaux",
  "template.topic.sync_new_items.description": "Ajoute de nouveaux matériaux de la collection. Les matériaux propres ajoutés ne seront pas modifiés.",
  "template.item.updates_available": "Des mises à jour sont disponibles pour ce matériau.",
  "template.item.sync_item_info.title": "Mettre à jour le matériau",
  "template.item.sync_item_info.description": "Met à jour le matériau (nom, etc.).",
  "template.item.sync_new_snippets.title": "Ajouter ou mettre à jour de nouveaux matériaux",
  "template.item.sync_new_snippets.description": "Ajoute de nouveaux matériaux et met à jour les matériaux existants à partir de la collection. Les matériaux propres ajoutés ne seront pas modifiés.",
  "collaboration.cannot_edit_item": "Modification non autorisée.",
  "collaboration.template.description_on_template_topics": "Vous êtes dans une collection. Copiez des séries ou des matériaux dans votre bibliothèque pour les utiliser.",
  "collaboration.template.colleagues": "Collègues :",
  "collaboration.use_topic.button": "Copier la série dans la bibliothèque",
  "collaboration.use_topic.button_short": "Copier le dossier",
  "collaboration.use_item.button": "Copier le matériel",
  "collaboration.use_topic.tooltip": "Copier la série de la collection dans votre bibliothèque.",
  "collaboration.use_item.tooltip": "Copier le matériel de la collection dans votre bibliothèque.",
  "collaboration.use_item.title": "Copier le matériel dans la bibliothèque",
  "collaboration.use_item.choose_topic": "Choisir la série",
  "collaboration.use_topic.choose_course": "Choisir le cours",
  "collection.material_banner.title": "Ce matériel fait partie d’une collection.",
  "collection.material_banner.description": "Copiez-le dans un cours pour pouvoir l’y utiliser.",
  "collection.material_banner.copy_to_course": "Copier dans un cours",
  "collection.copy_multiple_folders.dialog_description": "Choisissez les dossiers de « {{collection}} » à copier dans un cours.",
  "collection.origin_notice.folder_from": "Dossier de {{collectionName}}",
  "collection.origin_notice.material_from": "Matériel de {{collectionName}}",
  "collection.origin_notice.open_folder": "Ouvrir le dossier dans la collection",
  "collection.origin_notice.edit_material": "Modifier le matériel dans la collection",
  "collection.origin_notice.new_version_available": "Nouvelle version disponible",
  "material_card.also_used_in_course": "Également utilisé dans {{courseName}}",
  "collaboration.add_from_library.successfull": "Série copiée",
  "collaboration.add_from_library.successfull_text": "La série et les matériaux ont été dupliqués et ajoutés à la collection.",
  "collaboration.join_external_course.title": "Teamteaching",
  "collaboration.join_external_course.title_substitution": "Heure de remplacement",
  "collaboration.join_external_course.description": "{{ownerName}} planifie déjà {{courseName}} avec Teachino.",
  "collaboration.join_external_course.cta": "Rejoindre l'enseignement en équipe pour le cours {{courseName}}",
  "collaboration.join_external_course.cta_substitution": "Assumer la suppléance pour {{courseName}}",
  "collaboration.join_external_course.not_join": "Je veux planifier le cours seul",
  "external_content.choose_file": "Choisir le fichier",
  "external_content.choose_note": "Choisir la note",
  "external_content.choose_class_note": "Choisir la page du bloc-notes de classe",
  "courses.empty_title": "Pas encore de cours",
  "courses.empty_description": "Les cours représentent vos classes et matières de l'année scolaire en cours. Par exemple, \"10A Géographie\". Créez un cours pour commencer à planifier.",
  "video.modal.close": "Fermer la vidéo",
  "video.modal.title": "Explication vidéo",
  "pathfindr.pdfsplitter.choose_pages": "Choisir les pages",
  "pathfindr.pdfsplitter.select_max_pages": "Choisissez jusqu'à Y pages.",
  "pathfindr.pdfsplitter.x_of_y_pages_selected": "X sur Y pages sélectionnées",
  "iframe.open_teachino": "Ouvrir Teachino",
  "iframe.redirecting": "Ouverture de Teachino…",
  "iframe.open_teachino_hint": "Teachino s'ouvre dans un nouvel onglet.",
  "iframe.not_activated_hint": "L'intégration WebUntis n'est pas encore activée pour ton école. Tu peux quand même utiliser Teachino, mais ton compte ne sera connecté à WebUntis qu'une fois l'intégration activée.",
  "download.webview_not_possible": "Le téléchargement n'est pas possible dans cette application. Ouvre Teachino dans ton navigateur.",
  "link.webview_not_possible": "L'ouverture de liens n'est pas possible dans cette application. Ouvre Teachino dans ton navigateur.",
  "ai_powered_by_teachino": "Chat IA par",
  "student_ai": "Utiliser l'IA avec les élèves",
  "student_ai.home_view.empty_state.title": "Aucun exercice d'IA disponible pour le moment",
  "student_ai.home_view.empty_state.description": "Dès que vous créez un exercice d'IA ou qu'on vous en attribue un, il apparaîtra ici.",
  "student_ai.home_view.title": "Teachino Élève IA",
  "student_ai.assignment_view.title": "Exercice IA pour Élèves Teachino",
  "student_ai.assignments": "Exercices IA",
  "student_ai.banner.title": "Exercices IA : Utiliser l'intelligence artificielle avec vos élèves ✨",
  "student_ai.banner.description": "Enseignez des connaissances spécifiques et des compétences en IA dans un environnement sécurisé et conforme à la protection des données.",
  "student_ai.banner.cta": "Vers l'IA pour élèves",
  "student_ai.assignments.create_assignment": "Créer un exercice IA",
  "student_ai.assignments.create_custom_assignment": "Créer un exercice IA personnalisé",
  "student_ai.assignments.share_assignment": "QR-Code et lien",
  "student_ai.assignments.start": "Démarrer",
  "student_ai.assignments.stop": "Arrêter",
  "student_ai.assignments.start_hint": "Cliquez pour démarrer l'exercice IA",
  "student_ai.assignments.stop_hint": "L'exercice IA est en cours. Cliquez pour arrêter",
  "student_ai.assignments.hint_assignment_inactive_before_cta": "Cet exercice n'est pas démarré.",
  "student_ai.assignments.hint_assignment_inactive_cta": "Démarrer l'exercice",
  "student_ai.assignments.hint_assignment_inactive_after_cta": "pour permettre aux élèves de discuter avec l'IA.",
  "student_ai.assignments.hint_assignment_active": "Vos élèves peuvent maintenant discuter avec l'IA. Le QR-Code peut être scanné ou le lien peut être partagé.",
  "student_ai.create_assignment.title": "Créer un exercice IA",
  "student_ai.edit_assignment.title": "Modifier l'exercice IA",
  "student_ai.duplicate_assignment.title": "Dupliquer l'exercice IA",
  "student_ai.create_assignment.title.placeholder": "Exercice IA du {{date}}",
  "student_ai.create_assignment.description": "Tâche pour les élèves",
  "student_ai.create_assignment.system_prompt": "Comportement de l'IA (Prompt système)",
  "student_ai.delete_assignment.title": "Supprimer l'exercice IA",
  "student_ai.delete_assignment.description": "Êtes-vous sûr de vouloir supprimer l'exercice IA \"{{assignment}}\" ? Cette action est irréversible.",
  "student_ai.share_assignment.scan_code": "Scannez le code pour démarrer l'exercice IA",
  "student_ai.template.import": "Utiliser avec mes élèves",
  "student_ai.template.created_by_teachino": "Créé par Teachino",
  "student_ai.template.import_from_teachino": "Découvrir tous les exercices IA",
  "student_ai.create.edit_system_prompt": "Modifier le prompt",
  "student_ai.tutorial.custom.title": "Créer vos propres exercices IA ✍️",
  "student_ai.tutorial.custom.description": "Alignez précisément vos contenus pédagogiques avec des exercices IA personnalisés pour répondre aux besoins de vos élèves.",
  "student_ai.tutorial.custom.help": "Aide : Comment cela fonctionne-t-il",
  "student_ai.tutorial.template.title": "Utiliser des exercices IA prêts à l'emploi 🤩",
  "student_ai.tutorial.template.description": "Plus de 200 exercices IA prêts à l'emploi dans divers sujets vous attendent, vous et vos élèves.",
  "student_ai.tutorial.more_subjects": "💡 Votre matière ne figure pas encore ? Pas d'inquiétude. Nous ajoutons régulièrement de nouvelles matières. Avec les exercices personnalisés, vous pouvez déjà utiliser l'IA dans chaque matière.",
  "editor.image_selector.upload": "Télécharger une image",
  "editor.image_selector.search": "Rechercher une image",
  "editor.image_selector.generate": "Générer une image avec l'IA",
  "editor.image_selector.ai.prompt_label": "Entrez une description d'image",
  "editor.image_selector.ai.prompt_placeholder": "Tapez ici le prompt pour l'image générée par l'IA",
  "editor.image_selector.ai.style": "Style",
  "editor.image_selector.ai.style.realistic": "Réaliste",
  "editor.image_selector.ai.style.artistic": "Artistique",
  "editor.image_selector.ai.style.cartoon": "Cartoon",
  "editor.image_selector.ai.style.sketch": "Esquisse",
  "editor.image_selector.ai.style.watercolor": "Aquarelle",
  "editor.image_selector.ai.style.minimalist": "Minimaliste",
  "editor.image_selector.ai.author_name": "Généré par IA",
  "editor.image_selector.ai.cta": "Générer l'image",
  "editor.image_selector.search.label": "Mot-clé",
  "editor.image_selector.search.label_placeholder": "Entrez le mot-clé",
  "editor.image_selector.libraries.title": "Bibliothèques d'images",
  "editor.image_selector.libraries.empty": "Aucune bibliothèque d'images disponible",
  "editor.image_selector.libraries.recent": "Récemment utilisées",
  "editor.image_selector.libraries.all": "Toutes les bibliothèques",
  "editor.image_selector.ai.results": "Images générées",
  "editor.image_selector.tab.upload": "Télécharger une image",
  "editor.image_selector.tab.search": "Rechercher une image",
  "editor.image_selector.tab.ai": "Générer par IA",
  "editor.image_selector.ai.paywall.title": "Créer des images avec l'IA pour tes matériels",
  "editor.image_selector.ai.paywall.description": "Décris ce dont tu as besoin et crée des images sur mesure directement dans l'éditeur de matériel. Souscris une licence pour débloquer la génération d'images par IA.",
  "editor.image_selector.tab.loading": "L'image est enregistrée",
  "editor.empty_state.intro": "Introduction à la leçon avec l'IA",
  "editor.empty_state.info_text": "Texte d'information avec l'IA",
  "editor.empty_state.gap_text": "Texte à trous avec l'IA",
  "editor.tools.list.bulleted_list.name": "Liste à puces",
  "editor.tools.list.ordered_list.name": "Liste ordonnée",
  "editor.tools.details.name": "Liste à entrées déroulantes",
  "editor.tools.callout.name": "Note",
  "editor.tools.callout.color": "Couleur",
  "editor.tools.table.name": "Tableau",
  "editor.tools.table.add_row_below": "Ajouter une ligne en-dessous",
  "editor.tools.table.add_row_above": "Ajouter une ligne au-dessus",
  "editor.tools.table.add_header_row": "En-tête",
  "editor.tools.table.add_column_left": "Ajouter une colonne à gauche",
  "editor.tools.table.add_column_right": "Ajouter une colonne à droite",
  "editor.tools.table.add_header_column": "Colonne d'en-tête",
  "editor.tools.table.delete_row": "Supprimer la ligne",
  "editor.tools.table.delete_column": "Supprimer la colonne",
  "editor.tools.table.delete": "Supprimer le tableau",
  "editor.tools.text_color.name": "Couleur du texte",
  "editor.tools.text_color_background.name": "Couleur et arrière-plan",
  "editor.tools.highlight.name": "Mettre en évidence",
  "editor.tools.align_left.name": "Aligner à gauche",
  "editor.tools.align_center.name": "Centrer",
  "editor.tools.align_right.name": "Aligner à droite",
  "editor.tools.align_justify.name": "Justifié",
  "editor.tools.emoji.name": "Émoji",
  "editor.tools.undo.name": "Annuler",
  "editor.tools.redo.name": "Rétablir",
  "editor.tools.mathematics.name": "Formule",
  "editor.tools.mathematics.subscript.name": "Indice",
  "editor.tools.mathematics.superscript.name": "Exposant",
  "editor.tools.bold.name": "Gras",
  "editor.tools.italic.name": "Italique",
  "editor.tools.underline.name": "Souligné",
  "editor.tools.strike.name": "Barré",
  "editor.tools.code.name": "Code",
  "editor.tools.blockquote.name": "Citation",
  "editor.tools.clear_format.name": "Effacer la mise en forme",
  "editor.tools.line_spacing.name": "Interligne",
  "editor.tools.image": "Image",
  "editor.tools.image.caption.label": "Légende de l'image",
  "editor.tools.image.caption.placeholder": "Décrire l'image",
  "editor.tools.image.source": "[Source]",
  "editor.tools.file": "Fichier",
  "editor.tools.link": "Lien",
  "editor.tools.heading.name": "Titre",
  "editor.tools.heading.prose": "Texte",
  "editor.tools.heading.heading_1": "Titre 1",
  "editor.tools.heading.heading_2": "Titre 2",
  "editor.tools.heading.heading_3": "Titre 3",
  "editor.changes_saved": "Modifications sauvegardées",
  "editor.saving": "Enregistrement en cours",
  "editor.failed_to_save": "Erreur lors de la sauvegarde !",
  "editor.open_ai": "Ouvrir l'IA",
  "keyboard.modifier.windows": "Ctrl",
  "keyboard.modifier.mac": "command",
  "keyboard.shift": "Maj",
  "student_ai.upgrade_banner_before": "Avec la licence gratuite pour enseignants, tu peux essayer l'IA pour étudiants dans cet aperçu. L'IA pour étudiants te plaît ? Alors ",
  "student_ai.upgrade_banner_cta": "obtenez votre licence Pro maintenant",
  "student_ai.upgrade_banner_after": "🏅, pour partager facilement les exercices avec vos élèves.",
  "material.default_name": "Matériel sans nom",
  "material.add_blocks": "Blocs",
  "material.add_block": "Ajouter un bloc",
  "material.block_dialog.title": "Ajouter un bloc",
  "material.ai": "IA",
  "material.details": "Détails",
  "material.empty_state": "Réalisez votre idée : commencez à écrire, demandez à l'IA ou ajoutez des blocs.",
  "material.tutorial_title": "<strong>Regardez le tutoriel : </strong>Qu'est-ce qu'un matériel et comment le créer ?",
  "material.create": "Créer du matériel",
  "material.edit_details.title": "Détails du matériel",
  "material.details_dialog.duration_placeholder": "p. ex. 30",
  "material.details_dialog.duration_invalid": "Saisissez un nombre entier entre 1 et {{max}} minutes, ou laissez le champ vide.",
  "material.edit_details.topic_description": "Chaque matériel appartient à une série. Cela vous permet de le retrouver plus tard et fournit plus de contexte à l'IA.",
  "material.edit_details.duration_description": "Combien de minutes sont nécessaires pour ce matériel en cours ?",
  "material.edit_details.more": "Autres actions",
  "material.edit_details.export": "Exporter le matériel",
  "material.edit_details.material_duplicate": "Dupliquer le matériel",
  "material.edit_details.material_delete": "Supprimer le matériel",
  "material-edit_details.pdf_export": "Exporter en PDF",
  "material-edit_details.docx_export": "Exporter en WORD",
  "material-edit_details.docx_export_with_notes": "Exporter en WORD avec notes",
  "material.share.tab_students": "Partager avec les élèves",
  "material.share.tab_teachers": "Partager avec les enseignants",
  "material.share.tab_export": "Exporter",
  "material.share.courses_with_material": "Cours contenant ce matériel",
  "material.share.add_to_more_courses": "Ajouter le matériel à d'autres cours",
  "material.share.empty.no_courses_available.title": "Créez un cours pour partager le matériel avec les élèves.",
  "material.share.empty.no_courses_available.description": "Les cours correspondent à vos classes et matières. Par exemple : 8A Géographie.",
  "material.share.empty.courses_available_empty.title": "Ajoutez le matériel à un cours existant ou créez un nouveau.",
  "material.share.new_course": "Nouveau cours",
  "material.share.copy_link": "Copier le lien",
  "material.share.link_copied": "Lien copié",
  "material.share.copy_error": "Erreur lors de la copie",
  "material.share.create_new_course": "Créer un nouveau cours",
  "material.share.added_to_course": "Matériel ajouté au cours",
  "material.share.add_to_course_error": "Erreur lors de l'ajout du matériel au cours",
  "material.share.open_student_view": "Ouvrir la vue de l'élève",
  "material.share.copy_student_link": "Copier le lien de l'élève",
  "material.share.student_link_copied": "Lien de l'élève copié",
  "material.share.qr_code": "QR-Code",
  "material.share.qr_code_url_copied": "URL pour QR-Code copié",
  "material.share.qr_code_description": "Scannez le QR-Code pour ouvrir le matériel dans le cours {{courseName}}",
  "material.share.student_url": "URL pour élèves",
  "material.share.copy_url": "Copier le lien",
  "material.editor.teacher_note.title": "Note pour les enseignants",
  "material.editor.teacher_note.placeholder": "Les notes ne sont visibles que par vous. Vous pouvez également y joindre des feuilles de solutions.",
  "material.editor.teacher_note.convert_to_teacher_note": "Afficher uniquement pour moi",
  "material.editor.teacher_note.remove_from_teacher_note": "Afficher à tous",
  "material.editor.activity.title": "Activité",
  "material.editor.activity.ai_feedback": "Avec feedback IA",
  "material.editor.assignment_open_question.title": "Question",
  "material.editor.assignment_open_question.example": "Exemple : Citez trois mesures de protection du climat au quotidien.",
  "material.editor.assignment_open_question.edit": "Modifier la question",
  "material.editor.assignment_open_question.answer": "Répondre à la question",
  "material.editor.assignment_open_question.assignment_tag": "Tâche",
  "material.editor.assignment_open_question.your_answer": "Votre réponse",
  "material.editor.assignment_open_question.check": "Soumettre",
  "material.editor.assignment_open_question.redo": "Modifier la réponse",
  "material.editor.assignment_open_question.get_hint": "Obtenir un indice",
  "material.editor.assignment_open_question.hint": "Indice",
  "material.editor.assignment_open_question.confirm": "Soumettre",
  "material.editor.assignment_open_question.guidance": "Critères pour le feedback de l’IA sur le contenu",
  "material.editor.assignment_open_question.generate_guidance": "Générer avec IA",
  "material.editor.assignment_open_question.generate_guidance_empty": "Saisissez une question d’au moins 10 caractères pour générer des critères de feedback adaptés.",
  "material.editor.assignment_open_question.generate_guidance_disabled": "Ajoutez d'abord une question",
  "material.editor.assignment_open_question.generate_guidance_error": "Impossible de générer les critères de feedback. Veuillez réessayer.",
  "material.editor.assignment_open_question.guidance_placeholder": "L'élève nomme ...",
  "material.editor.assignment_open_question.guidance_example": "Définissez des critères de forme, de longueur et de contenu, et ajoutez éventuellement une réponse modèle. L’IA les utilise pour l’évaluation, le feedback et le feed forward.",
  "material.assignment_open_question.answer_placeholder": "Tapez votre réponse",
  "material.assignment_open_question.answer_reset": "Réinitialiser",
  "material.assignment_open_question.get_feedback": "Obtenir un feedback",
  "material.assignment_open_question.answer_placeholder_teacher": "Tapez une réponse pour tester le feedback IA du point de vue de vos élèves",
  "material.assignment_open_question.feedback": "Feedback de l'IA",
  "material.assignment_open_question.feedback.empty_state": "Pas de feedback disponible",
  "material.assignment_open_question.status.not_answered": "Non répondu",
  "material.assignment_open_question.status.incorrect": "Réponse incorrecte",
  "material.assignment_open_question.status.partially": "Partiellement correct",
  "material.assignment_open_question.status.correct": "Entièrement correct",
  "material.assignment_open_question.status.started": "En cours",
  "material.assignment_open_question.status.not_started": "Pas encore commencé",
  "material.assignment_open_question.summary.started": "En cours",
  "material.assignment_open_question.summary.correct": "Entièrement correct",
  "material.assignment_open_question.summary.partially": "Partiellement correct",
  "material.assignment_open_question.summary.incorrect": "Incorrect",
  "material.assignment_open_question.hints": "Indices",
  "material.assignment_open_question.loading": "L'IA lit la réponse et fournira bientôt un feedback.",
  "material.assignment_open_question.ai_disclaimer": "Le feedback est généré par l'IA. L'IA peut faire des erreurs.\nNe saisissez aucune donnée personnelle.",
  "material.assignment_open_question.ai_feedback_caveat": "Ce feedback a été généré par l'IA. L'IA peut faire des erreurs.",
  "material.assignment_open_question.question_placeholder": "Tapez une question ou une consigne",
  "material.assignment_open_question.your_answer_was": "Votre réponse :",
  "material.assignment_open_question.show_history": "Afficher les réponses précédentes",
  "material.assignment_open_question.hide_history": "Masquer les réponses",
  "material.assignment_open_question.complete": "Terminé",
  "material.assignment_open_question.show_response": "Afficher la réponse",
  "material.assignment_open_question.attempt": "Tentative",
  "material.assignment_open_question.nth_attempt": "{{count}}e tentative",
  "material.assignment_open_question.answer.empty_state": "Pas de réponse",
  "material.assignment_open_question.answer_paste_block": "Veuillez taper votre réponse au lieu de la copier.",
  "material.assignment_open_question.answer_paste_block_teacher": "Les élèves peuvent uniquement taper leur réponse. Copier-coller est seulement autorisé pour les enseignants.",
  "material.assignment_open_question.recording_start": "Enregistrer la réponse",
  "material.assignment_open_question.recording_stop": "Arrêter l'enregistrement",
  "material.assignment_open_question.microphone_select": "Microphone",
  "material.assignment_open_question.microphone_default": "Microphone par défaut",
  "material.assignment_open_question.transcribing": "Transcription en cours...",
  "material.assignment_open_question.microphone_denied": "L'accès au microphone a été refusé. Veuillez autoriser l'accès au microphone dans les paramètres de votre navigateur.",
  "material.assignment_open_question.transcription_error": "La transcription vocale a échoué. Veuillez réessayer ou taper votre réponse.",
  "speech_to_text.microphone": "Microphone",
  "speech_to_text.default_microphone": "Microphone par défaut",
  "speech_to_text.start_recording": "Enregistrer la réponse",
  "speech_to_text.stop_recording": "Arrêter l'enregistrement",
  "speech_to_text.transcribing": "Transcription en cours...",
  "speech_to_text.microphone_denied": "L'accès au microphone a été refusé. Veuillez autoriser l'accès au microphone dans les paramètres de votre navigateur.",
  "speech_to_text.transcription_error": "La transcription vocale a échoué. Veuillez réessayer ou taper votre réponse.",
  "image_to_text.upload_image": "Télécharger une image (extraire le texte)",
  "image_to_text.extraction_error": "L'extraction de texte depuis l'image a échoué. Veuillez réessayer ou taper votre réponse.",
  "image_to_text.file_too_large": "L'image est trop grande (max. 5 Mo). Veuillez utiliser une image plus petite.",
  "material.student_session.what_is_your_name": "Comment t'appelles-tu ?",
  "material.student_session.what_is_your_name.placeholder": "Comment puis-je t'appeler ?",
  "material.student.your_are_logged_in_as": "Vous êtes connecté(e) en tant que {{name}}",
  "material.student.click_logout_description": "Cliquez sur « Déconnexion » pour vous déconnecter. Cela supprimera vos réponses de cet ordinateur. Votre enseignant(e) pourra toujours y accéder.",
  "material.editor.image.set_size_small": "Réduire",
  "material.editor.image.set_size_large": "Agrandir",
  "material.editor.image.size_small": "Petit",
  "material.editor.image.size_medium": "Moyen",
  "material.editor.image.size_large": "Grand",
  "material.editor.image.replace": "Remplacer l'image",
  "material.editor.image.replace_preview": "Sous \"Modifier\", vous pouvez choisir une image alternative, la télécharger ou la générer avec l'IA.",
  "material.editor.add": "Ajouter",
  "material.change_topic": "Changer de série",
  "library.material.courses.title": "Cours",
  "library.material.courses.loading": "Chargement des cours...",
  "library.material.courses.error": "Erreur lors du chargement des cours",
  "library.material.courses.empty": "Ce matériel n'est rattaché à aucun cours",
  "material.rename.success": "Matériel renommé !",
  "material.icon_change.success": "Nouvelle icône enregistrée !",
  "material.download": "Télécharger",
  "material.editor.image.expand": "Agrandir l’image",
  "material.preview": "Aperçu",
  "material.preview.empty": "Ce matériel est encore vide. Sous \"Modifier\", ajoutez du texte, des fichiers ou des activités interactives pour le développer.",
  "material.preview.description": "Voici comment vos élèves verront le matériel. Vous pouvez essayer vous-même les activités interactives ici.",
  "material.open_link": "Ouvrir le lien",
  "material.copy_link": "Copier le lien",
  "material.editor.link.save": "Enregistrer le lien",
  "material.editor.link.label": "Lien",
  "material.editor.link.title": "Titre du lien",
  "material.editor.link.title_placeholder": "Ajouter un titre",
  "material.editor.link.description": "Description du lien",
  "material.editor.link.description_placeholder": "Ajouter une description",
  "material.editor.link.add": "Insérer un lien",
  "material.editor.link.edit_url": "Modifier le lien",
  "material.editor.link.convert_to_preview": "Convertir en aperçu",
  "material.editor.link.reload_preview": "Recharger l'aperçu",
  "material.editor.link.convert_to_url": "Convertir en URL",
  "material.bulk.cta": "Télécharger des fichiers",
  "material.bulk_create.title": "Télécharger des fichiers",
  "material.bulk_create.files": "Fichiers",
  "material.bulk_create.hint_1": "💡 Astuce : Avec {{cmdAll}}, vous pouvez sélectionner tous les fichiers d'un dossier.",
  "material.bulk_create.hint_2": "Pour cliquer sur plusieurs fichiers, maintenez {{cmdMultiSelect}} enfoncé.",
  "material.bulk_create.success": "Matériaux créés !",
  "material.bulk_create.pending_uploads": "{{count}} en attente",
  "material.bulk_create.cancel_uploads.title": "Annuler les téléchargements ?",
  "material.bulk_create.cancel_uploads.message": "Fermer cette fenêtre annulera tous les téléchargements en cours. Voulez-vous continuer ?",
  "material.bulk_create.cancel_uploads.confirm": "Oui, annuler",
  "material.bulk_create.cancel_uploads.keep_uploading": "Non, continuer le téléversement",
  "material.external_content.header": "Sélectionnez un document",
  "material.external_content.empty": "Aucun document trouvé",
  "material.external_content.recent": "Documents récemment utilisés",
  "material.read_only": "🔒 Vous avez un accès en lecture seule à ce matériel. Dupliquez-le pour le modifier.",
  "material.export.navigation_button": "Exporter",
  "material.export.title": "Exporter le matériel",
  "material.export.description": "Téléchargez votre matériel dans différents formats.",
  "material.export.download": "Télécharger",
  "material.share.cta": "Partager",
  "material.share.cta_long": "Partager le matériel avec les élèves",
  "material.share.teachers_coming_soon": "Partager avec des enseignants arrive bientôt",
  "material.share_with_teachers.menu_label": "Partager avec des enseignant·es",
  "material.share_with_teachers.title": "Partager le matériel avec des enseignant·es",
  "material.share_with_teachers.description": "Toute personne disposant de ce lien peut consulter le matériel et le copier dans ses propres cours.",
  "material.share_with_teachers.hint": "Le lien est accessible publiquement. Les réponses et données des élèves ne sont pas partagées.",
  "material.share_with_teachers.deactivate": "Désactiver le lien",
  "material.share_with_teachers.deactivated_title": "Lien désactivé",
  "material.share_with_teachers.deactivated_description": "L'ancien lien ne fonctionne plus. Plus personne ne peut consulter ou copier le matériel via ce lien. Les matériels déjà copiés ne sont pas concernés.",
  "material.share_with_teachers.create_new_link": "Créer un nouveau lien",
  "shared_material.title": "Matériel partagé",
  "shared_material.subtitle": "Un·e enseignant·e a partagé ce matériel avec toi",
  "shared_material.use_material": "Utiliser le matériel",
  "shared_material.use_material_hint": "Copie le matériel dans l'un de tes cours pour le modifier et l'utiliser.",
  "shared_material.no_courses": "Tu n'as pas encore de cours dans lequel copier le matériel. Crée d'abord un cours.",
  "shared_material.not_available.title": "Matériel non disponible",
  "shared_material.not_available.description": "Le lien est invalide ou a été désactivé.",
  "material.rename_dialog.title": "Nom du matériel",
  "material.rename_dialog.description": "Donnez un nom significatif à votre matériel afin que l'IA ait suffisamment de contexte.",
  "material.rename_dialog.placeholder": "Entrez le nom",
  "material.rename_dialog.error": "Veuillez entrer un nom plus long.",
  "material.chat.start_new_chat": "Démarrer un nouveau chat",
  "material.chat.error.question_unclear": "Je n'ai pas compris votre question. Pourriez-vous la reformuler ?",
  "material.chat.error.not_company_scope": "Cette demande n'est pas dans mon domaine de compétences. Je ne peux répondre qu'aux questions dans le contexte scolaire.",
  "material.chat.error.policy_violation": "Je ne peux malheureusement pas vous aider sur ce sujet.",
  "material.chat.error.unknown": "Quelque chose s'est mal passé. Veuillez réessayer.",
  "material.chat.expand_area": "Voir les fonctions IA",
  "material.chat.placeholder": "Posez une question à l'IA",
  "material.chat.placeholder_after_block": "Comment l'IA doit-elle ajuster le résultat ?",
  "material.chat.block_added_notification": "Bloc ajouté",
  "material.chat.send": "Envoyer",
  "material.chat.title": "Teachino IA",
  "material.chat.source_selector.title": "Sur quoi l'IA doit-elle se baser ?",
  "material.chat.source_selector.empty": "Une fois que vous avez ajouté des fichiers, vidéos YouTube ou liens dans l'éditeur, vous pouvez les choisir ici.",
  "material.chat.age_select.label": "Âge des élèves",
  "material.chat.language_select.label": "Langue des élèves",
  "material.chat.source_selector.all": "L'ensemble du matériel",
  "material.chat.task_selector.title": "Choisissez une tâche ou entrez un prompt.",
  "material.chat.language_changed": "Les contenus sont maintenant créés en {{language}}",
  "material.chat.age_changed": "Les contenus sont maintenant créés pour des élèves âgés de {{age}} ans",
  "interactive_assignment.overview.title": "Évaluation pour {{courseName}}",
  "interactive_assignment.overview.refresh": "Actualiser la vue",
  "interactive_assignment.overview.table.name": "Nom",
  "interactive_assignment.overview.table.assignment": "Tâche",
  "interactive_assignment.overview.empty_state": "Dès que vos élèves commencent à travailler, un aperçu des résultats s'affichera ici.",
  "interactive_assignment.number_of_students_one": "Un élève",
  "interactive_assignment.number_of_students_many": "{{number}} élèves",
  "interactive_assignment.overview.legend": "Légende",
  "interactive_assignment.overview.legend.incorrect": "Pas correct",
  "interactive_assignment.overview.user_interview.title": "Aidez-nous à améliorer cette vue d'évaluation",
  "interactive_assignment.overview.user_interview.description": "Vous avez déjà recueilli des réponses de plusieurs élèves. Participez à un court entretien utilisateur et dites-nous ce qui fonctionne bien et ce que nous devrions améliorer.",
  "interactive_assignment.overview.user_interview.cta": "Participer à l'entretien",
  "ipi.link.student_ai.description": "Créez des chatbots pour vos élèves",
  "ipi.prompt.cta": "Générer du matériel",
  "ipi.prompt.age_select": "{{age}} ans",
  "ipi.material.done": "Terminé! Cliquez sur Modifier pour ajuster le matériel ou le partager avec vos élèves.",
  "ipi.hints": "Exemples",
  "ipi.hint": "Exemple :",
  "ipi.hints.1.title": "Fiche de travail interactive Changement climatique",
  "ipi.hints.1.prompt": "Créez une fiche sur les conséquences du changement climatique avec un accent sur les phénomènes météorologiques extrêmes.",
  "ipi.hints.2.title": "Objectif pédagogique & idées Gestion du stress",
  "ipi.hints.2.prompt": "Créez un objectif d'apprentissage et deux idées de leçon sur la gestion et la réduction du stress dans le monde des élèves.",
  "ipi.hints.3.title": "Introduction à la leçon Machine à vapeur",
  "ipi.hints.3.prompt": "Créez une introduction à la leçon sur le fonctionnement des machines à vapeur.",
  "ipi.hints.4.title": "Texte informatif avec questions de compréhension Tourisme au Tyrol du Sud",
  "ipi.hints.4.prompt": "Rédigez un texte informatif sur l'impact du tourisme sur un lieu, par exemple le Tyrol du Sud, en géographie. Ajoutez ensuite trois questions ouvertes.",
  "ipi.hints.5.title": "Texte à trous Londres Simple Past",
  "ipi.hints.5.prompt": "Créez un texte à trous en anglais sur le passé simple avec un accent sur le vocabulaire des attractions à Londres.",
  "ipi.hints.6.title": "Fiche de travail chats mignons",
  "ipi.hints.6.prompt": "Créez une fiche avec un aperçu des quatre races de chats les plus mignonnes d'Europe centrale.",
  "ipi.loading.title": "Votre matériel est en cours de création",
  "ipi.loading.subtitle": "Cela prend environ une minute",
  "ipi.loading.1": "La structure de votre matériel est en cours de création",
  "ipi.loading.2": "Les textes, tâches et images sont assemblés",
  "ipi.loading.3": "Les tâches interactives sont générées",
  "ipi.loading.4": "Vous pouvez éditer et compléter le matériel terminé à votre guise.",
  "ipi.loading.5": "Ensuite, vous pouvez l'imprimer ou le partager par lien avec vos élèves.",
  "ipi.loading.6": "Le matériel sera enregistré dans un dossier de votre bibliothèque.",
  "ipi.loading.material_ready": "Votre matériel est prêt.",
  "ipi.loading.view_material": "Voir le matériel",
  "ipi.convert_worksheet.title": "Convertir la feuille de travail",
  "ipi.convert_worksheet.convert_button": "Convertir",
  "ipi.convert_worksheet.description": "Téléchargez une feuille de travail (PDF, image ou document) et l'IA la convertira en matériel Teachino interactif.",
  "ipi.convert_worksheet.ai_prompt": "Convertissez cette feuille de travail téléchargée en matériel Teachino interactif.",
  "ipi.progress.validating": "Validation de votre saisie...",
  "ipi.progress.generating": "Génération du matériel avec {{images}} images...",
  "ipi.progress.integrating": "Intégration de {{questions}} questions interactives...",
  "ipi.progress.finalizing": "Finalisation du matériel...",
  "ipi.topic_select.title": "Choisissez un thème pour l'IA",
  "ipi.topic.name_placeholder": "Nouveau thème",
  "ipi.material.name_placeholder": "Nouveau matériel",
  "ipi.feedback.rating.question": "Comment trouvez-vous le matériel?",
  "ipi.feedback.feedback.question": "Merci! Voulez-vous justifier le retour d'information?",
  "ipi.feedback.placeholder": "Entrez un retour d'information",
  "ipi.add_source": "Source",
  "ipi.add_source.loading": "Téléchargement en cours...",
  "ipi.add_source.upload_file": "Télécharger un fichier",
  "ipi.add_source.add_link": "Entrez le lien",
  "ipi.add_source_description": "Choisissez un lien ou un fichier sur lequel l'IA se basera.",
  "ipi.longer_prompt.hint": "Entrez au moins 6 caractères pour démarrer l'IA. Utilisez les exemples pour vous inspirer.",
  "ipi.disclaimer": "L'IA génère le matériel basé sur vos entrées (texte, source, thème). N'entrez pas de données personnelles. L'IA peut faire des erreurs.",
  "material_ai.disclaimer": "L'IA propose des suggestions basées sur le matériel et le thème. N'entrez pas de données personnelles. L'IA peut faire des erreurs.",
  "image_generation.disclaimer": "La description est traitée par l'IA. N'entrez pas de données personnelles.",
  "course.current_course": "Cours actuel",
  "course.current_collection": "Collection actuelle",
  "course.all_courses": "Tous les cours",
  "course.all_materials": "Tous les matériaux",
  "course.materials.empty.title": "Créez votre premier support !",
  "course.materials.empty.description": "Choisissez une suggestion IA ou cliquez sur Nouveau pour commencer vous-même.",
  "course.materials.empty.manual_description": "Cliquez sur Nouveau pour créer votre premier support.",
  "course.materials.empty.ai_primary_cta": "Commencer avec l'assistant IA",
  "course.materials.empty.ai_primary_prompt": "Créez un support adapté à mon cours.",
  "course.materials.empty.ai_cta_description": "Décrivez votre besoin – l'assistant IA crée un support adapté à votre cours.",
  "course.materials.empty.ai_cta_action": "Ouvrir l'assistant",
  "course.materials.empty.convert_description": "Téléversez une feuille de travail et transformez-la en support interactif.",
  "course.materials.empty.convert_action": "Téléverser une feuille",
  "course.materials.empty.manual_hint": "Vous pouvez aussi créer, importer ou téléverser des supports manuellement via Nouveau.",
  "course.materials.empty.cta": "Saisir un prompt",
  "course.materials.empty.guest.title": "Aucun matériel pour le moment",
  "course.materials.empty.guest.description": "Aucun matériel n'a encore été créé dans ce cours.",
  "course.materials.empty.guest.collection_description": "Aucun matériel n'a encore été créé dans cette collection.",
  "course.materials.used_in_courses_label": "Utilisé dans les cours :",
  "course.add_content_menu.create_material": "Créer du matériel",
  "course.add_content_menu.create_folder": "Créer un dossier",
  "course.add_content_menu.reuse_section": "Réutiliser",
  "course.add_content_menu.add_from_course_or_collection": "Ajouter du matériel d'un autre cours / d'une collection",
  "course.add_existing_preview_hint": "Consulter les dossiers et le contenu d'un autre cours.",
  "course.add_existing_materials_hint": "Les dossiers et le contenu sont affichés uniquement pour consultation pour le moment.",
  "course.add_existing_empty_title": "Aucun autre cours disponible",
  "course.add_existing_empty_description": "Créez ou restaurez un autre cours pour consulter les contenus existants ici.",
  "course.add_existing_empty_materials_title": "Aucun contenu dans ce dossier",
  "course.add_existing_empty_materials_description": "Sélectionnez un autre dossier pour consulter son contenu.",
  "course.all_folders_copied": "Tous les dossiers copiés",
  "course.copy_all_folders.button": "Copier tous les dossiers",
  "course.copy_all_folders.confirm_title": "Copier tous les dossiers ?",
  "course.copy_all_folders.confirm_message": "{{count}} dossiers seront copiés dans ce cours.",
  "course.copy_all_folders.partial_success": "{{copied}} dossiers sur {{total}} copiés",
  "course.copy_all_folders.success": "Tous les dossiers copiés",
  "course.copy_multiple_folders.button": "Copier les dossiers…",
  "course.copy_multiple_folders.confirm": "Copier {{count}} dossiers dans un cours",
  "course.copy_multiple_folders.select_course": "Sélectionner un cours…",
  "course.copy_multiple_folders.dialog_description": "Choisissez les dossiers de « {{course}} » à copier dans « {{destinationCourse}} ».",
  "course.copy_multiple_folders.dialog_title": "Copier dans un cours",
  "course.copy_multiple_folders.material_count": "{{count}} contenus",
  "course.copy_multiple_folders.partial_success": "{{copied}} dossiers sur {{total}} copiés",
  "course.copy_multiple_folders.select_all": "Tout sélectionner",
  "course.copy_multiple_folders.selection_count": "{{selected}} sur {{total}} sélectionnés",
  "course.copy_multiple_folders.success": "{{count}} dossiers copiés",
  "course.active_courses": "Cours actifs",
  "course.archived_courses": "Cours supprimés",
  "course.unselect_all_materials": "Tout désélectionner",
  "course.select_folder_or_materials": "Sélectionner un dossier ou du contenu",
  "course.duplicate_entire_folder": "Dupliquer le dossier",
  "course.copy_folder_with_selected_materials": "Copier le dossier avec les contenus sélectionnés",
  "course.duplicate_named_folder": "Dupliquer {{folderName}}",
  "course.duplicate_named_folder_with_number_of_materials": "Dupliquer {{folderName}} avec {{number}} contenus",
  "course.recently_updated_materials": "Récemment mis à jour",
  "course.material_updated_at": "modifié le {{date}}",
  "course.export.date": "Date",
  "course.export.materials_and_notes": "Contenus et notes",
  "course.export.class_register": "Cahier de classe",
  "course.export.export": "Exporter",
  "course.export.year_plan": "Exporter la planification annuelle",
  "course.export.calendar_days": "Exporter les heures et contenus",
  "course.export.exporting_csv": "Export CSV en cours",
  "course.export.dialog.title": "Imprimer et exporter",
  "course.export.dialog.student_codes.title": "Codes d’accès des élèves",
  "course.export.dialog.student_codes.description": "Imprime des cartes d’accès avec les noms et les codes personnels de tous les élèves de ce cours.",
  "course.export.dialog.student_codes.unavailable": "Cet export est disponible dès que des élèves ont été ajoutés au cours.",
  "course.export.dialog.year_plan.title": "Planification annuelle",
  "course.export.dialog.year_plan.description": "Exporte les dossiers et leurs périodes planifiées dans un fichier CSV.",
  "course.export.dialog.year_plan.unavailable": "Cet export est disponible dès que des dossiers et des contenus ont été ajoutés au cours.",
  "course.export.dialog.calendar.title": "Heures et contenus (Cahier de classe)",
  "course.export.dialog.calendar.description": "Exporte les heures planifiées, les contenus, les notes et les entrées du cahier de classe dans un fichier CSV.",
  "course.export.dialog.calendar.unavailable": "Cet export est disponible dès que des heures ont été planifiées.",
  "course.export.dialog.grading.title": "Aperçu des notes",
  "course.export.dialog.grading.description": "Exporte l’aperçu des notes de tous les élèves au format CSV.",
  "course.export.dialog.grading.unavailable": "Cet export est disponible dès que des élèves ont été ajoutés au cours.",
  "course.export.grading_overview": "Exporter l’aperçu des notes",
  "course.export.from": "De",
  "course.export.to": "À",
  "course.edit_course": "Modifier le cours",
  "course.share_course": "Partager le cours",
  "student_sharing.paywall.description": "Partagez du matériel pédagogique avec vos élèves – par lien ou code QR.",
  "student_sharing.paywall.material_share_tab.description": "Souscris une licence maintenant et donne aux élèves accès au cours – partage un lien ou un code QR et rends les supports disponibles dans la vue élève.",
  "student_sharing.paywall.students_tab.description": "Donnez aux élèves accès au cours – partagez un lien ou un code QR et rendez les supports disponibles dans la vue élève.",
  "student_sharing.paywall.evaluation_tab.description": "Souscris une licence maintenant pour consulter les évaluations et donner un retour personnalisé à tes élèves.",
  "course.archive_course": "Supprimer le cours",
  "course.archive_course_message": "Supprimer \"{{courseName}}\" ?",
  "course.archived_toast": "Cours supprimé. Le cours \"{{courseName}}\" a été supprimé.",
  "course.link_stays_same": "Le lien reste le même tout au long de l'année scolaire.",
  "course.share_with_students": "Partagez le lien ou le code QR avec vos élèves",
  "course.share_with_sus": "Partager avec les élèves",
  "course.import_material_from_course": "Ajouter du contenu à partir du cours",
  "course.import_material_from_course_dialog": "Ajouter du matériel à partir d’un cours ou d’une collection",
  "course.import_material_from_x": "Ajouter du contenu à partir de \"{{course}}\"",
  "course.import_from_course.destination_hint": "Les contenus seront copiés dans « {{courseName}} », dossier « {{folderName}} ».",
  "chatbot.chatbots": "Chatbots",
  "chatbot.custom_chatbots": "Chatbots personnalisés",
  "chatbot.custom_chatbot": "Chatbot personnalisé",
  "chatbot.create_new": "Créer un nouveau chatbot",
  "chatbot.rename": "Renommer le chatbot",
  "chatbot.edit": "Modifier le chatbot",
  "chatbot.delete": "Supprimer le chatbot",
  "chatbot.delete_confirm": "Voulez-vous vraiment supprimer \"{{title}}\" ?",
  "chatbot.customizable": "Personnalisable individuellement",
  "chatbot.name_label": "Nom du chatbot",
  "chatbot.how_should_answer": "Comment le chatbot doit-il répondre ?",
  "chatbot.purpose": "À quoi sert ce chatbot ?",
  "chatbot.start_without_template": "Commencer sans modèle",
  "chatbot.start_chat": "Démarrer le chat",
  "chatbot.ai_instructions": "Paramètres de base pour l'IA",
  "chatbot.additional_info": "Informations supplémentaires pour l'IA",
  "chatbot.internal_notes": "Notes internes d'utilisation",
  "chatbot.no_info": "Aucune information fournie",
  "chatbot.no_ai_settings": "Aucun paramètre IA pour le moment",
  "chatbot.enter_message": "Entrez un message...",
  "chatbot.legacy.title": "Chats IA existants",
  "chatbot.legacy.description": "Sélectionnez un chat existant pour pré-remplir les champs. Veuillez copier les anciens chats IA dans vos cours avant le 30.07.2026.",
  "chatbot.context.description": "Contenus auxquels le chatbot doit avoir accès.",
  "chatbot.context.no_sources": "Aucune source ajoutée",
  "chatbot.context.no_sources_hint": "Ajoutez des fichiers ou des liens auxquels l'IA doit avoir accès.",
  "chatbot.description.student_hint": "Affiché aux élèves avant qu'ils ne démarrent le chat.",
  "chatbot.prompt.teacher_only_hint": "Seul(e) vous voyez cette instruction – elle contrôle le comportement de l'IA.",
  "chatbot.title.student_visible_hint": "Le nom du chatbot que voient les élèves.",
  "chatbot.context.sources_label": "Sources et matériaux",
  "chatbot.hello_message": "Bonjour ! Comment puis-je vous aider aujourd'hui ?",
  "chatbot.explain_simple": "Peux-tu m'expliquer le sujet en termes simples ?",
  "chatbot.step_by_step": "Volontiers. Nous allons aborder le sujet étape par étape.",
  "chatbot.no_custom_chatbots_empty_state": "Pas encore de chatbots personnalisés. Créez un nouveau chatbot via \"Nouveau...\".",
  "folder.folder_copied": "Dossier copié",
  "folder.delete_folder": "Supprimer le dossier",
  "folder.delete_folder_confirm": "Voulez-vous vraiment supprimer le dossier ?",
  "folder.remove_from_course": "Retirer du cours",
  "folder.remove_from_course_confirm": "Voulez-vous vraiment retirer ce dossier du cours ?",
  "folder.folder_removed_from_course": "Dossier retiré du cours",
  "folder.print": "Imprimer les dossiers",
  "folder.select_course_for_copy": "Sélectionnez le cours dans lequel copier le dossier.",
  "material.no_materials_found": "Aucun matériel trouvé",
  "material.material_copied": "Matériel copié",
  "material.material_moved": "Matériel déplacé",
  "material.share_material": "Partager le matériel",
  "material.delete_material_confirm": "Voulez-vous vraiment supprimer ce matériel ?",
  "material.copy_destination": "Où le matériel doit-il être copié ?",
  "material.move_destination": "Où le matériel doit-il être déplacé ?",
  "material.share_with_students": "Partagez le matériel avec vos élèves",
  "material.visible_for_sus": "Visible pour les élèves",
  "material.not_visible_for_sus": "Matériel non visible pour les élèves",
  "material.visible_for_students": "Matériel visible pour les élèves",
  "material.hide_for_sus": "Masquer le matériel pour les élèves",
  "material.show_for_sus": "Rendre le matériel visible pour les élèves",
  "material.make_visible_first": "Rendre le matériel visible d'abord",
  "material.unlock_first": "Déverrouiller le matériel d'abord.",
  "generic.ok": "Ok",
  "generic.new_short": "Nouveau",
  "generic.new": "Nouveau...",
  "generic.rename": "Renommer",
  "generic.help": "Aide",
  "generic.website": "Site web",
  "generic.webinar": "Webinar",
  "generic.image": "Image",
  "generic.europathek": "EUROPATHEK",
  "generic.no_images_found": "Aucune image trouvée",
  "generic.click_to_enlarge": "Cliquez pour agrandir",
  "generic.link_not_available": "Lien pas encore disponible",
  "generic.link_could_not_load": "Le lien n'a pas pu être chargé",
  "generic.link_copied": "Lien copié !",
  "generic.preview": "Aperçu",
  "generic.open_in_new_tab": "Ouvrir dans un nouvel onglet",
  "generic.copy_prompt": "Copier le prompt",
  "generic.prompt_copied": "Prompt copié !",
  "generic.scan_qr_code": "Scanner le code QR",
  "generic.add_source": "Ajouter une source",
  "generic.scan_or_copy": "Scannez le code ou copiez le lien",
  "generic.try_different_search": "Essayez un autre terme de recherche",
  "generic.student_preview": "Aperçu de la vue élève",
  "generic.send_link_or_qr": "Envoyez le lien ou montrez le code QR.",
  "generic.name_and_color": "Nom et couleur",
  "generic.change_name_color": "Changer le nom et la couleur",
  "ipi.describe_what_to_create": "Décrivez ce que l'IA doit créer...",
  "ipi.placeholder.example_photosynthesis": "Une fiche de travail sur la photosynthèse avec images et questions ouvertes",
  "ipi.placeholder.example_faust": "Un exercice IA sur le Faust de Goethe",
  "ipi.placeholder.example_past_simple": "Un texte à trous interactif sur le Past Simple",
  "ipi.ideas_for_you": "Idées pour vous",
  "ipi.generate_ideas": "Générer des idées",
  "ipi.generate_new_ideas": "Nouvelles idées",
  "ipi.choose_idea": "Utiliser le prompt",
  "ipi.ideas_generating": "Les idées pour vous sont en cours de génération",
  "ipi.ai_assistance": "Assistance IA",
  "ipi.enter_details": "Entrez les détails",
  "ipi.context_files": "Fichiers de contexte",
  "ipi.description_students": "Description pour les élèves",
  "ipi.description_teacher": "Description pour l'enseignant",
  "ipi.llm_instructions": "Description pour le chatbot",
  "ipi.loading": "Chargement",
  "feature_flags.title": "Feature Flags 🧪",
  "course.ai_instructions_description": "L'IA utilise ces informations pour adapter les matériaux à votre enseignement.",
  "course.additional_info_description": "par ex. si l'IA doit tutoyer ou vouvoyer les élèves, ainsi que des informations qui doivent être prises en compte pour chaque matériel",
  "course.display_question": "Comment le cours doit-il être affiché ?",
  "course.archive_description": "Supprimer le cours. Les matériaux seront conservés pour les années scolaires suivantes.",
  "course.archive_info": "Le cours ne sera plus affiché pour la planification. Les matériaux restent accessibles via l'élément de menu \"Cours supprimés\" dans la bibliothèque.",
  "course_list.loading": "Chargement de la liste des cours…",
  "course_list.error.load_failed": "Impossible de charger la liste des cours.",
  "course_list.error.reorder": "Impossible de réorganiser le cours.",
  "course_list.error.update_school_year": "Impossible de mettre à jour l'année scolaire.",
  "course_list.error.create_course": "Impossible de créer le cours.",
  "course_list.error.connect_course": "Impossible de lier le cours.",
  "course_list.error.hide_course": "Impossible de masquer le cours.",
  "course_list.error.failed_create_school_year": "Impossible de créer l'année scolaire.",
  "course_list.error.failed_update_school_year": "Impossible de mettre à jour l'année scolaire.",
  "course_list.error.school_year_overlap": "Cette année scolaire chevauche une année existante. Veuillez modifier les dates et enregistrer à nouveau.",
  "course_list.new_school_year": "Nouvelle année scolaire",
  "course_list.create_school_year": "Créer une année scolaire",
  "course_list.edit_school_year": "Modifier l'année scolaire",
  "course_list.delete_school_year": "Supprimer l'année scolaire",
  "course_list.delete_school_year.title": "Supprimer l'année scolaire",
  "course_list.delete_school_year.message": "Supprimer \"{{schoolYearName}}\" ?",
  "course_list.delete_school_year.success": "Année scolaire supprimée. \"{{schoolYearName}}\" a été supprimée.",
  "course_list.delete_school_year_blocked.info_title": "L'année scolaire contient des cours",
  "course_list.delete_school_year_blocked.info_message": "Supprime d'abord tous les cours de cette année scolaire. Ensuite, tu pourras supprimer l'année scolaire.",
  "course_list.hide_course": "Masquer le cours",
  "course_list.connect_course": "Lier le cours",
  "course_list.add_course": "Ajouter un cours",
  "course_list.without_school_year": "Sans année scolaire",
  "course_list.empty_school_year.title": "Aucun cours",
  "course_list.empty_school_year.description": "Il n'y a aucun cours pour cette année scolaire.",
  "course_list.empty.description": "Crée un cours pour commencer.",
  "course_list.connect_dialog.description": "Choisis le cours Teachino à lier avec ce cours externe.",
  "course_list.external_course": "Cours externe",
  "course_list.external_course_from": "depuis {{integrationName}}",
  "course_list.teachino_course": "Cours Teachino",
  "course_list.select_course": "Sélectionner un cours",
  "course_list.connect_existing": "Lier à un cours existant",
  "course_list.statistics.students": "élèves",
  "course_list.statistics.folders": "dossiers",
  "course_list.statistics.materials": "supports",
  "course_list.menu.open": "Ouvrir",
  "course_list.menu.edit_details": "Modifier les détails",
  "course_list.open_course_aria": "Ouvrir le cours",
  "course_list.school_year.description": "Choisis l'année scolaire à laquelle appartient ce cours.",
  "course_list.select_school_year": "Sélectionner une année scolaire",
  "course_list.school_year.start_date": "Date de début",
  "course_list.school_year.end_date": "Date de fin",
  "course_list.school_year.end_date_after_start": "La date de fin doit être postérieure à la date de début.",
  "course_list.school_year.name_placeholder": "p. ex. {{startYear}}/{{endYear}}",
  "course_list.school_year.course_count_zero": "{{number}} cours",
  "course_list.school_year.course_count_one": "{{number}} cours",
  "course_list.school_year.course_count_many": "{{number}} cours",
  "course_list.school_year.drag_blocked": "Les cours ne peuvent pas être glissés vers une autre année scolaire. Modifie l'année scolaire dans les paramètres du cours.",
  "course_list.school_year.change_hint": "Changer l'année scolaire supprime l'emploi du temps de ce cours.",
  "course_list.school_year.change_title": "Déplacer le cours vers {{schoolYear}} ?",
  "course_list.school_year.change_message": "L'emploi du temps de « {{courseName}} » sera supprimé : heures de cours, remplacements et heures supplémentaires, y compris chez les collègues qui planifient ce cours avec toi. Cette action est irréversible. Les supports, les thèmes, les notes et les élèves sont conservés.",
  "course_list.school_year.change_action": "Changer l'année scolaire",
  "material.visibility_hint": "Les élèves voient tous les supports qui ont été débloqués pour eux via l'icône de l'œil.",
  "material.version_history.title": "Historique des versions",
  "material.version_history.current": "Actuel",
  "material.version_history.current_version": "Version actuelle",
  "material.version_history.version": "Version",
  "material.version_history.reason.created": "Créé",
  "material.version_history.reason.created_with_ai": "Créé avec l'IA",
  "material.version_history.reason.saved_edit": "Modification enregistrée",
  "material.version_history.reason.ai_rework": "Retravail IA",
  "material.version_history.reason.restored": "Restauré",
  "material.version_history.reason.saved_version": "Version enregistrée",
  "material.version_history.by": "Par",
  "material.version_history.no_versions_available": "Aucune version disponible",
  "material.version_history.restore_selected_version": "Restaurer la version sélectionnée ?",
  "material.version_history.restore_description": "Le matériel actuel sera d'abord enregistré, puis cette version deviendra la nouvelle version actuelle.",
  "material.version_history.cancel_restore": "Annuler la restauration",
  "material.version_history.confirm_restore": "Confirmer la restauration",
  "material.version_history.restore_this_version": "Restaurer cette version",
  "material.version_history.failed_to_load": "Impossible de charger le contenu de la version",
  "material.version_history.restore_failed": "Restauration échouée",
  "generic.file": "Fichier",
  "generic.upload_file": "Charger le fichier",
  "generic.save_link": "Enregistrer le lien",
  "generic.enter_link": "Saisir le lien",
  "generic.copy_item": "Copier \"{{item}}\"",
  "chatbot.template.socratic_tutor.title": "Tuteur Socratique",
  "chatbot.template.socratic_tutor.description_teacher": "Accompagne les élèves dans leur travail avec le matériel.",
  "chatbot.template.socratic_tutor.description_student": "Pose des questions sur le matériel et reçois des explications et des conseils utiles.",
  "chatbot.template.socratic_tutor.prompt": "Tu es un tuteur socratique bienveillant et empathique pour les élèves.\nTu accompagnes les élèves à travers ce matériel et les soutiens dans leur compréhension. Parle dans un langage simple.\nLorsque les élèves demandent des solutions à un exercice, ne donne JAMAIS simplement la solution. Ne raconte ni ne résume jamais des sections entières du matériel. Guide plutôt les élèves à revenir au matériel (par ex. renvoie aux parties du matériel où se trouve la réponse, par ex. : \"Regarde M2\").",
  "chatbot.template.exam_coach.title": "Coach d'Examen",
  "chatbot.template.exam_coach.description_teacher": "Évalue les connaissances des élèves en préparation.",
  "chatbot.template.exam_coach.description_student": "Entraîne-toi avec l'aide de l'IA pour préparer tes tests, devoirs et examens, et fais-toi expliquer des sujets.",
  "chatbot.template.exam_coach.prompt": "Tu es un coach d'apprentissage pour les élèves et tu les aides à se préparer aux tests, devoirs, examens et autres épreuves. Explique les contenus de manière claire et par petites étapes.\nAide à structurer le contenu d'apprentissage et donne un retour motivant.\nNe fournis pas de solutions modèles complètes, mais accompagne les élèves vers la bonne démarche.",
  "chatbot.template.discussion.title": "Discussion",
  "chatbot.template.discussion.description_teacher": "Les élèves mènent une discussion pour et contre sur des sujets controversés tirés du matériel.",
  "chatbot.template.discussion.description_student": "Mène une discussion pour et contre sur un sujet controversé. L'IA prend la position adverse – convaincs-la avec des arguments solides !",
  "chatbot.template.discussion.prompt": "Mène une discussion pour et contre sur le sujet controversé \"{{topic}}\" tiré de ce matériel. Tu défends cette opinion : {{opinion}}. Prends la position opposée aux élèves et challenge-les à justifier leurs arguments de manière cohérente. Garde tes réponses courtes.",
  "chatbot.copy": "Copier",
  "chatbot.initial_message": "Bonjour",
  "chatbot.ai_disclaimer": "Vous discutez avec une IA. L'IA peut faire des erreurs. Ne saisissez aucune donnée personnelle.",
  "chatbot.template.persuasion_talk.title": "Défi de Persuasion",
  "chatbot.template.persuasion_talk.description_teacher": "Les élèves convainquent l'IA de leur opinion ou de leur projet.",
  "chatbot.template.persuasion_talk.description_student": "Convaincs l'IA de ton opinion",
  "chatbot.template.persuasion_talk.prompt": "Mène une discussion sur le sujet \"{{topic}}\" et apporte des contre-arguments. Ce n'est que lorsque l'élève aura réfuté de manière convaincante trois de tes arguments que tu lui donneras raison.",
  "chatbot.template.chat_with_person.title": "Chat avec une Personne",
  "chatbot.template.chat_with_person.description_teacher": "Les élèves mènent une conversation avec un personnage choisi.",
  "chatbot.template.chat_with_person.description_student": "Chatte avec \"{{person}}\" pour en savoir plus sur un sujet et pose des questions ciblées.",
  "chatbot.template.chat_with_person.prompt": "Tu incarnes le rôle de : {{person}}.\nL'élève souhaite te parler du sujet suivant : {{topic}}.\n\nParle d'une manière adaptée à ton personnage et à ton époque. Sois bref.\n\nReste toujours complètement dans ton rôle. Ne quitte jamais ce rôle.\n\nConduis un dialogue naturel. Ne pose pas une question en retour après chaque réponse.\nSi l'élève aborde un autre sujet, ramène doucement la conversation au thème.\n\nNe pose pas de questions sur les informations personnelles de l'élève.\nSi quelque chose ne correspond pas à ton personnage ou à ton époque, dis-le honnêtement depuis ton rôle.\n\nCommence le chat en te présentant brièvement.",
  "chatbot.template.vocabulary_trainer.title": "Entraînement au Vocabulaire",
  "chatbot.template.vocabulary_trainer.description_teacher": "Fais pratiquer le vocabulaire actuel à tes élèves.",
  "chatbot.template.vocabulary_trainer.description_student": "Entraîne-toi avec le vocabulaire grâce à l'IA en traduisant les mots ou en formant des phrases. L'IA te soumet les mots.",
  "chatbot.template.vocabulary_trainer.prompt": "Tu es un entraîneur de vocabulaire pour les élèves.\nEntraîne du vocabulaire avec l'élève.\nChoisis le vocabulaire dans un ordre aléatoire.\n\nVarie la façon dont tu interroges :\n– parfois l'apprenant doit traduire\n– parfois il doit former une phrase exemple avec le mot.\n\nNe pose toujours qu'un seul mot à la fois.\nSois très attentif à l'orthographe et à la grammaire.\nDonne un retour, mais ne donne jamais simplement la réponse.\nÀ la fin, répète tous les mots qui n'ont pas encore été maîtrisés avec assurance.\nNe termine l'entraînement que lorsque tous les mots ont été répondus correctement.\nDis au revoir à la fin avec des félicitations.\nUtilise le vocabulaire du matériel.",
  "chatbot.template.grammar_trainer.title": "Entraînement à la Grammaire",
  "chatbot.template.grammar_trainer.description_teacher": "Les élèves s'entraînent de manière ciblée à la grammaire.",
  "chatbot.template.grammar_trainer.description_student": "Entraîne-toi à la grammaire avec l'aide de l'IA en transformant des phrases dans le temps requis. L'IA te donnera un retour.",
  "chatbot.template.grammar_trainer.prompt": "Tu es un entraîneur de grammaire patient mais très précis pour les apprenants.\nEntraîne l'élève sur le sujet suivant : {{topic}}.\nDonne toujours une seule tâche à la fois.\nAprès chaque réponse, donne un retour, mais ne donne JAMAIS simplement la solution.\nNe laisse passer aucune erreur.\nAugmente la difficulté lorsque plusieurs tâches ont été résolues correctement.\n\nExemple de déroulement :\n\"Change the following sentence from the Simple Present into the Simple Past: 'She walks to school.'\"\nAttends la réponse puis donne un retour.",
  "chatbot.template.conversation_simulation.title": "Simulation de Conversation",
  "chatbot.template.conversation_simulation.description_teacher": "Les élèves s'entraînent dans une situation de conversation réaliste.",
  "chatbot.template.conversation_simulation.description_student": "Entraîne-toi dans cette simulation avec l'IA pour ce type de conversation : \"{{conversation}}\". Prépare-toi ainsi pour une vraie conversation.",
  "chatbot.template.conversation_simulation.prompt": "Tu es \"{{person}}\" et tu mènes le type de conversation suivant : \"{{conversation}}\".\nPose des questions ciblées.\nSi le type de conversation poursuit un objectif, comme un entretien d'embauche, donne un retour à la fin de la conversation en fonction de ta satisfaction (par ex. féliciter pour le poste ou donner un retour constructif).",
  "chatbot.mock_answer": "Réponse fictive : Merci pour ton message. C'est ici que l'IA répondrait.",
  "chatbot.create": "Chatbot",
  "chatbot.create_custom": "Créer un chatbot personnalisé",
  "chatbot.edit_settings": "Modifier les paramètres",
  "chatbot.start_new_chat": "Redémarrer la conversation",
  "chatbot.ready_to_chat": "Prêt à discuter",
  "chatbot.history.conversation": "Conversation",
  "chatbot.history.one_message": "1 message",
  "chatbot.history.many_messages": "{{count}} messages",
  "chatbot.messages_count": "Messages : {{count}}",
  "chatbot.column_type.chatbot": "Chatbot",
  "chatbot.column_type.question": "Question",
  "chatbot.apply_template": "Appliquer le modèle",
  "chatbot.template.discussion.configure": "Configurer la discussion",
  "chatbot.template.discussion.topic_label": "Sujet controversé",
  "chatbot.template.discussion.topic_description": "Le sujet que l'IA discute avec les élèves.",
  "chatbot.template.discussion.topic_placeholder": "p. ex. Les réseaux sociaux à l'école",
  "chatbot.template.discussion.opinion_label": "Opinion de l'IA",
  "chatbot.template.discussion.opinion_description": "La position que l'IA adopte dans la discussion.",
  "chatbot.template.discussion.opinion_placeholder": "p. ex. Les réseaux sociaux devraient être interdits à l'école",
  "chatbot.template.persuasion_talk.configure": "Configurer le défi de persuasion",
  "chatbot.template.persuasion_talk.topic_label": "Sujet",
  "chatbot.template.persuasion_talk.topic_description": "Le sujet dont l'IA doit être convaincue.",
  "chatbot.template.persuasion_talk.topic_placeholder": "p. ex. Les devoirs devraient être supprimés",
  "chatbot.template.conversation_simulation.configure": "Configurer la simulation de conversation",
  "chatbot.template.conversation_simulation.person_label": "Rôle de l'IA",
  "chatbot.template.conversation_simulation.person_description": "La personne ou le rôle que l'IA joue dans la simulation.",
  "chatbot.template.conversation_simulation.person_placeholder": "p. ex. Responsable RH",
  "chatbot.template.conversation_simulation.conversation_label": "Type de conversation",
  "chatbot.template.conversation_simulation.conversation_description": "Le type de conversation que les élèves doivent pratiquer.",
  "chatbot.template.conversation_simulation.conversation_placeholder": "p. ex. Entretien d'embauche",
  "chatbot.template.chat_with_person.configure": "Configurer le chat avec une personne",
  "chatbot.template.chat_with_person.person_label": "Personne",
  "chatbot.template.chat_with_person.person_description": "La personne ou le personnage dont l'IA prend le rôle.",
  "chatbot.template.chat_with_person.person_placeholder": "p. ex. Albert Einstein",
  "chatbot.template.chat_with_person.topic_label": "Sujet de conversation",
  "chatbot.template.chat_with_person.topic_description": "Le sujet dont les élèves parlent avec la personne.",
  "chatbot.template.chat_with_person.topic_placeholder": "p. ex. La théorie de la relativité",
  "chatbot.template.grammar_trainer.configure": "Configurer l'entraînement grammatical",
  "chatbot.template.grammar_trainer.topic_label": "Sujet de grammaire",
  "chatbot.template.grammar_trainer.topic_description": "Le sujet grammatical que les élèves doivent pratiquer.",
  "chatbot.template.grammar_trainer.topic_placeholder": "p. ex. Simple Past",
  "material.block_menu.file_upload": "Dépôt de fichier",
  "material.editor.file_upload.badge": "Dépôt de fichier",
  "material.editor.file_upload.question_placeholder": "Saisis la consigne ici, p. ex. « Téléverse une photo de ta solution. »",
  "material.editor.file_upload.no_question": "Aucune consigne",
  "material.editor.file_upload.settings.allow_file": "Téléverser un fichier",
  "material.editor.file_upload.settings.allow_audio": "Enregistrer un audio",
  "material.editor.file_upload.settings.allow_camera": "Caméra (photo/vidéo)",
  "material.editor.file_upload.settings.allow_link": "Lien",
  "material.editor.file_upload.settings.answer_type": "Type de réponse",
  "material.editor.file_upload.settings.max_files_hint": "Tu peux téléverser au maximum {{count}} fichiers.",
  "material.editor.file_upload.student_action.file": "Téléverser un fichier",
  "material.editor.file_upload.student_action.audio": "Enregistrer un audio",
  "material.editor.file_upload.student_action.camera": "Prendre une photo ou une vidéo",
  "material.editor.file_upload.student_action.link": "Ajouter un lien",
  "material.editor.file_upload.drop_here": "Dépose les fichiers ici",
  "material.editor.file_upload.record_again": "Réenregistrer",
  "material.editor.file_upload.already_submitted": "Le fichier a été envoyé à ton enseignant.",
  "material.editor.file_upload.already_submitted_many": "Les fichiers ont été envoyés à ton enseignant.",
  "material.editor.file_upload.new_try": "Nouvel essai",
  "material.editor.file_upload.record_audio": "Enregistrer un audio",
  "material.editor.file_upload.stop_recording": "Arrêter l'enregistrement",
  "material.editor.file_upload.take_photo": "Prendre une photo",
  "material.editor.file_upload.take_video": "Enregistrer une vidéo",
  "material.editor.file_upload.link_placeholder": "https://…",
  "material.editor.file_upload.link_invalid": "Saisis une URL valide.",
  "material.editor.file_upload.max_files_reached": "Nombre maximal de pièces jointes atteint ({{count}}).",
  "material.editor.file_upload.attachments_count": "{{count}} sur max. {{max}}",
  "material.editor.file_upload.upload_error": "Échec du téléversement.",
  "material.editor.file_upload.media_permission_denied": "Impossible d'accéder au micro ou à la caméra.",
  "material.editor.file_upload.submit": "Rendre",
  "material.editor.file_upload.discard_title": "Fermer sans rendre ?",
  "material.editor.file_upload.discard_message": "Tes fichiers et enregistrements non rendus seront perdus si tu fermes cette fenêtre.",
  "material.editor.file_upload.discard_confirm": "Abandonner",
  "material.editor.file_upload.discard_keep": "Continuer l'édition",
  "material.editor.file_upload.evaluation.version": "Version {{number}}",
  "material.editor.file_upload.evaluation.download": "Télécharger",
  "material.editor.file_upload.open": "Ouvrir",
  "evaluation.latest_conversation": "Dernière tentative",
  "evaluation.latest_attempt": "Dernière tentative",
  "evaluation.attempt_of_total": "Tentative {{current}} sur {{total}}",
  "evaluation.conversation_of_total": "Conversation {{current}} sur {{total}}",
  "evaluation.previous_conversation": "Tentative précédente",
  "evaluation.previous_attempt": "Tentative précédente",
  "evaluation.next_conversation": "Tentative suivante",
  "evaluation.next_attempt": "Tentative suivante",
  "evaluation.feedback": "Commentaire",
  "evaluation.feedback_placeholder": "Saisissez ou dictez ici votre commentaire pour {{name}}.",
  "evaluation.save_feedback": "Enregistrer le commentaire",
  "evaluation.clear_feedback": "Effacer le commentaire",
  "evaluation.dashboard.give_feedback": "Ajouter un commentaire",
  "evaluation.dashboard.show_feedback": "Afficher le commentaire",
  "evaluation.dashboard.next_update_in": "Prochaine mise à jour dans",
  "evaluation.dashboard.reload_now": "Recharger maintenant",
  "evaluation.dashboard.legend.submitted": "Rendu",
  "evaluation.overview.edit_schedule": "Modifier les paramètres de partage",
  "evaluation.overview.reuse_last_schedule": "Réutiliser le dernier réglage",
  "evaluation.overview.schedule_save_failed": "Impossible d’enregistrer les paramètres de partage.",
  "evaluation.overview.make_visible": "Rendre visible",
  "evaluation.overview.set_visible_date": "Définir la date de visibilité",
  "evaluation.overview.set_due_date": "Définir la date limite",
  "evaluation.overview.reuse_last_schedule_with_dates": "Visible à partir du : {{from}} · Modifiable jusqu’au : {{until}}",
  "evaluation.overview.edit_visibility_all": "Modifier le partage pour tous",
  "evaluation.overview.hide_material_all": "Masquer pour tous",
  "evaluation.overview.visibility_all_description": "Les dates communes s’appliquent aux élèves sans paramètres individuels.",
  "evaluation.overview.title": "Progression des élèves",
  "evaluation.overview.subtitle": "Progression des élèves à travers les matériels du cours",
  "evaluation.onboarding.empty_title": "Pas encore d’élèves dans ce cours",
  "evaluation.onboarding.empty_description": "Ajoutez des élèves pour mettre ici des supports à la disposition de chaque élève et suivre leur progression en temps réel. Les données d’exemple disparaissent alors.",
  "evaluation.onboarding.empty_description_readonly": "Dès que des élèves sont dans le cours, vous suivez ici leur progression en temps réel.",
  "evaluation.onboarding.sample_material_1": "Quiz d’entrée",
  "evaluation.onboarding.sample_material_2": "Fiche d’exercices",
  "evaluation.onboarding.sample_material_3": "Révision",
  "evaluation.onboarding.sample_material_4": "Vidéo",
  "evaluation.onboarding.sample_material_5": "Texte à trous",
  "evaluation.onboarding.sample_material_6": "Mini-test",
  "evaluation.onboarding.sample_material_7": "Texte de lecture",
  "evaluation.onboarding.sample_material_8": "Associations",
  "evaluation.onboarding.sample_material_9": "Devoirs",
  "evaluation.onboarding.sample_material_10": "Énigme",
  "evaluation.onboarding.sample_material_11": "Projet",
  "evaluation.onboarding.sample_material_12": "Auto-évaluation",
  "evaluation.onboarding.sample_material_13": "Carte mentale",
  "evaluation.onboarding.sample_material_14": "Test final",
  "evaluation.overview.no_materials": "Ce cours ne contient pas encore de matériel.",
  "evaluation.overview.no_materials_in_folder": "Ce dossier ne contient pas de matériel.",
  "evaluation.overview.no_materials_matching_filter": "Aucun matériel ne correspond à ce filtre.",
  "evaluation.overview.load_error": "Impossible de charger la progression des élèves.",
  "evaluation.overview.all_folders": "Tous les dossiers",
  "evaluation.overview.unsorted_folder": "Non trié",
  "evaluation.overview.filter_interactive": "Avec tâches interactives",
  "evaluation.overview.filter_shared": "Partagé avec les élèves",
  "evaluation.overview.legend.hidden": "Masqué pour l'élève",
  "evaluation.overview.legend.hidden_with_submissions": "Masqué, mais des réponses existent",
  "evaluation.overview.legend.time_since_last_answer": "Temps depuis la dernière réponse",
  "evaluation.overview.legend.time_example": "20 min",
  "evaluation.overview.live_now": "Maintenant",
  "evaluation.overview.live_tooltip": "Actif sur ce matériel au cours des trois dernières minutes",
  "evaluation.overview.last_answer": "Dernière réponse",
  "evaluation.overview.needs_help_tooltip": "A besoin d'aide : au moins trois réponses incorrectes ou partiellement correctes d'affilée",
  "evaluation.overview.show_material": "Afficher le matériel pour l'élève",
  "evaluation.overview.hide_material": "Masquer le matériel pour l'élève",
  "evaluation.overview.open_feedback": "Ouvrir le commentaire pour ce matériel",
  "evaluation.overview.feedback_given": "Commentaire ou note ajoutés pour ce matériel",
  "evaluation.overview.new_answers": "Nouvelles réponses depuis le dernier commentaire",
  "evaluation.overview.non_interactive_material": "Ce matériel ne contient pas de tâches interactives",
  "teacher_feedback.label": "Commentaire de l'enseignant",
  "teacher_feedback.show_more": "Afficher plus",
  "teacher_feedback.show_less": "Afficher moins",
  "evaluation.mobile.show_feedback": "Afficher le commentaire",
  "evaluation.mobile.hide_feedback": "Masquer le commentaire",
  "evaluation.dialog.static_material_title": "Matériel statique",
  "evaluation.dialog.static_material_hint": "Ce matériel ne contient pas de tâches interactives, il n'y a donc pas de réponses ici. Tu peux tout de même ajouter une note ou une évaluation pour {{name}}.",
  "evaluation.dialog.not_submitted_yet": "{{name}} n'a pas encore traité cette tâche.",
  "evaluation.dialog.task_title": "Titre de la tâche",
  "evaluation.file_upload.submission": "Remise",
  "evaluation.file_upload.many_submissions": "Remises",
  "evaluation.file_upload.submissions_count": "Remises : {{count}}",
  "material_card.view_feedback": "Voir le commentaire",
  "grades.grade_column": "Évaluation",
  "grades.enable_grades": "Choisir un barème",
  "grades.notes_only": "Notes uniquement",
  "grades.note_for_student": "Note pour {{name}}",
  "grades.save_for_student_one": "Enregistrer pour {{count}} élève",
  "grades.save_for_student_many": "Enregistrer pour {{count}} élèves",
  "grades.quick_note_placeholder": "Note…",
  "grades.documentation_title_placeholder": "p. ex. Travail de groupe",
  "grades.tags_for_student": "Étiquettes pour {{name}}",
  "grades.worksheet_keyboard_hint": "Entrée : élève suivant · Maj + Entrée : nouvelle ligne",
  "grades.tag_for_student": "{{tag}} pour {{name}}",
  "grades.tag": "Étiquette",
  "grades.start_empty": "Commencer sans sélection",
  "grades.edit_documentation": "Modifier la documentation",
  "grades.tab_title": "Documentation",
  "grades.grade_categories": "Catégories d’évaluation",
  "grades.tags": "Étiquettes",
  "grades.student": "Élève",
  "grades.students": "Élèves",
  "grades.manage_students": "Gérer les élèves",
  "grades.filter": "Filtrer",
  "grades.reset_filters": "Réinitialiser",
  "grades.add_note": "Ajouter une note",
  "grades.add_grade": "Ajouter une évaluation",
  "grades.add_documentation": "Consigner une documentation",
  "grades.add_students_before_documentation": "Ajoutez d’abord des élèves pour consigner une documentation.",
  "grades.add_entries": "Ajouter les entrées",
  "grades.delete_documentation_confirm": "Voulez-vous vraiment supprimer cette documentation ? Cette action est irréversible.",
  "grades.discard_note_title": "Fermer sans enregistrer ?",
  "grades.discard_note_message": "Vos modifications non enregistrées seront perdues.",
  "grades.discard_note_confirm": "Abandonner",
  "grades.discard_note_keep": "Continuer la modification",
  "grades.edit_grade": "Modifier la note",
  "grades.edit_note": "Modifier la note",
  "grades.overview_settings": "Configurer l’affichage",
  "grades.overview_subtitle": "Évaluations et documentation des élèves en un coup d’œil",
  "grades.overview_settings_description": "Choisissez les catégories, moyennes et étiquettes affichées dans l’aperçu. Faites glisser les éléments pour modifier leur ordre.",
  "grades.shown_in_overview": "Afficher dans l’aperçu",
  "grades.date": "Date",
  "grades.entry_date": "Date de l’entrée",
  "grades.title_placeholder": "Ajouter un titre…",
  "grades.bulk_title_placeholder": "Ajouter un titre pour toutes les évaluations…",
  "grades.grade_category": "Catégorie d’évaluation",
  "grades.choose_grade_category": "Choisir une catégorie d’évaluation",
  "grades.change_grade_category": "Changer de catégorie d’évaluation",
  "grades.choose_grade_category_hint": "Choisissez une catégorie d’évaluation pour continuer.",
  "grades.grade": "Évaluation",
  "grades.choose_grade": "Choisir une évaluation",
  "grades.note": "Note",
  "grades.observations": "Notes",
  "grades.note_placeholder": "Ajouter une note…",
  "grades.grade_and_note": "Évaluation et note",
  "grades.documentation": "Documentation",
  "grades.grade_for_student": "Évaluation de {{name}}",
  "grades.no_matching_grades": "Aucune évaluation correspondante",
  "grades.no_students": "Dès que vous aurez ajouté des élèves à ce cours, vous pourrez saisir ici des évaluations et de la documentation.",
  "grades.no_students_title": "Aucun élève disponible",
  "grades.no_students_course_settings": "Ajoutez des élèves dans les paramètres du cours pour saisir des évaluations et des notes.",
  "grades.add_documentation_archived": "Ce cours a été supprimé. Il n’est plus possible de consigner de la documentation.",
  "grades.onboarding.empty_title": "Pas encore d’élèves dans ce cours",
  "grades.onboarding.empty_description": "Ajoutez des élèves pour saisir des évaluations et des notes. Les données d’exemple disparaissent alors et « Consigner une documentation » devient actif.",
  "grades.onboarding.empty_description_readonly": "Dès que des élèves sont dans le cours, leurs évaluations et notes apparaissent ici.",
  "grades.onboarding.settings_hint": "Sous {{settings}}, vous pouvez adapter les catégories d’évaluation, les moyennes et les étiquettes.",
  "grades.onboarding.settings_hint_no_categories": "Ce cours n’a pas encore de catégories d’évaluation. Créez-les sous {{settings}}.",
  "grades.onboarding.sample_category_mark": "Devoir surveillé",
  "grades.onboarding.sample_category_participation": "Participation",
  "grades.onboarding.sample_tag_homework": "Devoirs non faits",
  "grades.onboarding.sample_tag_positive": "Contribution positive",
  "grades.saved_grade_title": "Évaluation enregistrée",
  "grades.saved_note_title": "Note enregistrée",
  "grades.saved_entries_one": "Entrée créée pour {{count}} élève",
  "grades.saved_entries_many": "Entrées créées pour {{count}} élèves",
  "grades.load_error": "Impossible de charger les notes.",
  "grades.move_up": "Déplacer vers le haut",
  "grades.move_down": "Déplacer vers le bas",
  "grades.new_grade_category": "Nouvelle catégorie d’évaluation",
  "grades.grade_category_name_required": "Saisissez un nom pour la catégorie d’évaluation.",
  "grades.grade_visualization": "Affichage de l’évaluation",
  "grades.no_grade_categories": "Aucune catégorie d’évaluation pour le moment.",
  "grades.import_grading_structure": "Reprendre catégories, moyennes et tags d’un autre cours",
  "grades.import_grading_structure_description": "Choisissez le cours dont vous reprenez les catégories, moyennes et tags.",
  "grades.import_grading_structure_select_course": "Cours",
  "grades.import_grading_structure_confirm": "Appliquer",
  "grades.import_grading_structure_success": "Catégories, moyennes et tags appliqués.",
  "grades.import_grading_structure_no_other_courses": "Vous n’avez aucun autre cours depuis lequel importer.",
  "grades.import_grading_structure_list_categories_one": "{{count}} catégorie",
  "grades.import_grading_structure_list_categories_other": "{{count}} catégories",
  "grades.import_grading_structure_list_averages_one": "{{count}} moyenne",
  "grades.import_grading_structure_list_averages_other": "{{count}} moyennes",
  "grades.import_grading_structure_list_tags_one": "{{count}} tag",
  "grades.import_grading_structure_list_tags_other": "{{count}} tags",
  "grades.import_grading_structure_list_failed": "Non chargé",
  "grades.import_grading_structure_warning": "Les notes déjà saisies dans « {{courseName}} » seront perdues.",
  "grades.average": "Moyenne",
  "grades.averages": "Moyennes",
  "grades.new_average": "Nouvelle moyenne",
  "grades.no_averages": "Aucune moyenne configurée.",
  "grades.category_average": "Moyenne de la catégorie",
  "grades.export_csv.grade_column": "{{category}} ({{index}})",
  "grades.export_csv.category_average_column": "{{category}} ({{averageSymbol}})",
  "grades.export_csv.duplicate_column": "{{name}} ({{index}})",
  "grades.class_average": "Moyenne de la classe",
  "grades.timeframe": "Période",
  "grades.whole_school_year": "Toute l’année scolaire",
  "grades.custom_timeframe": "Plage de dates personnalisée",
  "grades.weighting": "Pondération",
  "grades.equal_weighting": "Pondération égale",
  "grades.custom_weighting": "Pondération personnalisée",
  "grades.total_weight": "Pondération totale",
  "grades.total_weight_validation": "La pondération totale doit être égale à 100 % pour pouvoir enregistrer.",
  "grades.category_weight_validation": "Chaque catégorie sélectionnée doit avoir une pondération supérieure à 0 %.",
  "grades.distribute_equally": "Répartir également",
  "grades.grade_invalid_level_removed": "Cette note ne correspond plus à un niveau du barème actuel. Le niveau a peut‑être été supprimé ou modifié.",
  "grades.grade_invalid_scheme_changed": "Cette note utilise un ancien barème de la catégorie. Choisissez une note à nouveau.",
  "grades.grade_invalid_scheme_unavailable": "Le barème de cette note n’est plus disponible. Ouvrez l’entrée et choisissez une note à nouveau.",
  "grades.new_tag": "Nouvelle étiquette",
  "grades.tag_color": "Couleur de l’étiquette",
  "grades.grading_scheme_group": "Groupe de barème",
  "grades.grading_scheme_group_generic": "Types génériques",
  "grades.grading_scheme_group_other": "Autre",
  "grades.grading_scheme_name_thumbs_three_level": "Pouces",
  "grades.grading_scheme_name_not_fulfilled_fulfilled": "Non atteint / atteint",
  "grades.grading_scheme_name_one_to_five_detailed": "1–5 détaillé",
  "grades.grading_scheme_name_one_to_ten_detailed": "1–10 détaillé",
  "grades.grading_scheme_name_us": "Notes par lettres (USA)",
  "grades.grading_scheme_name_plant_growth": "Fleur des compétences",
  "grades.import_grading_structure_unavailable_schemes": "Ce cours utilise des barèmes indisponibles ici : {{schemeNames}}. Choisis un autre cours ou remplace ces barèmes dans le cours d’origine.",
  "grades.add_grading_scheme": "Nouveau barème",
  "grades.edit_grading_scheme": "Modifier le barème",
  "grades.delete_grading_scheme_title": "Supprimer le barème ?",
  "grades.delete_grading_scheme_message": "Supprimer « {{name}} » ? Les notes existantes conservent leurs valeurs ; le barème n’apparaîtra plus dans la liste.",
  "grades.custom_scheme_name_required": "Saisissez un nom pour le barème.",
  "grades.custom_scheme_name_too_long": "Le nom du barème peut comporter au maximum {{maxLength}} caractères.",
  "grades.custom_scheme_label_mode": "Libellés des niveaux",
  "grades.custom_scheme_label_text": "Texte",
  "grades.custom_scheme_label_emoji": "Emoji",
  "grades.custom_scheme_supports_average": "Compte dans le calcul de la moyenne",
  "grades.custom_scheme_label_too_long": "Le libellé d’un niveau peut comporter au maximum {{maxLength}} caractères.",
  "grades.custom_scheme_levels": "Niveaux",
  "grades.custom_scheme_level_label": "Libellé",
  "grades.custom_scheme_default_level_low": "Faible",
  "grades.custom_scheme_default_level_mid": "Moyen",
  "grades.custom_scheme_default_level_high": "Bon",
  "grades.custom_scheme_level_value": "Valeur",
  "grades.custom_scheme_level_grade_value": "Valeur de la note",
  "grades.custom_scheme_add_level": "Ajouter un niveau",
  "grades.custom_scheme_duplicate_label": "Chaque niveau doit avoir un libellé unique.",
  "grades.custom_scheme_duplicate_emoji": "Chaque niveau doit avoir un emoji unique.",
  "grades.custom_scheme_duplicate_value": "Chaque valeur numérique doit être unique.",
  "grades.custom_scheme_label_required": "Saisissez un libellé pour chaque niveau.",
  "grades.custom_scheme_value_required": "Saisissez un nombre valide entre 0 et 100 pour chaque niveau.",
  "grades.no_tags": "Aucune étiquette pour le moment.",
  "grades.no_matching_documentation": "Aucune documentation ne correspond aux filtres sélectionnés.",
  "grades.no_documentation_yet": "Il n'y a pas encore de documentation pour cet(te) élève.",
  "grades.ai_generated_pending": "Créé par l'IA · En attente de validation",
  "grades.ai_generated_approved": "Créé par l'IA · Validé",
  "grades.approve_ai_entry": "Valider",
  "grades.documentation_count": "Entrées : {{count}}",
  "grades.export_student_csv": "Exporter toutes les entrées en CSV",
  "grades.select_tag_for_all_students": "Sélectionner « {{tag}} » pour tous les élèves",
  "grades.clear_tag_for_all_students": "Désélectionner « {{tag}} » pour tous les élèves",
  "grades.view_details": "Voir les détails",
  "grades.colors.grey": "Gris",
  "grades.colors.amber": "Ambre",
  "grades.colors.green": "Vert",
  "grades.colors.red": "Rouge",
  "grades.colors.blue": "Bleu",
  "grades.colors.violet": "Violet",
  "sample_preview.row_tag": "Exemple",
  "sample_preview.hide": "Masquer les données d’exemple",
  "sample_preview.show": "Afficher les données d’exemple",
  "sample_preview.student_1": "Anna Martin",
  "sample_preview.student_2": "Ben Bernard",
  "sample_preview.student_3": "Léa Dubois",
  "library.courses_empty_for_range": "Aucun cours pour cette période.",
  "timetable_edit.period_type_course_none": "Tu n'as pas encore de cours. Crée d'abord un cours.",
  "timetable_edit.period_type_course_none_for_date": "Aucun cours n'est actif ce jour-là. Choisis une autre date.",
  "timetable.empty_state_manual_title": "Créer manuellement",
  "timetable.empty_state_manual_description": "Crée et gère ton emploi du temps directement dans Teachino.",
  "timetable.empty_state_integration_title": "Connecter un emploi du temps existant",
  "timetable.empty_state_integration_description": "Synchronise tes cours avec le système d'emploi du temps de ton école.",
  "timetable.empty_state_integration_action": "Connecter l'emploi du temps",
  "timetable.empty_state_integration_dialog_title": "Connecter un emploi du temps existant",
  "timetable.no_lessons_in_week_title": "Pas de cours cette semaine",
  "timetable.no_lessons_in_week_description": "Ton emploi du temps est enregistré. Ton prochain cours est le {{date}}.",
  "timetable.no_lessons_in_week_none_upcoming": "Ton emploi du temps est enregistré, mais aucun autre cours n'est prévu.",
  "timetable.no_lessons_in_week_action": "Aller à cette semaine",
  "generic_print": "Imprimer",
  "timetable.breadcrumb.courses": "Cours",
  "timetable.tabs.vacations": "Ajouter les vacances",
  "timetable.tabs.timetables": "Créer les emplois du temps",
  "timetable.tabs.weeks": "Attribuer les semaines scolaires",
  "timetable.continue.timetables": "Continuer vers les emplois du temps",
  "timetable.continue.weeks": "Continuer vers l’attribution des semaines",
  "timetable.saving": "Enregistrement …",
  "timetable.external_integration.title": "Votre emploi du temps reste automatiquement à jour",
  "timetable.external_integration.description": "{{source}} gère votre emploi du temps. Il ne peut donc pas être modifié ici. Vous pouvez toujours associer les cours importés à vos cours Teachino ci-dessous.",
  "timetable.profile_prefill.title": "Ajoutez le pays et la région pour préremplir les vacances",
  "timetable.profile_prefill.description": "Ajoutez le lieu et le type de votre établissement dans les paramètres du profil pour préremplir les vacances scolaires officielles.",
  "timetable.profile_prefill.action": "Ajouter le pays et la région",
  "timetable.mode.title": "Comment votre emploi du temps évolue-t-il pendant l’année ?",
  "timetable.mode.description": "Choisissez la configuration adaptée à votre année scolaire. Vous pourrez toujours ajouter d’autres emplois du temps plus tard.",
  "timetable.mode.single_title": "Le même emploi du temps toute l’année",
  "timetable.mode.single_description": "Commencez avec un emploi du temps et utilisez-le pour chaque semaine de cours.",
  "timetable.mode.multiple_title": "Emplois du temps variables",
  "timetable.mode.multiple_description": "Commencez avec une semaine A et une semaine B, puis attribuez-les dans l’année scolaire.",
  "timetable.vacations.title": "Vacances scolaires",
  "timetable.vacations.description": "Les semaines de vacances seront ignorées lors de l’attribution des emplois du temps.",
  "timetable.vacations.add": "Ajouter des vacances",
  "timetable.vacations.edit": "Modifier les vacances",
  "timetable.vacations.remove": "Supprimer les vacances",
  "timetable.vacations.empty_title": "Aucune période de vacances ajoutée",
  "timetable.vacations.empty_description": "Ajoutez les vacances qui doivent être ignorées lors de l’attribution des emplois du temps.",
  "timetable.vacations.empty_action": "Ajouter les premières vacances",
  "timetable.vacations.dialog_add_title": "Ajouter des vacances",
  "timetable.vacations.dialog_edit_title": "Modifier les vacances",
  "timetable.vacations.start_date": "Date de début",
  "timetable.vacations.end_date": "Date de fin",
  "timetable.vacations.invalid_dates": "La date de fin doit être identique ou postérieure à la date de début.",
  "timetable.pattern.title": "Emplois du temps",
  "timetable.pattern.description": "Créez-les une fois et attribuez-les à n’importe quelle semaine.",
  "timetable.pattern.add": "Ajouter un emploi du temps",
  "timetable.pattern.new": "Nouvel emploi du temps",
  "timetable.pattern.week_a": "Semaine A",
  "timetable.pattern.week_b": "Semaine B",
  "timetable.pattern.new_numbered": "Nouvel emploi du temps {{number}}",
  "timetable.pattern.school_year_name": "Emploi du temps {{schoolYear}}",
  "timetable.pattern.copy": "Copie de {{name}}",
  "timetable.pattern.empty": "Emploi du temps vide",
  "timetable.pattern.lesson_count_one": "{{count}} unité de cours",
  "timetable.pattern.lesson_count_many": "{{count}} unités de cours",
  "timetable.pattern.name": "Nom de l’emploi du temps",
  "timetable.pattern.cell_hint": "Cliquez sur une cellule pour choisir ou modifier son cours.",
  "timetable.pattern.add_more": "Ajouter d’autres emplois du temps",
  "timetable.pattern.minimum_one": "Vous devez conserver au moins un emploi du temps",
  "timetable.pattern.duplicate": "Dupliquer",
  "timetable.pattern.period": "Créneau",
  "timetable.pattern.edit_periods": "Modifier les horaires de tous les créneaux",
  "timetable.pattern.choose_course": "Choisir un cours",
  "timetable.pattern.no_course": "Aucun cours",
  "timetable.pattern.empty_cells": "Une cellule vide signifie que vous n’avez aucun cours pendant ce créneau.",
  "timetable.periods.title": "Modifier la grille horaire",
  "timetable.periods.description": "Modifiez tous les horaires en une seule fois. Les emplois du temps concernés sont immédiatement mis à jour.",
  "timetable.periods.start": "Début",
  "timetable.periods.end": "Fin",
  "timetable.periods.invalid": "Chaque créneau doit se terminer après son heure de début.",
  "timetable.periods.save": "Enregistrer les horaires",
  "timetable.delete.title": "Supprimer l’emploi du temps ?",
  "timetable.delete.message": "Supprimer « {{name}} » ? Les semaines qui l’utilisent devront recevoir un nouvel emploi du temps.",
  "timetable.delete.planned_lessons_explainer": "Les cours déjà planifiés ne seront à nouveau disponibles qu’après l’ajout d’un nouvel emploi du temps pour la même période.",
  "timetable.delete.action": "Supprimer l’emploi du temps",
  "timetable.weeks.description": "Attribuez un emploi du temps réutilisable à chaque semaine de cours.",
  "timetable.weeks.calendar_week": "Sem.",
  "timetable.weeks.none_assigned": "Aucun emploi du temps attribué",
  "timetable.weeks.vacation": "Vacances",
  "timetable.weeks.vacation_starts_midweek": "commencent le {{date}}",
  "timetable.weeks.vacation_ends_midweek": "se terminent le {{date}}",
  "timetable.weeks.vacation_within_week": "commencent le {{startDate}} et se terminent le {{endDate}}",
  "timetable.weeks.needs_timetable": "Emploi du temps requis",
  "timetable.weeks.timetable_for_week": "Emploi du temps de la semaine",
  "timetable.weeks.choose": "Choisir un emploi du temps…",
  "timetable.weeks.apply_prompt": "Utiliser cet emploi du temps pour toutes les semaines de cours suivantes ? Les semaines de vacances seront ignorées.",
  "timetable.weeks.not_now": "Pas maintenant",
  "timetable.weeks.apply_every_second": "Appliquer une semaine sur deux",
  "timetable.weeks.apply_all_future": "Appliquer à toutes les semaines suivantes",
  "timetable.weeks.all_assigned": "Toutes les semaines sont attribuées",
  "timetable.weeks.needs_attention_one": "{{count}} semaine requiert votre attention",
  "timetable.weeks.needs_attention_many": "{{count}} semaines requièrent votre attention",
  "timetable.weekday.monday": "Lundi",
  "timetable.weekday.tuesday": "Mardi",
  "timetable.weekday.wednesday": "Mercredi",
  "timetable.weekday.thursday": "Jeudi",
  "timetable.weekday.friday": "Vendredi",
  "timetable.period.number": "{{number}}e créneau",
  "timetable.period.1": "1er créneau",
  "timetable.period.2": "2e créneau",
  "timetable.period.3": "3e créneau",
  "timetable.period.4": "4e créneau",
  "timetable.period.5": "5e créneau",
  "timetable.period.6": "6e créneau",
  "planning.title": "Planification",
  "planning.heading": "Planifier les cours",
  "planning.open_full_planning": "Ouvrir la planification complète",
  "planning.add_lesson_short": "Cours",
  "planning.add_additional_lesson": "Ajouter un cours supplémentaire",
  "planning.description": "Matériel, notes et tâches pour toutes les dates de cours.",
  "planning.read_only_description": "Matériel, notes et tâches enregistrés pour toutes les dates de cette année scolaire.",
  "planning.vacation": "Vacances",
  "planning.cancelled_lesson": "Annulé",
  "planning.no_scheduled_lesson": "Aucun cours prévu",
  "planning.period_tags": "Étiquettes des cours",
  "planning.other_teacher_lesson": "Cours assuré par {{teacher}}",
  "planning.shared_teacher_lesson": "Cours avec {{teacher}}",
  "planning.enlarge_note": "Agrandir la note",
  "planning.note_autosaved": "Les modifications sont enregistrées automatiquement.",
  "planning.class_register_needs_review": "Vérifier l’entrée du cahier de classe",
  "planning.class_register_needs_review_description": "Vérifiez l’entrée enregistrée et mettez-la à jour à partir de la planification actuelle si nécessaire.",
  "planning.update_class_register_from_plan": "Actualiser depuis la planification actuelle",
  "planning.notes": "Notes",
  "planning.materials": "Matériel",
  "planning.todos": "Tâches",
  "planning.note": "Note",
  "planning.material": "Matériel",
  "planning.todo": "Tâche",
  "planning.add_note": "Ajouter une note",
  "planning.add_material": "Ajouter du matériel",
  "planning.collection_material_planned": "Planifié",
  "planning.collection_material_exists.title": "Matériel déjà dans le cours",
  "planning.collection_material_exists.description": "« {{materialName}} » est déjà dans ce cours dans le dossier « {{folderName}} ». Souhaitez-vous planifier le matériel existant ou créer une autre copie et la planifier ?",
  "planning.collection_material_exists.intro": "Ce matériel est déjà dans votre cours.",
  "planning.collection_material_exists.choose_action": "Comment souhaitez-vous continuer ?",
  "planning.collection_material_exists.plan_existing": "Planifier l'existant",
  "planning.collection_material_exists.plan_existing_title": "Planifier l'existant",
  "planning.collection_material_exists.plan_existing_hint": "Ajouter le matériel du cours à cette séance sans le copier à nouveau.",
  "planning.collection_material_exists.copy_again": "Copier à nouveau et planifier",
  "planning.collection_material_exists.copy_again_title": "Créer une copie et planifier",
  "planning.collection_material_exists.copy_again_hint": "Ajouter une nouvelle copie au cours et la planifier pour cette séance.",
  "planning.import_folder_and_plan.button_short": "Copier le dossier et planifier",
  "planning.import_folder_and_plan.planned_success": "{{count}} supports ont été ajoutés à cette leçon.",
  "planning.import_folder_and_plan.none_planned": "Le dossier a été copié, mais aucun support n'a pu être ajouté à cette leçon.",
  "planning.import_folder_copy.success": "Dossier copié dans votre cours.",
  "planning.import_external_material.not_in_course_tag": "Pas dans le cours",
  "planning.import_external_material.title": "Matériel pas encore dans le cours",
  "planning.import_external_material.intro": "Ce matériel n’est pas encore dans votre cours. Choisissez comment l’ajouter avant de le planifier.",
  "planning.import_external_material.choose_action": "Comment souhaitez-vous continuer ?",
  "planning.import_external_material.copy_material_title": "Copier uniquement ce matériel",
  "planning.import_external_material.copy_material_hint": "Choisissez un dossier dans votre cours, puis planifiez ce matériel.",
  "planning.import_external_material.copy_folder_title": "Copier tout le dossier",
  "planning.import_external_material.copy_folder_hint": "Copiez « {{folderName}} » dans votre cours, puis planifiez ce matériel.",
  "planning.import_destination_folder.title": "Choisir le dossier de destination",
  "planning.import_destination_folder.intro": "Où copier « {{materialName}} » dans ce cours ?",
  "planning.import_destination_folder.existing_title": "Dossier existant",
  "planning.import_destination_folder.existing_hint": "Copier le support dans un dossier déjà présent dans ce cours.",
  "planning.import_destination_folder.new_title": "Nouveau dossier",
  "planning.import_destination_folder.new_hint": "Créer un nouveau dossier dans ce cours pour le support.",
  "planning.import_destination_folder.no_writable_folder": "Vous ne pouvez ajouter de supports à aucun dossier existant. Créez plutôt un nouveau dossier.",
  "planning.import_destination_folder.no_destination_available": "Vous ne pouvez pas copier de supports dans ce cours, car aucun dossier n’est disponible et vous ne pouvez pas en créer un.",
  "planning.import_destination_folder.confirm": "Continuer",
  "planning.import_destination_folder.back_to_existing": "Choisir un dossier existant",
  "planning.import_destination_folder.folder_created_success": "Le dossier « {{folderName}} » a été créé.",
  "planning.folder_exists.title": "Dossier déjà dans le cours",
  "planning.folder_exists.intro": "Ce dossier est déjà dans votre cours.",
  "planning.folder_exists.plan_existing_title": "Planifier le dossier existant",
  "planning.folder_exists.plan_existing_hint": "Ajouter les matériels du dossier existant à cette séance sans copier à nouveau.",
  "planning.folder_exists.copy_again_title": "Copier à nouveau le dossier et planifier",
  "planning.folder_exists.copy_again_hint": "Créer un autre dossier dans le cours et ajouter tous les matériels à cette séance.",
  "planning.folder_exists.copy_only_prompt": "Vous pouvez copier ce dossier à nouveau dans votre cours.",
  "planning.folder_exists.copy_again_title_copy_only": "Copier le dossier à nouveau",
  "planning.folder_exists.copy_again_hint_copy_only": "Créer une autre copie de ce dossier dans votre cours.",
  "planning.add_todo": "Ajouter une tâche …",
  "planning.add_event": "Ajouter un tag",
  "planning.choose_start_date": "Choisir la date de début",
  "planning.today": "Aujourd’hui",
  "planning.retry": "Réessayer",
  "planning.load_failed": "Impossible de charger la planification",
  "planning.course_load_failed": "Impossible de charger le cours",
  "planning.no_upcoming_lessons": "Aucun cours à venir",
  "planning.no_upcoming_lessons_description": "Il n’y a plus de cours durant cette année scolaire.",
  "planning.vacation_only_title": "Seules des vacances sont planifiées",
  "planning.vacation_only_description": "Ce cours n’a pas encore d’emploi du temps. Ajoutez-en un pour commencer à planifier les cours.",
  "planning.no_saved_content": "Aucun contenu de planification enregistré",
  "planning.no_saved_content_description": "Aucun matériel, aucune note ni aucune tâche n’est enregistré pour cette année scolaire.",
  "planning.move_material": "Déplacer le matériel",
  "planning.remove_material": "Retirer le matériel",
  "planning.remove_tag": "Retirer {{tag}}",
  "planning.shift": "Décaler la planification vers les cours suivants",
  "planning.shift_question": "Décaler la planification vers les cours suivants ?",
  "planning.shift_all": "Décaler la planification à partir d’ici vers les cours suivants",
  "planning.shift_success": "La planification a été décalée vers les cours suivants.",
  "planning.shift_failed": "Impossible de décaler la planification.",
  "planning.shift_no_next": "Il n’y a pas de prochain cours.",
  "planning.shift_blocked": "Il ne reste pas assez de dates de cours pour décaler {{content}}. Retirez ou déplacez d’abord ce contenu.",
  "planning.shift_description": "Tous les contenus sélectionnés à partir du {{date}} seront déplacés au cours suivant.",
  "planning.class_register": "Cahier de classe",
  "planning.current_period": "Maintenant : {{title}} de {{from}} à {{to}}",
  "planning.class_register_draft": "Brouillon du cahier",
  "planning.class_register_completed": "Cahier de classe envoyé",
  "planning.class_register_saved_locally": "Contenu du cours enregistré",
  "planning.saved": "Enregistré",
  "planning.not_saved": "Non enregistré",
  "planning.note_placeholder": "Saisir une note",
  "planning.delete": "Supprimer",
  "planning.toggle_todo": "Modifier l’état de la tâche",
  "planning.edit_todo": "Modifier la tâche",
  "planning.move_todo_date": "Déplacer à une autre date",
  "planning.close": "Fermer",
  "planning.cancel": "Annuler",
  "planning.material_load_failed": "Impossible de charger le matériel du cours.",
  "planning.manage_tags": "Gérer les tags",
  "planning.tag_name": "Nom du tag",
  "planning.create_tag": "Créer le tag",
  "planning.save_tag": "Enregistrer le tag",
  "planning.delete_tag": "Supprimer le tag",
  "planning.save_draft": "Enregistrer comme brouillon",
  "planning.send_class_register": "Envoyer au cahier de classe",
  "planning.copy_class_register": "Copier l’entrée",
  "planning.class_register_content": "Entrée du cahier de classe",
  "planning.documentation": "Documentation",
  "planning.student_documentation": "Documentation des élèves",
  "planning.previous": "Précédent",
  "planning.next": "Suivant",
  "planning.todos_for_date": "Tâches du {{date}}",
  "planning.move_note": "Déplacer la note",
  "planning.lesson": "Cours",
  "planning.open_add_material": "Ouvrir l’ajout de matériel",
  "planning.collapse_add_material": "Réduire l’ajout de matériel",
  "todo_more": "+{{count}} de plus",
  "generic_yes": "Oui",
  "generic_no": "Non",
  "dpa.eyebrow": "Accord de traitement des données",
  "dpa.title": "DPA pour votre établissement",
  "dpa.legal_explanation": "L’accord de traitement des données aide votre établissement à respecter ses obligations découlant du RGPD et de l’AI Act européen lors de l’utilisation de Teachino. Consultez nos informations sur la confidentialité pour plus de détails juridiques.",
  "dpa.download": "Télécharger le DPA actuel",
  "dpa.document.description": "Télécharger le DPA actuel au format PDF",
  "dpa.document.last_changed": "Dernière mise à jour",
  "dpa.privacy_link": "Informations sur la confidentialité",
  "dpa.privacy.description": "En savoir plus sur le traitement des données personnelles et l’IA chez Teachino",
  "dpa.privacy.info_label": "À titre informatif",
  "dpa.existing.question": "Un autre enseignant de votre établissement utilise-t-il déjà Teachino avec un DPA ?",
  "dpa.existing.explanation": "À l’étape suivante, vous pouvez signer le DPA ou le transmettre à la direction. Si votre établissement a déjà conclu un DPA avec Teachino, aucun nouvel accord n’est nécessaire. Indiquez les coordonnées de l’établissement et nous retrouverons le DPA existant.",
  "dpa.existing.answer_yes": "Oui, une autre personne l’utilise déjà",
  "dpa.existing.answer_no": "Non, je suis la première personne",
  "dpa.school.title": "Coordonnées de l’établissement",
  "dpa.school.name": "Nom de l’établissement",
  "dpa.school.address": "Adresse complète",
  "dpa.leadership.question": "Faites-vous partie de la direction de l’établissement ?",
  "dpa.no_cost": "La signature du DPA n’entraîne aucun coût pour l’établissement.",
  "dpa.direct.title": "Vérifier et signer le DPA",
  "dpa.signer.name": "Nom complet",
  "dpa.signer.email": "Adresse e-mail",
  "dpa.signer.email_help": "Nous enverrons un code de vérification à six chiffres à cette adresse. Utilisez votre adresse e-mail professionnelle.",
  "dpa.accept": "J’ai lu le DPA, je suis habilité à signer pour l’établissement et j’accepte l’accord.",
  "dpa.send_code": "Envoyer le code de vérification",
  "dpa.code.title": "Vérifier votre adresse e-mail",
  "dpa.code.help": "Nous avons envoyé un code à six chiffres par e-mail. Il est valable 30 minutes.",
  "dpa.code.label": "Code de vérification",
  "dpa.verify": "Signer le DPA",
  "dpa.resend": "Renvoyer le code",
  "dpa.handoff.title": "Transmettre à la direction",
  "dpa.handoff.help": "Le lien est valable 30 jours. Copiez le lien seul ou l’e-mail préparé complet.",
  "dpa.handoff.link_label": "Lien de signature",
  "dpa.handoff.email_label": "E-mail préparé",
  "dpa.copy_link": "Copier le lien",
  "dpa.copy_email": "Copier l’e-mail",
  "dpa.copied": "Copié",
  "dpa.review.title": "Demande envoyée",
  "dpa.review.before_submit_title": "Prochaine étape",
  "dpa.review.before_submit_help": "Lorsque vous envoyez la demande, l’équipe Teachino est informée. Nous vérifierons vos informations dès que possible et vous recontacterons.",
  "dpa.review.submit": "Envoyer la demande",
  "dpa.review.help": "Nous vérifierons si votre établissement dispose déjà d’un DPA et vous répondrons prochainement.",
  "dpa.signed.title": "DPA signé avec succès",
  "dpa.signed.help": "La fonctionnalité a été activée pour votre licence personnelle.",
  "dpa.continue": "Retourner à Teachino",
  "dpa.error.generic": "Une erreur s’est produite. Veuillez réessayer.",
  "dpa.error.invalid_code": "Le code est incorrect ou expiré. Vérifiez-le et réessayez.",
  "dpa.public.title": "Signer le DPA de Teachino",
  "dpa.public.review": "Vérifier l’établissement et l’accord",
  "dpa.public.signed": "Merci – le DPA a été signé",
  "dpa.public.signed_help": "L’enseignant demandeur a été informé et la fonctionnalité a été activée.",
  "dpa.public.invalid": "Ce lien n’est plus valide",
  "dpa.public.invalid_help": "Le lien a expiré, a déjà été utilisé ou a été remplacé par une demande plus récente. Contactez l’enseignant demandeur.",
  "dpa.trust.label": "Confidentialité et confiance",
  "dpa.trust.gdpr.title": "Cadre de protection des données",
  "dpa.trust.gdpr.description": "Le DPA documente le cadre de protection applicable au traitement des données personnelles.",
  "dpa.trust.eu.title": "Traitement des données dans l’UE",
  "dpa.trust.eu.description": "Le DPA décrit où les données personnelles sont traitées et quels sous-traitants interviennent.",
  "dpa.trust.encryption.title": "Chiffrement",
  "dpa.trust.encryption.description": "Des mesures techniques protègent les données pendant leur transmission et leur stockage.",
  "dpa.loading": "Chargement de l’accord…",
  "dpa.code.sent_to": "Nous avons envoyé le code à {{email}}.",
  "dpa.resend_in": "Renvoyer dans {{seconds}} s",
  "dpa.error.code_rejected": "Ce code n'est plus valable. Veuillez en demander un nouveau.",
  "material.student_visibility.continue_without_students": "Continuer sans élèves",
  "material.student_visibility.empty.title": "Aucun élève créé",
  "material.student_visibility.empty.create_students_description": "Créez les élèves pour votre cours « {{courseName}} » et distribuez leurs codes d’accès personnels.",
  "material.student_visibility.empty.without_students_description": "Autre possibilité : les élèves ouvrent le lien et saisissent eux-mêmes leur nom ou leurs initiales. Ils reçoivent un code pour y accéder à nouveau plus tard.",
  "material.student_visibility.empty.description": "Créez d’abord les élèves. Ils recevront un code personnel pour accéder aux contenus partagés, ainsi qu’à leurs réponses et travaux.",
  "material.unavailable.title": "Ce matériel n’est pas disponible",
  "material.unavailable.description": "Il a peut-être été supprimé ou vous n’avez pas l’autorisation d’y accéder.",
  "material.unavailable.action": "Accéder à mes cours",
  "ai.assistant.action.folders_created": "{{count}} dossiers créés",
  "material.student_visibility.no_students.title": "Aucun élève",
  "material.student_visibility.no_students.description": "Vous n’avez pas encore d’élèves dans ce cours. Créez des élèves ou activez le lien public.",
  "material.student_visibility.no_students.public_link_description": "Les élèves peuvent s’inscrire eux-mêmes grâce au lien.",
  "last_message": "Ceci est seulement ici, pour que toutes les lignes précédentes puissent avoir une, à la fin. De rien.",
  "ai.assistant.voice.starting": "En attente du microphone…",
  "ai.assistant.voice.detected": "Son détecté",
  "ai.assistant.voice.quiet": "Aucun son détecté – vérifie ton microphone",
  "ai.assistant.voice.ready": "Enregistrement terminé. Prêt à envoyer.",
  "ai.assistant.voice.change_microphone": "Changer de microphone (démarre un nouvel enregistrement)",
  "ai.assistant.voice.empty": "Aucune parole reconnue. Enregistre à nouveau ton message.",
  "material.assignment_open_question.edited_by_teacher": "Modifié par l’enseignant",
  "material.assignment_open_question.edit_feedback": "Modifier le feedback",
  "material.assignment_open_question.feedback_rating": "Emoji",
  "auth.two_factor.title": "Authentification à deux facteurs",
  "auth.two_factor.verify": "Vérifier",
  "auth.two_factor.challenge_description": "Saisissez le code à six chiffres de votre application d’authentification ou l’un de vos codes de récupération.",
  "auth.two_factor.code_label": "Code d’authentification",
  "auth.two_factor.invalid_or_expired": "Le code est invalide ou a expiré. Veuillez réessayer.",
  "auth.two_factor.locked_out": "Trop de codes incorrects. La vérification à deux facteurs est temporairement bloquée. Veuillez réessayer dans quelques minutes.",
  "auth.two_factor.setup_failed": "La configuration de l’authentification à deux facteurs n’a pas pu démarrer.",
  "auth.two_factor.invalid_code": "Le code d’authentification est invalide.",
  "auth.two_factor.enabled_description": "L’authentification à deux facteurs est activée pour ton compte.",
  "auth.two_factor.setup_description": "Ajoute une application d’authentification pour protéger ton compte avec une deuxième étape de connexion.",
  "auth.two_factor.scan_qr_description": "Scanne ce code QR avec ton application d’authentification ou saisis la clé secrète manuellement.",
  "auth.two_factor.six_digit_code": "Code à six chiffres",
  "auth.two_factor.enable": "Activer l’authentification à deux facteurs",
  "auth.two_factor.code_placeholder": "Code d’authentification ou de récupération",
  "auth.two_factor.regenerate_recovery_codes": "Générer de nouveaux codes de récupération",
  "auth.two_factor.disable": "Désactiver l’authentification à deux facteurs",
  "auth.two_factor.setup": "Configurer l’authentification à deux facteurs",
  "auth.two_factor.save_recovery_codes": "Enregistre ces codes de récupération maintenant. Ils ne seront plus affichés.",
  "auth.two_factor.download_recovery_codes": "Télécharger les codes de récupération",
  "course.add_content_menu.create_blank_material": "Créer du matériel vierge",
  "course.add_content_menu.create_link": "Créer un lien",
  "course.add_content_menu.upload_files": "Importer des fichiers",
  "course.create_link.url": "Lien",
  "course.create_link.placeholder": "https://exemple.fr",
  "course.add_content_menu.new": "Nouveau",
  "ai.assistant.image_choice.preview_unavailable": "Aperçu indisponible",
  "ai.assistant.image_choice.open_source": "Ouvrir la source",
  "ai.assistant.image_choice.select": "Sélectionner l’image",
  "ai.assistant.image_choice.selected": "Sélectionnée",
  "ai.assistant.image_choice.use_selected": "Utiliser les images sélectionnées ({{count}})",
  "ai.assistant.image_choice.request": "Je choisis ces images pour ma demande :\n{{images}}",
  "ai.assistant.student_note.pending": "En attente de validation",
  "ai.assistant.student_note.approved": "Validée",
  "ai.assistant.student_note.grade": "Note",
  "ai.assistant.student_note.created": "Générée par l’IA",
  "material.schedule.visible_from": "Visible à partir du",
  "material.schedule.editable_until": "Modifiable jusqu’au",
  "material.schedule.immediately": "Immédiatement",
  "material.schedule.no_deadline": "Sans date limite",
  "material.schedule.timezone": "Fuseau horaire : {timezone}",
  "material.schedule.lesson": "Choisir un cours",
  "material.schedule.individual": "Dates individuelles",
  "material.schedule.inherit": "Utiliser la date commune ({{date}})",
  "time_input.hours": "Heures",
  "time_input.minutes": "Minutes",
  "material.navigation_notice.title": "Nouvelle navigation dans le matériel",
  "material.navigation_notice.description": "Les actions du matériel se trouvent désormais en haut à droite dans la barre de navigation.",
  "material.navigation_notice.dismiss": "Ne plus afficher",
  "material.schedule.invalid_time": "Saisis une heure valide, par exemple 08:30.",
  "material.schedule.invalid": "La date limite doit être postérieure à la mise à disposition.",
  "material.schedule.hidden": "Masqué",
  "material.schedule.scheduled": "Planifié",
  "material.schedule.available": "Disponible",
  "material.schedule.expired": "Lecture seule : délai dépassé",
  "material.schedule.print_codes": "Imprimer les codes d’accès",
  "material.schedule.confirm": "Confirmer le partage",
  "material.schedule.change": "Modifier",
  "material.schedule.retry": "Réessayer",
  "material.schedule.retry_lessons": "Recharger les suggestions",
  "material.student_visibility.configure_individually": "Définir pour chaque élève",
  "material.student_visibility.confirm_release": "Rendre le matériel accessible",
  "material.student_visibility.confirm_revoke": "Retirer l’accès",
  "material.student_visibility.edit_settings": "Modifier",
  "material.student_visibility.editable_until": "Modifiable jusqu’au",
  "material.student_visibility.immediately": "Immédiatement",
  "material.student_visibility.invalid_dates": "La date limite de modification doit être égale ou postérieure à la date de visibilité.",
  "material.student_visibility.tooltip_different_dates": "Dates différentes selon les élèves",
  "material.student_visibility.tooltip_immediate_count": "{{count}} immédiatement",
  "material.student_visibility.tooltip_no_deadline_count": "{{count}} sans date limite",
  "material.student_visibility.tooltip_individual_one": "{{count}} date individuelle",
  "material.student_visibility.tooltip_individual_many": "{{count}} dates individuelles",
  "material.student_visibility.tooltip_all": "Tous les élèves",
  "material.student_visibility.tooltip_selected": "Tous les élèves sélectionnés",
  "material.student_visibility.tooltip_others": "Tous les autres élèves",
  "material.student_visibility.tooltip_other_selected": "Tous les autres élèves sélectionnés",
  "material.student_visibility.no_deadline": "Sans date limite",
  "material.student_visibility.no_upcoming_periods": "Aucun cours à venir",
  "material.student_visibility.other_period": "Saisir une date",
  "material.student_visibility.change_date": "Modifier la date",
  "material.student_visibility.periods_retry": "Recharger les cours",
  "material.student_visibility.release_all": "Rendre le matériel accessible à tous les élèves",
  "material.student_visibility.release_audience": "Accessible à {{visible}} élèves sur {{total}}",
  "material.student_visibility.release_complete": "Matériel accessible",
  "material.student_visibility.release_revoked": "Accès retiré",
  "material.student_visibility.release_scheduled": "Accès programmé",
  "material.student_visibility.release_student": "Rendre accessible à {{name}}",
  "material.student_visibility.release_summary": "Accessible à {{visible}} élèves sur {{total}}",
  "material.student_visibility.release_summary_scheduled": "Accès prévu pour {{visible}} élèves sur {{total}}",
  "material.student_visibility.qr_description": "Ce code QR mène directement au support.",
  "course.distribute_access": "Distribuer les accès",
  "material.student_visibility.share_title": "Distribuer",
  "material.student_visibility.release_title": "Accès au matériel",
  "material.student_visibility.retry": "Réessayer",
  "material.student_visibility.schedule_for_student": "Période pour {{name}}",
  "material.student_visibility.share_link_error": "Le lien du matériel n’a pas pu être chargé.",
  "material.student_visibility.visible_from": "Visible à partir du",
  "material.student_visibility.release_for_students": "Rendre accessible aux élèves",
  "material.preview.banner": "Aperçu · Voici comment vos élèves voient le matériel.",
  "material.preview.tooltip": "Aperçu du point de vue de vos élèves",
  "material.schedule.individual_releases": "Accès individuels",
  "material.student_visibility.share_tooltip": "Rendre le matériel accessible aux élèves",
  "material.student_visibility.distribute_tooltip": "Partager l’accès au matériel avec les élèves",
  "evaluation.overview.view_progress": "Consulter la progression des apprentissages",
  "material.print_tooltip": "Imprimer le matériel",
  "material.student_deadline.editable_until": "Modifiable jusqu’au {{date}}",
  "material.student_deadline.expired": "Délai de modification dépassé : {{date}} · Lecture seule",
  "material.student_visibility.saved_refresh_failed": "Les modifications ont été enregistrées, mais la vue du cours n’a pas pu être actualisée. Recharge la page.",
  "material.student_visibility.save_changes": "Enregistrer les modifications",
  "material.student_visibility.release_material": "Rendre le matériel accessible aux élèves",
  "material.student_deadline.access_check_failed": "Impossible de vérifier l’accès. Votre saisie est conservée. Veuillez réessayer.",
  "integration.authenticate.required_integration_title": "Connectez d’abord {{integration}}",
  "integration.authenticate.required_integration_description": "Connectez {{requiredIntegration}} à votre compte Teachino avant de connecter {{integration}}.",
  "integration.authenticate.required_integration_connect": "Se connecter avec {{integration}}",
  "integration.authenticate.required_integration_return": "Terminez la connexion et l’association de votre compte dans le nouvel onglet, puis revenez ici pour continuer. Si aucun onglet ne s’est ouvert, réessayez de vous connecter.",
  "integration.authenticate.required_integration_continue": "J’ai terminé la connexion — Continuer",
  "material.divider.label": "Section",
  "material.pages.position": "Page {{current}} sur {{total}}",
  "material.pages.progress": "Progression dans le support",
  "material.pages.navigation": "Pages du support",
  "material.pages.end": "Vous êtes à la dernière page.",
  "presentation.controls": "Commandes de présentation",
  "presentation.close": "Fermer la présentation",
  "presentation.lesson.overview": "Aperçu du cours",
  "presentation.settings.label": "Paramètres",
  "presentation.font.label": "Taille du texte",
  "presentation.font.normal": "Normale",
  "presentation.font.large": "Grande",
  "presentation.font.largest": "Très grande",
  "presentation.laser": "Pointeur laser",
  "presentation.dark_mode": "Mode sombre",
  "presentation.drawing.pen": "Stylo",
  "presentation.drawing.highlighter": "Surligneur",
  "presentation.drawing.controls": "Outils de dessin",
  "presentation.drawing.undo": "Annuler le dernier trait",
  "presentation.drawing.clear": "Effacer les dessins de cette page",
  "presentation.drawing.surface": "Surface de dessin",
  "presentation.tools.label": "Outils",
  "presentation.tools.clock": "Horloge",
  "presentation.tools.timer": "Minuteur",
  "presentation.tools.stopwatch": "Chronomètre",
  "presentation.tools.sound": "Niveau sonore",
  "presentation.tools.traffic": "Feu tricolore",
  "presentation.tools.work": "Modalité de travail",
  "presentation.tools.move": "Déplacer {{tool}} (glisser ou utiliser les flèches)",
  "presentation.tools.remove": "Retirer l’outil",
  "presentation.tools.remaining": "Temps restant",
  "presentation.tools.finished": "Le temps est écoulé",
  "presentation.tools.minutes": "Minutes",
  "presentation.tools.seconds": "Secondes",
  "presentation.tools.pause": "Pause",
  "presentation.tools.start": "Démarrer",
  "presentation.tools.reset": "Réinitialiser",
  "presentation.tools.alarm": "Signal sonore à la fin",
  "presentation.tools.sound.loud": "Un peu moins fort, s’il vous plaît",
  "presentation.tools.sound.ok": "Le niveau sonore est adapté",
  "presentation.tools.sound.requesting": "Autorisez l’accès au microphone pour mesurer le niveau sonore.",
  "presentation.tools.sound.denied": "L’accès au microphone a été refusé. Autorisez-le dans les paramètres du navigateur, puis réessayez.",
  "presentation.tools.sound.unavailable": "Aucun microphone disponible. Vérifiez votre appareil et réessayez.",
  "presentation.tools.sound.paused": "Microphone en pause",
  "presentation.tools.sound.sensitivity": "Sensibilité du microphone",
  "presentation.tools.sound.limit": "Niveau sonore maximal",
  "presentation.tools.sound.enable": "Activer le microphone",
  "presentation.tools.sound.local": "Mesure sur cet appareil. Aucun son n’est enregistré ni envoyé.",
  "presentation.tools.traffic.red": "Arrêter",
  "presentation.tools.traffic.amber": "Se préparer",
  "presentation.tools.traffic.green": "Commencer",
  "presentation.tools.work.silence": "Silence",
  "presentation.tools.work.whisper": "Chuchoter",
  "presentation.tools.work.group": "Travail en groupe",
  "presentation.tools.work.partner": "Demander à un partenaire",
  "presentation.drawing.color": "Couleur du trait",
  "presentation.drawing.color.red": "Rouge",
  "presentation.drawing.color.yellow": "Jaune",
  "presentation.drawing.color.green": "Vert",
  "presentation.drawing.color.blue": "Bleu",
  "presentation.drawing.color.purple": "Violet",
  "presentation.drawing.color.black": "Noir",
  "presentation.drawing.color.white": "Blanc",
  "presentation.drawing.width": "Épaisseur du trait",
  "presentation.drawing.width.thin": "Fin",
  "presentation.drawing.width.medium": "Moyen",
  "presentation.drawing.width.thick": "Épais",
  "presentation.break.start": "Masquer le support",
  "presentation.break.resume": "Afficher à nouveau le support",
  "presentation.pointer.label": "Curseur",
  "presentation.pointer.normal": "Curseur normal",
  "presentation.pointer.laser": "Pointeur laser",
  "presentation.pointer.spotlight": "Projecteur",
  "presentation.spotlight.circleSmall": "Cercle (petit)",
  "presentation.spotlight.content": "Scan",
  "presentation.spotlight.circleLarge": "Cercle (grand)",
  "presentation.scan.move": "Déplacer le scan (glisser ou utiliser les flèches)",
  "presentation.scan.resize": "Redimensionner le scan (glisser ou utiliser les flèches)",
  "presentation.scan.close": "Fermer le scan",
  "presentation.attention.label": "Signal d’attention",
  "presentation.attention.title": "Votre attention, s’il vous plaît",
  "presentation.attention.instruction": "Interrompez votre activité. Écoutez votre enseignant.",
  "presentation.sharing.open": "Code QR pour les élèves",
  "presentation.sharing.close": "Revenir à la présentation",
  "presentation.sharing.choose_course": "Pour quel cours ?",
  "presentation.sharing.no_course": "Ajoutez d’abord ce matériel à un cours pour le partager avec les élèves.",
  "presentation.sharing.edit": "Modifier le partage",
  "presentation.sharing.release": "Partager le document avec les élèves",
  "presentation.sharing.retry": "Réessayer",
  "presentation.attention.ring": "Faire sonner la cloche",
  "presentation.promotion.hint": "Le nouveau mode présentation est disponible.",
  "presentation.promotion.try": "Essayer",
  "presentation.promotion.dismiss": "Fermer le message",
  "material.student_display.title": "Affichage pour les élèves",
  "material.student_display.info": "Expliquer les modes d’affichage",
  "material.student_display.scroll": "Défilement",
  "material.student_display.sections": "Sections",
  "material.student_display.intro": "Voici comment les élèves peuvent parcourir le document.",
  "material.student_display.scroll_description": "Le document entier est affiché sur une seule page. Les élèves font défiler le contenu de haut en bas.",
  "material.student_display.sections_description": "Les élèves voient une section à la fois et utilisent Suivant et Retour pour passer d’une page à l’autre.",
  "material.student_display.section_title": "Qu’est-ce qu’une section ?",
  "material.student_display.section_description": "Les sections peuvent être ajoutées à l’aide du + dans le document. Les exercices interactifs constituent toujours une section distincte.",
  "material.student_display.image": "Image",
  "material.student_display.assignment": "Exercice interactif",
  "material.student_display.manual_section": "Section créée manuellement",
  "material.student_display.scroll_hint": "Tout sur une page · défiler vers le bas",
  "material.student_display.section_position": "Section {{current}} sur {{total}}",
  "material.student_summary.title": "Ta progression",
  "material.student_summary.success_title": "Tu as réussi !",
  "material.student_summary.success_description": "Tu as résolu toutes les activités correctement. Bravo — tu peux être fier de ce que tu as appris !",
  "material.student_summary.review_title": "Regarde le chemin parcouru",
  "material.student_summary.review_description": "Consulte tes résultats ci-dessous. Tu peux revenir à une activité pour la terminer ou réessayer. Les travaux rendus peuvent encore être en attente de retour.",
  "material.student_summary.no_activities": "Tu as atteint la fin de ce support. Prends un moment pour réfléchir à ce que tu as appris.",
  "material.student_summary.correct": "Correctes",
  "material.student_summary.remaining": "Pas encore validées",
  "material.student_summary.progress": "{{correct}} activités correctes sur {{total}}",
  "material.student_summary.activity": "Activité {{number}}",
  "material.student_summary.section": "Aller à la section {{number}}"
}
